//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class DirectoriesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    getDirectoryByName(parentUniqueId: string | null | undefined, directoryName: string | undefined, cancelToken?: CancelToken): Promise<FileModel> {
        let url_ = this.baseUrl + "/api/directories?";
        if (parentUniqueId !== undefined && parentUniqueId !== null)
            url_ += "parentUniqueId=" + encodeURIComponent("" + parentUniqueId) + "&";
        if (directoryName === null)
            throw new globalThis.Error("The parameter 'directoryName' cannot be null.");
        else if (directoryName !== undefined)
            url_ += "directoryName=" + encodeURIComponent("" + directoryName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDirectoryByName(_response);
        });
    }

    protected processGetDirectoryByName(response: AxiosResponse): Promise<FileModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileModel.fromJS(resultData200);
            return Promise.resolve<FileModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileModel>(null as any);
    }

    deleteDirectory(uniqueIdentifier: string, options: DirectoryDeletePostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/directory/{uniqueIdentifier}";
        if (uniqueIdentifier === undefined || uniqueIdentifier === null)
            throw new globalThis.Error("The parameter 'uniqueIdentifier' must be defined.");
        url_ = url_.replace("{uniqueIdentifier}", encodeURIComponent("" + uniqueIdentifier));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDirectory(_response);
        });
    }

    protected processDeleteDirectory(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AmeliaIntegrationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    appointmentBookingCompletedWebhook(model: AmeliaAppointmentBookingCompletePostModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/amelia-integrations/appointment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAppointmentBookingCompletedWebhook(_response);
        });
    }

    protected processAppointmentBookingCompletedWebhook(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    eventBookingCompletedWebhook(model: AmeliaEventBookingCompletePostModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/amelia-integrations/event";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEventBookingCompletedWebhook(_response);
        });
    }

    protected processEventBookingCompletedWebhook(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ContactsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    getMyContacts(showOrganizationMembersOnly: boolean | null | undefined, cancelToken?: CancelToken): Promise<ContactResponseModel[]> {
        let url_ = this.baseUrl + "/api/contacts?";
        if (showOrganizationMembersOnly !== undefined && showOrganizationMembersOnly !== null)
            url_ += "showOrganizationMembersOnly=" + encodeURIComponent("" + showOrganizationMembersOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyContacts(_response);
        });
    }

    protected processGetMyContacts(response: AxiosResponse): Promise<ContactResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactResponseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ContactResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContactResponseModel[]>(null as any);
    }

    addContact(model: CreateContactPostModel, cancelToken?: CancelToken): Promise<AddContactResponseModel> {
        let url_ = this.baseUrl + "/api/contacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddContact(_response);
        });
    }

    protected processAddContact(response: AxiosResponse): Promise<AddContactResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddContactResponseModel.fromJS(resultData200);
            return Promise.resolve<AddContactResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddContactResponseModel>(null as any);
    }

    getPendingInvites( cancelToken?: CancelToken): Promise<PendingInvitationResponseModel[]> {
        let url_ = this.baseUrl + "/api/contacts/pending-invites";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPendingInvites(_response);
        });
    }

    protected processGetPendingInvites(response: AxiosResponse): Promise<PendingInvitationResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PendingInvitationResponseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PendingInvitationResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PendingInvitationResponseModel[]>(null as any);
    }

    resendInvite(contactId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/contacts/{contactId}/resend-invite";
        if (contactId === undefined || contactId === null)
            throw new globalThis.Error("The parameter 'contactId' must be defined.");
        url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResendInvite(_response);
        });
    }

    protected processResendInvite(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    acceptInvite(model: AcceptInvitePostModel, cancelToken?: CancelToken): Promise<UserResponseModel> {
        let url_ = this.baseUrl + "/api/contacts/accept-invite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptInvite(_response);
        });
    }

    protected processAcceptInvite(response: AxiosResponse): Promise<UserResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserResponseModel.fromJS(resultData200);
            return Promise.resolve<UserResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserResponseModel>(null as any);
    }

    acceptPendingInvite(contactId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/contacts/pending-invites/{contactId}/accept";
        if (contactId === undefined || contactId === null)
            throw new globalThis.Error("The parameter 'contactId' must be defined.");
        url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptPendingInvite(_response);
        });
    }

    protected processAcceptPendingInvite(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DispatcherCallbackClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    onFileAnlysisSuccess(model: AnalysisCompletedCallbackModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/dispatcher-callback/file-analysis/success";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOnFileAnlysisSuccess(_response);
        });
    }

    protected processOnFileAnlysisSuccess(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    onFileAnlysisFail(model: AnalysisFailedCallbackModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/dispatcher-callback/file-analysis/fail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOnFileAnlysisFail(_response);
        });
    }

    protected processOnFileAnlysisFail(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class DownloadFilesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    submitRequestToDownloadFiles(model: DownloadFilesPostModel, cancelToken?: CancelToken): Promise<DownloadFilesResponseModel> {
        let url_ = this.baseUrl + "/api/download-files";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitRequestToDownloadFiles(_response);
        });
    }

    protected processSubmitRequestToDownloadFiles(response: AxiosResponse): Promise<DownloadFilesResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DownloadFilesResponseModel.fromJS(resultData200);
            return Promise.resolve<DownloadFilesResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DownloadFilesResponseModel>(null as any);
    }

    getZipFilesStatus(requestId: string, cancelToken?: CancelToken): Promise<DownloadFilesZipStatusResponse> {
        let url_ = this.baseUrl + "/api/download-files/zip-request-status/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new globalThis.Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetZipFilesStatus(_response);
        });
    }

    protected processGetZipFilesStatus(response: AxiosResponse): Promise<DownloadFilesZipStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DownloadFilesZipStatusResponse.fromJS(resultData200);
            return Promise.resolve<DownloadFilesZipStatusResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DownloadFilesZipStatusResponse>(null as any);
    }

    downloadZipFile(requestId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/download-files/download/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new globalThis.Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadZipFile(_response);
        });
    }

    protected processDownloadZipFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class DwsimProStartupActionsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    addStartupAction(model: CreateStartupActionPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/dwsim-pro-startup-actions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddStartupAction(_response);
        });
    }

    protected processAddStartupAction(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getLatestAction( cancelToken?: CancelToken): Promise<DwsimProActionResponseModel> {
        let url_ = this.baseUrl + "/api/dwsim-pro-startup-actions/latest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatestAction(_response);
        });
    }

    protected processGetLatestAction(response: AxiosResponse): Promise<DwsimProActionResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DwsimProActionResponseModel.fromJS(resultData200);
            return Promise.resolve<DwsimProActionResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DwsimProActionResponseModel>(null as any);
    }

    markActionAsExecuted(actionId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/dwsim-pro-startup-actions/{actionId}/mark-as-executed";
        if (actionId === undefined || actionId === null)
            throw new globalThis.Error("The parameter 'actionId' must be defined.");
        url_ = url_.replace("{actionId}", encodeURIComponent("" + actionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkActionAsExecuted(_response);
        });
    }

    protected processMarkActionAsExecuted(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class FileMetadataClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    getFileMetadata(fileUniqueId: string, cancelToken?: CancelToken): Promise<FileMetadataFieldResponseModel[]> {
        let url_ = this.baseUrl + "/api/file-metadata/{fileUniqueId}";
        if (fileUniqueId === undefined || fileUniqueId === null)
            throw new globalThis.Error("The parameter 'fileUniqueId' must be defined.");
        url_ = url_.replace("{fileUniqueId}", encodeURIComponent("" + fileUniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFileMetadata(_response);
        });
    }

    protected processGetFileMetadata(response: AxiosResponse): Promise<FileMetadataFieldResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileMetadataFieldResponseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<FileMetadataFieldResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileMetadataFieldResponseModel[]>(null as any);
    }
}

export class FileOpenerClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    updateLocallyOpenedFiles(model: UpdateLocallyOpenedFilesPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/file-opener/update-locally-opened-files";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLocallyOpenedFiles(_response);
        });
    }

    protected processUpdateLocallyOpenedFiles(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class FilesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    getSuggestedDocumentName(model: SuggestDocumentNamePostModel, cancelToken?: CancelToken): Promise<SuggestDocumentNameResponseModel> {
        let url_ = this.baseUrl + "/api/flies/get-suggested-document-name";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSuggestedDocumentName(_response);
        });
    }

    protected processGetSuggestedDocumentName(response: AxiosResponse): Promise<SuggestDocumentNameResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SuggestDocumentNameResponseModel.fromJS(resultData200);
            return Promise.resolve<SuggestDocumentNameResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuggestDocumentNameResponseModel>(null as any);
    }

    getFiles(parentUniqueId: string | null, sortBy: FileSortFields | null | undefined, isDescending: boolean | null | undefined, cancelToken?: CancelToken): Promise<FilesWithBreadcrumbsResponseModel> {
        let url_ = this.baseUrl + "/api/files/{parentUniqueId}?";
        if (parentUniqueId === undefined || parentUniqueId === null)
            throw new globalThis.Error("The parameter 'parentUniqueId' must be defined.");
        url_ = url_.replace("{parentUniqueId}", encodeURIComponent("" + parentUniqueId));
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (isDescending !== undefined && isDescending !== null)
            url_ += "isDescending=" + encodeURIComponent("" + isDescending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFiles(_response);
        });
    }

    protected processGetFiles(response: AxiosResponse): Promise<FilesWithBreadcrumbsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilesWithBreadcrumbsResponseModel.fromJS(resultData200);
            return Promise.resolve<FilesWithBreadcrumbsResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilesWithBreadcrumbsResponseModel>(null as any);
    }

    getStaredFiles(sortBy: FileSortFields | null | undefined, isDescending: boolean | null | undefined, cancelToken?: CancelToken): Promise<StaredFileModel[]> {
        let url_ = this.baseUrl + "/api/files/stared?";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (isDescending !== undefined && isDescending !== null)
            url_ += "isDescending=" + encodeURIComponent("" + isDescending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStaredFiles(_response);
        });
    }

    protected processGetStaredFiles(response: AxiosResponse): Promise<StaredFileModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StaredFileModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<StaredFileModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaredFileModel[]>(null as any);
    }

    getDeletedFiles(sortBy: FileSortFields | null | undefined, isDescending: boolean | null | undefined, cancelToken?: CancelToken): Promise<DeletedFileModel[]> {
        let url_ = this.baseUrl + "/api/files/deleted?";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (isDescending !== undefined && isDescending !== null)
            url_ += "isDescending=" + encodeURIComponent("" + isDescending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeletedFiles(_response);
        });
    }

    protected processGetDeletedFiles(response: AxiosResponse): Promise<DeletedFileModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeletedFileModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DeletedFileModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeletedFileModel[]>(null as any);
    }

    restoreFile(model: RestoreFilePostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/files/restore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestoreFile(_response);
        });
    }

    protected processRestoreFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getFileLatest(fileUniqueIdentifier: string, includeBreadcrumbs: boolean | undefined, accessType: AccessType | null | undefined, cancelToken?: CancelToken): Promise<FileWithBreadcrumbsResponseModel> {
        let url_ = this.baseUrl + "/api/files/{fileUniqueIdentifier}/single?";
        if (fileUniqueIdentifier === undefined || fileUniqueIdentifier === null)
            throw new globalThis.Error("The parameter 'fileUniqueIdentifier' must be defined.");
        url_ = url_.replace("{fileUniqueIdentifier}", encodeURIComponent("" + fileUniqueIdentifier));
        if (includeBreadcrumbs === null)
            throw new globalThis.Error("The parameter 'includeBreadcrumbs' cannot be null.");
        else if (includeBreadcrumbs !== undefined)
            url_ += "includeBreadcrumbs=" + encodeURIComponent("" + includeBreadcrumbs) + "&";
        if (accessType !== undefined && accessType !== null)
            url_ += "accessType=" + encodeURIComponent("" + accessType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFileLatest(_response);
        });
    }

    protected processGetFileLatest(response: AxiosResponse): Promise<FileWithBreadcrumbsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileWithBreadcrumbsResponseModel.fromJS(resultData200);
            return Promise.resolve<FileWithBreadcrumbsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileWithBreadcrumbsResponseModel>(null as any);
    }

    getFileByPath(filePath: string | undefined, includeBreadcrumbs: boolean | undefined, cancelToken?: CancelToken): Promise<FileWithBreadcrumbsResponseModel> {
        let url_ = this.baseUrl + "/api/files/by-path?";
        if (filePath === null)
            throw new globalThis.Error("The parameter 'filePath' cannot be null.");
        else if (filePath !== undefined)
            url_ += "filePath=" + encodeURIComponent("" + filePath) + "&";
        if (includeBreadcrumbs === null)
            throw new globalThis.Error("The parameter 'includeBreadcrumbs' cannot be null.");
        else if (includeBreadcrumbs !== undefined)
            url_ += "includeBreadcrumbs=" + encodeURIComponent("" + includeBreadcrumbs) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFileByPath(_response);
        });
    }

    protected processGetFileByPath(response: AxiosResponse): Promise<FileWithBreadcrumbsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileWithBreadcrumbsResponseModel.fromJS(resultData200);
            return Promise.resolve<FileWithBreadcrumbsResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileWithBreadcrumbsResponseModel>(null as any);
    }

    getSharedFileLatest(fileUniqueIdentifier: string, sourceType: ShareDefinitionSourceType | null | undefined, sourceId: string | null | undefined, includeBreadcrumbs: boolean | undefined, cancelToken?: CancelToken): Promise<FileWithBreadcrumbsResponseModel> {
        let url_ = this.baseUrl + "/api/files/{fileUniqueIdentifier}/single/shared?";
        if (fileUniqueIdentifier === undefined || fileUniqueIdentifier === null)
            throw new globalThis.Error("The parameter 'fileUniqueIdentifier' must be defined.");
        url_ = url_.replace("{fileUniqueIdentifier}", encodeURIComponent("" + fileUniqueIdentifier));
        if (sourceType !== undefined && sourceType !== null)
            url_ += "sourceType=" + encodeURIComponent("" + sourceType) + "&";
        if (sourceId !== undefined && sourceId !== null)
            url_ += "sourceId=" + encodeURIComponent("" + sourceId) + "&";
        if (includeBreadcrumbs === null)
            throw new globalThis.Error("The parameter 'includeBreadcrumbs' cannot be null.");
        else if (includeBreadcrumbs !== undefined)
            url_ += "includeBreadcrumbs=" + encodeURIComponent("" + includeBreadcrumbs) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSharedFileLatest(_response);
        });
    }

    protected processGetSharedFileLatest(response: AxiosResponse): Promise<FileWithBreadcrumbsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileWithBreadcrumbsResponseModel.fromJS(resultData200);
            return Promise.resolve<FileWithBreadcrumbsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileWithBreadcrumbsResponseModel>(null as any);
    }

    getSharedFile(fileUniqueIdentifier: string, versionNumber: number, sourceType: ShareDefinitionSourceType | null | undefined, sourceId: string | null | undefined, includeBreadcrumbs: boolean | undefined, cancelToken?: CancelToken): Promise<FileWithBreadcrumbsResponseModel> {
        let url_ = this.baseUrl + "/api/files/{fileUniqueIdentifier}/versions/{versionNumber}/shared?";
        if (fileUniqueIdentifier === undefined || fileUniqueIdentifier === null)
            throw new globalThis.Error("The parameter 'fileUniqueIdentifier' must be defined.");
        url_ = url_.replace("{fileUniqueIdentifier}", encodeURIComponent("" + fileUniqueIdentifier));
        if (versionNumber === undefined || versionNumber === null)
            throw new globalThis.Error("The parameter 'versionNumber' must be defined.");
        url_ = url_.replace("{versionNumber}", encodeURIComponent("" + versionNumber));
        if (sourceType !== undefined && sourceType !== null)
            url_ += "sourceType=" + encodeURIComponent("" + sourceType) + "&";
        if (sourceId !== undefined && sourceId !== null)
            url_ += "sourceId=" + encodeURIComponent("" + sourceId) + "&";
        if (includeBreadcrumbs === null)
            throw new globalThis.Error("The parameter 'includeBreadcrumbs' cannot be null.");
        else if (includeBreadcrumbs !== undefined)
            url_ += "includeBreadcrumbs=" + encodeURIComponent("" + includeBreadcrumbs) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSharedFile(_response);
        });
    }

    protected processGetSharedFile(response: AxiosResponse): Promise<FileWithBreadcrumbsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileWithBreadcrumbsResponseModel.fromJS(resultData200);
            return Promise.resolve<FileWithBreadcrumbsResponseModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileWithBreadcrumbsResponseModel>(null as any);
    }

    getFile(fileUniqueIdentifier: string, versionNumber: number, includeBreadcrumbs: boolean | undefined, accessType: AccessType | null | undefined, cancelToken?: CancelToken): Promise<FileWithBreadcrumbsResponseModel> {
        let url_ = this.baseUrl + "/api/files/{fileUniqueIdentifier}/versions/{versionNumber}?";
        if (fileUniqueIdentifier === undefined || fileUniqueIdentifier === null)
            throw new globalThis.Error("The parameter 'fileUniqueIdentifier' must be defined.");
        url_ = url_.replace("{fileUniqueIdentifier}", encodeURIComponent("" + fileUniqueIdentifier));
        if (versionNumber === undefined || versionNumber === null)
            throw new globalThis.Error("The parameter 'versionNumber' must be defined.");
        url_ = url_.replace("{versionNumber}", encodeURIComponent("" + versionNumber));
        if (includeBreadcrumbs === null)
            throw new globalThis.Error("The parameter 'includeBreadcrumbs' cannot be null.");
        else if (includeBreadcrumbs !== undefined)
            url_ += "includeBreadcrumbs=" + encodeURIComponent("" + includeBreadcrumbs) + "&";
        if (accessType !== undefined && accessType !== null)
            url_ += "accessType=" + encodeURIComponent("" + accessType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFile(_response);
        });
    }

    protected processGetFile(response: AxiosResponse): Promise<FileWithBreadcrumbsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileWithBreadcrumbsResponseModel.fromJS(resultData200);
            return Promise.resolve<FileWithBreadcrumbsResponseModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileWithBreadcrumbsResponseModel>(null as any);
    }

    getFileVersions(fileUniqueIdentifier: string, cancelToken?: CancelToken): Promise<FileVersionResponseModel[]> {
        let url_ = this.baseUrl + "/api/files/{fileUniqueIdentifier}/versions";
        if (fileUniqueIdentifier === undefined || fileUniqueIdentifier === null)
            throw new globalThis.Error("The parameter 'fileUniqueIdentifier' must be defined.");
        url_ = url_.replace("{fileUniqueIdentifier}", encodeURIComponent("" + fileUniqueIdentifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFileVersions(_response);
        });
    }

    protected processGetFileVersions(response: AxiosResponse): Promise<FileVersionResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileVersionResponseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<FileVersionResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileVersionResponseModel[]>(null as any);
    }

    getDirectory(directoryUniqueIdentifier: string, includeBreadcrumbs: boolean | undefined, cancelToken?: CancelToken): Promise<FileWithBreadcrumbsResponseModel> {
        let url_ = this.baseUrl + "/api/directories/{directoryUniqueIdentifier}?";
        if (directoryUniqueIdentifier === undefined || directoryUniqueIdentifier === null)
            throw new globalThis.Error("The parameter 'directoryUniqueIdentifier' must be defined.");
        url_ = url_.replace("{directoryUniqueIdentifier}", encodeURIComponent("" + directoryUniqueIdentifier));
        if (includeBreadcrumbs === null)
            throw new globalThis.Error("The parameter 'includeBreadcrumbs' cannot be null.");
        else if (includeBreadcrumbs !== undefined)
            url_ += "includeBreadcrumbs=" + encodeURIComponent("" + includeBreadcrumbs) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDirectory(_response);
        });
    }

    protected processGetDirectory(response: AxiosResponse): Promise<FileWithBreadcrumbsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileWithBreadcrumbsResponseModel.fromJS(resultData200);
            return Promise.resolve<FileWithBreadcrumbsResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileWithBreadcrumbsResponseModel>(null as any);
    }

    updateComment(fileUniqueId: string, model: UpdateCommentPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/files/{fileUniqueId}/comment";
        if (fileUniqueId === undefined || fileUniqueId === null)
            throw new globalThis.Error("The parameter 'fileUniqueId' must be defined.");
        url_ = url_.replace("{fileUniqueId}", encodeURIComponent("" + fileUniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateComment(_response);
        });
    }

    protected processUpdateComment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    toogleFileStared(fileUniqueId: string, model: ToogleStaredPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/files/{fileUniqueId}/toogle-stared";
        if (fileUniqueId === undefined || fileUniqueId === null)
            throw new globalThis.Error("The parameter 'fileUniqueId' must be defined.");
        url_ = url_.replace("{fileUniqueId}", encodeURIComponent("" + fileUniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToogleFileStared(_response);
        });
    }

    protected processToogleFileStared(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    uploadFiles(conflictAction: UploadConflictAction | null | undefined, parentDirectoryUniqueId: string | null | undefined, files: FileParameter[] | null | undefined, isFromOtherService: boolean | undefined, sourceFileUniqueId: string | null | undefined, metadataFields: { [key: string]: string; } | null | undefined, comment: string | null | undefined, isFromS365FileOpener: boolean | undefined, ownerId: string | null | undefined, fileVersion: number | null | undefined, cancelToken?: CancelToken): Promise<UploadFileResponseModel[]> {
        let url_ = this.baseUrl + "/api/files/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (conflictAction !== null && conflictAction !== undefined)
            content_.append("ConflictAction", conflictAction.toString());
        if (parentDirectoryUniqueId !== null && parentDirectoryUniqueId !== undefined)
            content_.append("ParentDirectoryUniqueId", parentDirectoryUniqueId.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (isFromOtherService === null || isFromOtherService === undefined)
            throw new globalThis.Error("The parameter 'isFromOtherService' cannot be null.");
        else
            content_.append("IsFromOtherService", isFromOtherService.toString());
        if (sourceFileUniqueId !== null && sourceFileUniqueId !== undefined)
            content_.append("SourceFileUniqueId", sourceFileUniqueId.toString());
        if (metadataFields !== null && metadataFields !== undefined)
            content_.append("MetadataFields", JSON.stringify(metadataFields));
        if (comment !== null && comment !== undefined)
            content_.append("Comment", comment.toString());
        if (isFromS365FileOpener === null || isFromS365FileOpener === undefined)
            throw new globalThis.Error("The parameter 'isFromS365FileOpener' cannot be null.");
        else
            content_.append("IsFromS365FileOpener", isFromS365FileOpener.toString());
        if (ownerId !== null && ownerId !== undefined)
            content_.append("OwnerId", ownerId.toString());
        if (fileVersion !== null && fileVersion !== undefined)
            content_.append("FileVersion", fileVersion.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadFiles(_response);
        });
    }

    protected processUploadFiles(response: AxiosResponse): Promise<UploadFileResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UploadFileResponseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UploadFileResponseModel[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ErrorResponseModel.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadFileResponseModel[]>(null as any);
    }

    createDirectory(model: CreateDirectoryPostModel, cancelToken?: CancelToken): Promise<FileModel> {
        let url_ = this.baseUrl + "/api/files";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDirectory(_response);
        });
    }

    protected processCreateDirectory(response: AxiosResponse): Promise<FileModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileModel.fromJS(resultData200);
            return Promise.resolve<FileModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileModel>(null as any);
    }

    validateFileNames(model: ValidateFileNamesPostModel, cancelToken?: CancelToken): Promise<ValidateFileNamesResponseModel> {
        let url_ = this.baseUrl + "/api/files/validate-file-names";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateFileNames(_response);
        });
    }

    protected processValidateFileNames(response: AxiosResponse): Promise<ValidateFileNamesResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateFileNamesResponseModel.fromJS(resultData200);
            return Promise.resolve<ValidateFileNamesResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateFileNamesResponseModel>(null as any);
    }

    renameFile(model: RenameFilePostModel, cancelToken?: CancelToken): Promise<ValidateFileNamesResponseModel> {
        let url_ = this.baseUrl + "/api/files/rename-file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenameFile(_response);
        });
    }

    protected processRenameFile(response: AxiosResponse): Promise<ValidateFileNamesResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateFileNamesResponseModel.fromJS(resultData200);
            return Promise.resolve<ValidateFileNamesResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateFileNamesResponseModel>(null as any);
    }

    renameDirectory(model: RenameDirectoryPostModel, cancelToken?: CancelToken): Promise<ValidateFileNamesResponseModel> {
        let url_ = this.baseUrl + "/api/files/rename-directory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenameDirectory(_response);
        });
    }

    protected processRenameDirectory(response: AxiosResponse): Promise<ValidateFileNamesResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateFileNamesResponseModel.fromJS(resultData200);
            return Promise.resolve<ValidateFileNamesResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateFileNamesResponseModel>(null as any);
    }

    downloadFile(uniqueId: string, versionNumber: number, filename: string | null, accessType: AccessType | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/files/{uniqueId}/versions/{versionNumber}/download/{filename}?";
        if (uniqueId === undefined || uniqueId === null)
            throw new globalThis.Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (versionNumber === undefined || versionNumber === null)
            throw new globalThis.Error("The parameter 'versionNumber' must be defined.");
        url_ = url_.replace("{versionNumber}", encodeURIComponent("" + versionNumber));
        if (filename === undefined || filename === null)
            throw new globalThis.Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        if (accessType !== undefined && accessType !== null)
            url_ += "accessType=" + encodeURIComponent("" + accessType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadFile(_response);
        });
    }

    protected processDownloadFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadFileLatest(uniqueId: string, accessType: AccessType | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/files/{uniqueId}/download?";
        if (uniqueId === undefined || uniqueId === null)
            throw new globalThis.Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (accessType !== undefined && accessType !== null)
            url_ += "accessType=" + encodeURIComponent("" + accessType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadFileLatest(_response);
        });
    }

    protected processDownloadFileLatest(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadFileByPath(filePath: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/files/download-by-path?";
        if (filePath === null)
            throw new globalThis.Error("The parameter 'filePath' cannot be null.");
        else if (filePath !== undefined)
            url_ += "filePath=" + encodeURIComponent("" + filePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadFileByPath(_response);
        });
    }

    protected processDownloadFileByPath(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    fileExistsByPath(model: FileExistsByPathPostModel, cancelToken?: CancelToken): Promise<FileExistsResponseModel> {
        let url_ = this.baseUrl + "/api/files/file-exists-by-path";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileExistsByPath(_response);
        });
    }

    protected processFileExistsByPath(response: AxiosResponse): Promise<FileExistsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileExistsResponseModel.fromJS(resultData200);
            return Promise.resolve<FileExistsResponseModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileExistsResponseModel>(null as any);
    }

    deleteFile(uniqueId: string, fileType: FileSystemEntityType, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/files/{uniqueId}/delete/{fileType}";
        if (uniqueId === undefined || uniqueId === null)
            throw new globalThis.Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (fileType === undefined || fileType === null)
            throw new globalThis.Error("The parameter 'fileType' must be defined.");
        url_ = url_.replace("{fileType}", encodeURIComponent("" + fileType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFile(_response);
        });
    }

    protected processDeleteFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    resubmitForAnalysis(model: ResubmitForAnalysisPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/files/resubmit-for-analysis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResubmitForAnalysis(_response);
        });
    }

    protected processResubmitForAnalysis(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getFileAnalysisStatus(fileUniqueIdentifier: string, fileVersionNumber: number, cancelToken?: CancelToken): Promise<AnalysisStatus> {
        let url_ = this.baseUrl + "/api/files/{fileUniqueIdentifier}/version/{fileVersionNumber}/analysis-status";
        if (fileUniqueIdentifier === undefined || fileUniqueIdentifier === null)
            throw new globalThis.Error("The parameter 'fileUniqueIdentifier' must be defined.");
        url_ = url_.replace("{fileUniqueIdentifier}", encodeURIComponent("" + fileUniqueIdentifier));
        if (fileVersionNumber === undefined || fileVersionNumber === null)
            throw new globalThis.Error("The parameter 'fileVersionNumber' must be defined.");
        url_ = url_.replace("{fileVersionNumber}", encodeURIComponent("" + fileVersionNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFileAnalysisStatus(_response);
        });
    }

    protected processGetFileAnalysisStatus(response: AxiosResponse): Promise<AnalysisStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<AnalysisStatus>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AnalysisStatus>(null as any);
    }

    moveFileOrFolder(model: MoveFilePostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/files/move";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveFileOrFolder(_response);
        });
    }

    protected processMoveFileOrFolder(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    copyFileOrFolder(model: CopyFilePostModel, cancelToken?: CancelToken): Promise<FileModel> {
        let url_ = this.baseUrl + "/api/files/copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyFileOrFolder(_response);
        });
    }

    protected processCopyFileOrFolder(response: AxiosResponse): Promise<FileModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileModel.fromJS(resultData200);
            return Promise.resolve<FileModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileModel>(null as any);
    }

    searchFiles(searchText: string | undefined, parentUniqueId: string | null | undefined, sortBy: FileSortFields | null | undefined, isDescending: boolean | null | undefined, cancelToken?: CancelToken): Promise<SearchFileModel[]> {
        let url_ = this.baseUrl + "/api/files/search?";
        if (searchText === null)
            throw new globalThis.Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (parentUniqueId !== undefined && parentUniqueId !== null)
            url_ += "parentUniqueId=" + encodeURIComponent("" + parentUniqueId) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (isDescending !== undefined && isDescending !== null)
            url_ += "isDescending=" + encodeURIComponent("" + isDescending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchFiles(_response);
        });
    }

    protected processSearchFiles(response: AxiosResponse): Promise<SearchFileModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchFileModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SearchFileModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchFileModel[]>(null as any);
    }
}

export class FiltersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    getFilters(query: FilterQuery, cancelToken?: CancelToken): Promise<FilterResultModel[]> {
        let url_ = this.baseUrl + "/api/filters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilters(_response);
        });
    }

    protected processGetFilters(response: AxiosResponse): Promise<FilterResultModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterResultModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<FilterResultModel[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
                result401 = resultData401 !== undefined ? resultData401 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterResultModel[]>(null as any);
    }

    cloneSharedFilter(model: CloneSharedFilterPostModel, cancelToken?: CancelToken): Promise<CloneSharedFilterResponseModel> {
        let url_ = this.baseUrl + "/api/filters/clone-shared-filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloneSharedFilter(_response);
        });
    }

    protected processCloneSharedFilter(response: AxiosResponse): Promise<CloneSharedFilterResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CloneSharedFilterResponseModel.fromJS(resultData200);
            return Promise.resolve<CloneSharedFilterResponseModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloneSharedFilterResponseModel>(null as any);
    }

    getAllFiltersWithWebForms(skip: number | undefined, take: number | undefined, orderByIdDesc: boolean | undefined, cancelToken?: CancelToken): Promise<FilterListResponseModel> {
        let url_ = this.baseUrl + "/api/filters/all-user-web-forms?";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (orderByIdDesc === null)
            throw new globalThis.Error("The parameter 'orderByIdDesc' cannot be null.");
        else if (orderByIdDesc !== undefined)
            url_ += "OrderByIdDesc=" + encodeURIComponent("" + orderByIdDesc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllFiltersWithWebForms(_response);
        });
    }

    protected processGetAllFiltersWithWebForms(response: AxiosResponse): Promise<FilterListResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterListResponseModel.fromJS(resultData200);
            return Promise.resolve<FilterListResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterListResponseModel>(null as any);
    }

    getSharedFilter(sourceType: ShareDefinitionSourceType | null | undefined, sourceId: string | null | undefined, filterId: number, filterVersionId: number | null, cancelToken?: CancelToken): Promise<FilterResultModel> {
        let url_ = this.baseUrl + "/api/filters/{filterId}/versions/{filterVersionId}/get-shared-filter?";
        if (filterId === undefined || filterId === null)
            throw new globalThis.Error("The parameter 'filterId' must be defined.");
        url_ = url_.replace("{filterId}", encodeURIComponent("" + filterId));
        if (filterVersionId === undefined || filterVersionId === null)
            throw new globalThis.Error("The parameter 'filterVersionId' must be defined.");
        url_ = url_.replace("{filterVersionId}", encodeURIComponent("" + filterVersionId));
        if (sourceType !== undefined && sourceType !== null)
            url_ += "sourceType=" + encodeURIComponent("" + sourceType) + "&";
        if (sourceId !== undefined && sourceId !== null)
            url_ += "sourceId=" + encodeURIComponent("" + sourceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSharedFilter(_response);
        });
    }

    protected processGetSharedFilter(response: AxiosResponse): Promise<FilterResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterResultModel.fromJS(resultData200);
            return Promise.resolve<FilterResultModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterResultModel>(null as any);
    }

    getFilterLatest(fileUniqueId: string, filterId: number, cancelToken?: CancelToken): Promise<FilterResultModel> {
        let url_ = this.baseUrl + "/api/files/{fileUniqueId}/filters/{filterId}";
        if (fileUniqueId === undefined || fileUniqueId === null)
            throw new globalThis.Error("The parameter 'fileUniqueId' must be defined.");
        url_ = url_.replace("{fileUniqueId}", encodeURIComponent("" + fileUniqueId));
        if (filterId === undefined || filterId === null)
            throw new globalThis.Error("The parameter 'filterId' must be defined.");
        url_ = url_.replace("{filterId}", encodeURIComponent("" + filterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilterLatest(_response);
        });
    }

    protected processGetFilterLatest(response: AxiosResponse): Promise<FilterResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterResultModel.fromJS(resultData200);
            return Promise.resolve<FilterResultModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterResultModel>(null as any);
    }

    getFilter(fileUniqueId: string, filterId: number, filterVersionId: number, cancelToken?: CancelToken): Promise<FilterResultModel> {
        let url_ = this.baseUrl + "/api/files/{fileUniqueId}/filters/{filterId}/version/{filterVersionId}";
        if (fileUniqueId === undefined || fileUniqueId === null)
            throw new globalThis.Error("The parameter 'fileUniqueId' must be defined.");
        url_ = url_.replace("{fileUniqueId}", encodeURIComponent("" + fileUniqueId));
        if (filterId === undefined || filterId === null)
            throw new globalThis.Error("The parameter 'filterId' must be defined.");
        url_ = url_.replace("{filterId}", encodeURIComponent("" + filterId));
        if (filterVersionId === undefined || filterVersionId === null)
            throw new globalThis.Error("The parameter 'filterVersionId' must be defined.");
        url_ = url_.replace("{filterVersionId}", encodeURIComponent("" + filterVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilter(_response);
        });
    }

    protected processGetFilter(response: AxiosResponse): Promise<FilterResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterResultModel.fromJS(resultData200);
            return Promise.resolve<FilterResultModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterResultModel>(null as any);
    }

    getFlowsheetInfo(query: FilterFlowsheetQuery, cancelToken?: CancelToken): Promise<FilterFileResponseModel> {
        let url_ = this.baseUrl + "/api/filter/get-flowsheet-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFlowsheetInfo(_response);
        });
    }

    protected processGetFlowsheetInfo(response: AxiosResponse): Promise<FilterFileResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterFileResponseModel.fromJS(resultData200);
            return Promise.resolve<FilterFileResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterFileResponseModel>(null as any);
    }

    getFilterWithoutFile(filterId: number, filterVersionId: number, cancelToken?: CancelToken): Promise<FilterResultModel> {
        let url_ = this.baseUrl + "/api/filters/{filterId}/version/{filterVersionId}";
        if (filterId === undefined || filterId === null)
            throw new globalThis.Error("The parameter 'filterId' must be defined.");
        url_ = url_.replace("{filterId}", encodeURIComponent("" + filterId));
        if (filterVersionId === undefined || filterVersionId === null)
            throw new globalThis.Error("The parameter 'filterVersionId' must be defined.");
        url_ = url_.replace("{filterVersionId}", encodeURIComponent("" + filterVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilterWithoutFile(_response);
        });
    }

    protected processGetFilterWithoutFile(response: AxiosResponse): Promise<FilterResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterResultModel.fromJS(resultData200);
            return Promise.resolve<FilterResultModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterResultModel>(null as any);
    }

    getFilterWithoutFileLatest(filterId: number, cancelToken?: CancelToken): Promise<FilterResultModel> {
        let url_ = this.baseUrl + "/api/filters/{filterId}";
        if (filterId === undefined || filterId === null)
            throw new globalThis.Error("The parameter 'filterId' must be defined.");
        url_ = url_.replace("{filterId}", encodeURIComponent("" + filterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilterWithoutFileLatest(_response);
        });
    }

    protected processGetFilterWithoutFileLatest(response: AxiosResponse): Promise<FilterResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterResultModel.fromJS(resultData200);
            return Promise.resolve<FilterResultModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterResultModel>(null as any);
    }

    getFiltersCount(fileUniqueId: string, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/files/{fileUniqueId}/filters/count";
        if (fileUniqueId === undefined || fileUniqueId === null)
            throw new globalThis.Error("The parameter 'fileUniqueId' must be defined.");
        url_ = url_.replace("{fileUniqueId}", encodeURIComponent("" + fileUniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFiltersCount(_response);
        });
    }

    protected processGetFiltersCount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    createOrUpdateFilter(model: FilterPostModel, cancelToken?: CancelToken): Promise<FilterResultModel> {
        let url_ = this.baseUrl + "/api/filters/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateFilter(_response);
        });
    }

    protected processCreateOrUpdateFilter(response: AxiosResponse): Promise<FilterResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterResultModel.fromJS(resultData200);
            return Promise.resolve<FilterResultModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
                result401 = resultData401 !== undefined ? resultData401 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterResultModel>(null as any);
    }

    createExcelFile(model: CreateExcelFilePostModel, cancelToken?: CancelToken): Promise<UploadFileResponseModel> {
        let url_ = this.baseUrl + "/api/filters/create-excel-file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateExcelFile(_response);
        });
    }

    protected processCreateExcelFile(response: AxiosResponse): Promise<UploadFileResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadFileResponseModel.fromJS(resultData200);
            return Promise.resolve<UploadFileResponseModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
                result401 = resultData401 !== undefined ? resultData401 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadFileResponseModel>(null as any);
    }

    deleteFilter(filterId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/filters/{filterId}/delete";
        if (filterId === undefined || filterId === null)
            throw new globalThis.Error("The parameter 'filterId' must be defined.");
        url_ = url_.replace("{filterId}", encodeURIComponent("" + filterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFilter(_response);
        });
    }

    protected processDeleteFilter(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
                result401 = resultData401 !== undefined ? resultData401 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    restoreFilter(filterId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/filters/{filterId}/restore";
        if (filterId === undefined || filterId === null)
            throw new globalThis.Error("The parameter 'filterId' must be defined.");
        url_ = url_.replace("{filterId}", encodeURIComponent("" + filterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestoreFilter(_response);
        });
    }

    protected processRestoreFilter(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
                result401 = resultData401 !== undefined ? resultData401 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getPublicWebFormId(filterId: number, cancelToken?: CancelToken): Promise<PublicWebFormIdResponseModel> {
        let url_ = this.baseUrl + "/api/filters/{filterId}/public-web-form-id";
        if (filterId === undefined || filterId === null)
            throw new globalThis.Error("The parameter 'filterId' must be defined.");
        url_ = url_.replace("{filterId}", encodeURIComponent("" + filterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublicWebFormId(_response);
        });
    }

    protected processGetPublicWebFormId(response: AxiosResponse): Promise<PublicWebFormIdResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicWebFormIdResponseModel.fromJS(resultData200);
            return Promise.resolve<PublicWebFormIdResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicWebFormIdResponseModel>(null as any);
    }

    recreateWebFormId(filterId: number, cancelToken?: CancelToken): Promise<PublicWebFormIdResponseModel> {
        let url_ = this.baseUrl + "/api/filters/{filterId}/public-web-form-id";
        if (filterId === undefined || filterId === null)
            throw new globalThis.Error("The parameter 'filterId' must be defined.");
        url_ = url_.replace("{filterId}", encodeURIComponent("" + filterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecreateWebFormId(_response);
        });
    }

    protected processRecreateWebFormId(response: AxiosResponse): Promise<PublicWebFormIdResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicWebFormIdResponseModel.fromJS(resultData200);
            return Promise.resolve<PublicWebFormIdResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicWebFormIdResponseModel>(null as any);
    }

    getPythonScript(model: FilterPythonScriptPostModel, cancelToken?: CancelToken): Promise<CreatePythonScriptResultModel> {
        let url_ = this.baseUrl + "/api/filters/python-script";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPythonScript(_response);
        });
    }

    protected processGetPythonScript(response: AxiosResponse): Promise<CreatePythonScriptResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreatePythonScriptResultModel.fromJS(resultData200);
            return Promise.resolve<CreatePythonScriptResultModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatePythonScriptResultModel>(null as any);
    }
}

export class FiltersCountClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    getFiltersCount(model: FiltersCountPostModel, cancelToken?: CancelToken): Promise<FilterCountResultModel[]> {
        let url_ = this.baseUrl + "/api/filters-count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFiltersCount(_response);
        });
    }

    protected processGetFiltersCount(response: AxiosResponse): Promise<FilterCountResultModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilterCountResultModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<FilterCountResultModel[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterCountResultModel[]>(null as any);
    }
}

export class FilterWebFormImagesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    upload(upload: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/filter-web-form-images/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (upload !== null && upload !== undefined)
            content_.append("upload", upload.data, upload.fileName ? upload.fileName : "upload");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getImage(uniqueIdentifier: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/filter-web-form-images/{uniqueIdentifier}";
        if (uniqueIdentifier === undefined || uniqueIdentifier === null)
            throw new globalThis.Error("The parameter 'uniqueIdentifier' must be defined.");
        url_ = url_.replace("{uniqueIdentifier}", encodeURIComponent("" + uniqueIdentifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImage(_response);
        });
    }

    protected processGetImage(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class FilterWebFormsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    getPublicWebFromData(model: FilterWebFormDataRequestModel, cancelToken?: CancelToken): Promise<FilterWebFormResponseModel> {
        let url_ = this.baseUrl + "/api/filter-web-forms/get-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublicWebFromData(_response);
        });
    }

    protected processGetPublicWebFromData(response: AxiosResponse): Promise<FilterWebFormResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterWebFormResponseModel.fromJS(resultData200);
            return Promise.resolve<FilterWebFormResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterWebFormResponseModel>(null as any);
    }

    submitWebFormDataForCalculation(model: FilterWebFormDataPostModel, cancelToken?: CancelToken): Promise<SubmitFilterWebFormResponseModel> {
        let url_ = this.baseUrl + "/api/filter-web-forms/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitWebFormDataForCalculation(_response);
        });
    }

    protected processSubmitWebFormDataForCalculation(response: AxiosResponse): Promise<SubmitFilterWebFormResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SubmitFilterWebFormResponseModel.fromJS(resultData200);
            return Promise.resolve<SubmitFilterWebFormResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubmitFilterWebFormResponseModel>(null as any);
    }

    jobCalculationSuccess(model: CalculationCompletedCallbackModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/filter-web-forms/dispatcher-callback-success";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processJobCalculationSuccess(_response);
        });
    }

    protected processJobCalculationSuccess(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    jobCalculationError(model: CalculationFailedCallbackModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/filter-web-forms/dispatcher-callback-error";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processJobCalculationError(_response);
        });
    }

    protected processJobCalculationError(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getJobResult(model: JobStatusRequestModel, cancelToken?: CancelToken): Promise<FilterWebFormJobResult> {
        let url_ = this.baseUrl + "/api/filter-web-forms/results";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobResult(_response);
        });
    }

    protected processGetJobResult(response: AxiosResponse): Promise<FilterWebFormJobResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterWebFormJobResult.fromJS(resultData200);
            return Promise.resolve<FilterWebFormJobResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterWebFormJobResult>(null as any);
    }
}

export class GroupsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    searchMembers(groupId: string, filterText: string | undefined, cancelToken?: CancelToken): Promise<UserResponseModel[]> {
        let url_ = this.baseUrl + "/api/groups/{groupId}/search-members?";
        if (groupId === undefined || groupId === null)
            throw new globalThis.Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (filterText === null)
            throw new globalThis.Error("The parameter 'filterText' cannot be null.");
        else if (filterText !== undefined)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMembers(_response);
        });
    }

    protected processSearchMembers(response: AxiosResponse): Promise<UserResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserResponseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserResponseModel[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserResponseModel[]>(null as any);
    }

    createGroup(model: CreateGroupPostModel, cancelToken?: CancelToken): Promise<UpdateGroupResultModel> {
        let url_ = this.baseUrl + "/api/groups/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateGroup(_response);
        });
    }

    protected processCreateGroup(response: AxiosResponse): Promise<UpdateGroupResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateGroupResultModel.fromJS(resultData200);
            return Promise.resolve<UpdateGroupResultModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateGroupResultModel>(null as any);
    }

    renameGroup(model: RenameGroupPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/groups/rename";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenameGroup(_response);
        });
    }

    protected processRenameGroup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getUserMemberOfGroups( cancelToken?: CancelToken): Promise<GroupTableResultModel[]> {
        let url_ = this.baseUrl + "/api/groups/member-of";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserMemberOfGroups(_response);
        });
    }

    protected processGetUserMemberOfGroups(response: AxiosResponse): Promise<GroupTableResultModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupTableResultModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GroupTableResultModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GroupTableResultModel[]>(null as any);
    }

    getAllGroupsAdmin( cancelToken?: CancelToken): Promise<GroupSlimResponseModel[]> {
        let url_ = this.baseUrl + "/api/groups/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllGroupsAdmin(_response);
        });
    }

    protected processGetAllGroupsAdmin(response: AxiosResponse): Promise<GroupSlimResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupSlimResponseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GroupSlimResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GroupSlimResponseModel[]>(null as any);
    }

    getUserOwnedGroups( cancelToken?: CancelToken): Promise<GroupTableResultModel[]> {
        let url_ = this.baseUrl + "/api/groups/user-owned";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserOwnedGroups(_response);
        });
    }

    protected processGetUserOwnedGroups(response: AxiosResponse): Promise<GroupTableResultModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupTableResultModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GroupTableResultModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GroupTableResultModel[]>(null as any);
    }

    getGroup(groupId: string, cancelToken?: CancelToken): Promise<GroupResultModel> {
        let url_ = this.baseUrl + "/api/groups/{groupId}";
        if (groupId === undefined || groupId === null)
            throw new globalThis.Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGroup(_response);
        });
    }

    protected processGetGroup(response: AxiosResponse): Promise<GroupResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GroupResultModel.fromJS(resultData200);
            return Promise.resolve<GroupResultModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GroupResultModel>(null as any);
    }

    getGroupMembersCount(groupId: string, cancelToken?: CancelToken): Promise<GroupMembersCountResponseModel> {
        let url_ = this.baseUrl + "/api/groups/{groupId}/members-count";
        if (groupId === undefined || groupId === null)
            throw new globalThis.Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGroupMembersCount(_response);
        });
    }

    protected processGetGroupMembersCount(response: AxiosResponse): Promise<GroupMembersCountResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GroupMembersCountResponseModel.fromJS(resultData200);
            return Promise.resolve<GroupMembersCountResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GroupMembersCountResponseModel>(null as any);
    }

    getGroupMembers(groupId: string, cancelToken?: CancelToken): Promise<UserModel[]> {
        let url_ = this.baseUrl + "/api/groups/{groupId}/members";
        if (groupId === undefined || groupId === null)
            throw new globalThis.Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGroupMembers(_response);
        });
    }

    protected processGetGroupMembers(response: AxiosResponse): Promise<UserModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserModel[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserModel[]>(null as any);
    }

    addMember(groupId: string, memberId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/groups/{groupId}/add-member/{memberId}";
        if (groupId === undefined || groupId === null)
            throw new globalThis.Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (memberId === undefined || memberId === null)
            throw new globalThis.Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddMember(_response);
        });
    }

    protected processAddMember(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addOwner(groupId: string, ownerId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/groups/{groupId}/add-owner/{ownerId}";
        if (groupId === undefined || groupId === null)
            throw new globalThis.Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (ownerId === undefined || ownerId === null)
            throw new globalThis.Error("The parameter 'ownerId' must be defined.");
        url_ = url_.replace("{ownerId}", encodeURIComponent("" + ownerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOwner(_response);
        });
    }

    protected processAddOwner(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removeOwner(groupId: string, ownerId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/groups/{groupId}/remove-owner/{ownerId}";
        if (groupId === undefined || groupId === null)
            throw new globalThis.Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (ownerId === undefined || ownerId === null)
            throw new globalThis.Error("The parameter 'ownerId' must be defined.");
        url_ = url_.replace("{ownerId}", encodeURIComponent("" + ownerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveOwner(_response);
        });
    }

    protected processRemoveOwner(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removeMember(groupId: string, memberId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/groups/{groupId}/remove-member/{memberId}";
        if (groupId === undefined || groupId === null)
            throw new globalThis.Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (memberId === undefined || memberId === null)
            throw new globalThis.Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveMember(_response);
        });
    }

    protected processRemoveMember(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteGroup(groupId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/groups/{groupId}/delete-group";
        if (groupId === undefined || groupId === null)
            throw new globalThis.Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteGroup(_response);
        });
    }

    protected processDeleteGroup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getDomainToGroupMappings(group: string | undefined, domain: string | undefined, sortBy: string | undefined, sortDescending: boolean | undefined, skip: number | undefined, take: number | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/groups/mappings?";
        if (group === null)
            throw new globalThis.Error("The parameter 'group' cannot be null.");
        else if (group !== undefined)
            url_ += "Group=" + encodeURIComponent("" + group) + "&";
        if (domain === null)
            throw new globalThis.Error("The parameter 'domain' cannot be null.");
        else if (domain !== undefined)
            url_ += "Domain=" + encodeURIComponent("" + domain) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new globalThis.Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "SortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDomainToGroupMappings(_response);
        });
    }

    protected processGetDomainToGroupMappings(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    addMapping(model: GroupMappingPostModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/groups/mappings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddMapping(_response);
        });
    }

    protected processAddMapping(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ImpersonateUserClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    getImpersonationData(userId: string, cancelToken?: CancelToken): Promise<ImpersonateUserResponseModel> {
        let url_ = this.baseUrl + "/api/impersonate-user/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImpersonationData(_response);
        });
    }

    protected processGetImpersonationData(response: AxiosResponse): Promise<ImpersonateUserResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImpersonateUserResponseModel.fromJS(resultData200);
            return Promise.resolve<ImpersonateUserResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImpersonateUserResponseModel>(null as any);
    }

    canImpersonateUser( cancelToken?: CancelToken): Promise<CanImpersonateUserResponseModel> {
        let url_ = this.baseUrl + "/api/impersonate-user/can-impersonate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCanImpersonateUser(_response);
        });
    }

    protected processCanImpersonateUser(response: AxiosResponse): Promise<CanImpersonateUserResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CanImpersonateUserResponseModel.fromJS(resultData200);
            return Promise.resolve<CanImpersonateUserResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CanImpersonateUserResponseModel>(null as any);
    }
}

export class LicensingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    getLicenseInfo(model: GetLicenseInfoPostModel, cancelToken?: CancelToken): Promise<LicenseResponseModel> {
        let url_ = this.baseUrl + "/api/licensing/license-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLicenseInfo(_response);
        });
    }

    protected processGetLicenseInfo(response: AxiosResponse): Promise<LicenseResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LicenseResponseModel.fromJS(resultData200);
            return Promise.resolve<LicenseResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LicenseResponseModel>(null as any);
    }

    getCurrentLicense( cancelToken?: CancelToken): Promise<CurrentLicenseResponseModel> {
        let url_ = this.baseUrl + "/api/licensing/current-license";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentLicense(_response);
        });
    }

    protected processGetCurrentLicense(response: AxiosResponse): Promise<CurrentLicenseResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CurrentLicenseResponseModel.fromJS(resultData200);
            return Promise.resolve<CurrentLicenseResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurrentLicenseResponseModel>(null as any);
    }

    getSubmittedBusinessEmails( cancelToken?: CancelToken): Promise<TrialUserEmail[]> {
        let url_ = this.baseUrl + "/api/licensing/submitted-business-emails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubmittedBusinessEmails(_response);
        });
    }

    protected processGetSubmittedBusinessEmails(response: AxiosResponse): Promise<TrialUserEmail[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrialUserEmail.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TrialUserEmail[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrialUserEmail[]>(null as any);
    }

    submitBusinessEmail(model: SubmitBusinessEmailPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/licensing/submit-business-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitBusinessEmail(_response);
        });
    }

    protected processSubmitBusinessEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getSubscriptionSharedWith(subscriptionId: number, cancelToken?: CancelToken): Promise<SubscriptionShareResponseModel[]> {
        let url_ = this.baseUrl + "/api/licensing/{subscriptionId}/sharedWith";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubscriptionSharedWith(_response);
        });
    }

    protected processGetSubscriptionSharedWith(response: AxiosResponse): Promise<SubscriptionShareResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriptionShareResponseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SubscriptionShareResponseModel[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubscriptionShareResponseModel[]>(null as any);
    }

    shareSubscription(model: ShareSubscriptionPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/licensing/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShareSubscription(_response);
        });
    }

    protected processShareSubscription(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    stopSharing(model: StopSharingSubscriptionPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/licensing/stop-sharing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStopSharing(_response);
        });
    }

    protected processStopSharing(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OrdersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    createOrder(model: OrderPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrder(_response);
        });
    }

    protected processCreateOrder(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OrganizationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    getOrganization(organizationId: number, cancelToken?: CancelToken): Promise<OrganizationResultModel> {
        let url_ = this.baseUrl + "/api/organizations/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganization(_response);
        });
    }

    protected processGetOrganization(response: AxiosResponse): Promise<OrganizationResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrganizationResultModel.fromJS(resultData200);
            return Promise.resolve<OrganizationResultModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationResultModel>(null as any);
    }

    deleteOrganization(organizationId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/organizations/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteOrganization(_response);
        });
    }

    protected processDeleteOrganization(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getOrganizations(name: string | null | undefined, azureGroupName: string | null | undefined, sortBy: string | null | undefined, sortDescending: boolean | undefined, skip: number | null | undefined, take: number | null | undefined, cancelToken?: CancelToken): Promise<ListResultOfOrganizationResultModel> {
        let url_ = this.baseUrl + "/api/organizations?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (azureGroupName !== undefined && azureGroupName !== null)
            url_ += "AzureGroupName=" + encodeURIComponent("" + azureGroupName) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new globalThis.Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "SortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizations(_response);
        });
    }

    protected processGetOrganizations(response: AxiosResponse): Promise<ListResultOfOrganizationResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultOfOrganizationResultModel.fromJS(resultData200);
            return Promise.resolve<ListResultOfOrganizationResultModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultOfOrganizationResultModel>(null as any);
    }

    createOrUpdateOrganization(model: OrganizationPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/organizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateOrganization(_response);
        });
    }

    protected processCreateOrUpdateOrganization(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getUserOrganization(userId: string, cancelToken?: CancelToken): Promise<OrganizationResultModel> {
        let url_ = this.baseUrl + "/api/organizations/user-organization/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserOrganization(_response);
        });
    }

    protected processGetUserOrganization(response: AxiosResponse): Promise<OrganizationResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrganizationResultModel.fromJS(resultData200);
            return Promise.resolve<OrganizationResultModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationResultModel>(null as any);
    }

    getMyOrganization( cancelToken?: CancelToken): Promise<OrganizationResultModel> {
        let url_ = this.baseUrl + "/api/organizations/my-organization";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyOrganization(_response);
        });
    }

    protected processGetMyOrganization(response: AxiosResponse): Promise<OrganizationResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrganizationResultModel.fromJS(resultData200);
            return Promise.resolve<OrganizationResultModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationResultModel>(null as any);
    }

    getOrganizationMembers(organizationId: number, sortBy: string | null | undefined, sortDescending: boolean | undefined, skip: number | null | undefined, take: number | null | undefined, cancelToken?: CancelToken): Promise<ListResultOfOrganizationMemberResponseModel> {
        let url_ = this.baseUrl + "/api/organizations/{organizationId}/members?";
        if (organizationId === undefined || organizationId === null)
            throw new globalThis.Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new globalThis.Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "SortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationMembers(_response);
        });
    }

    protected processGetOrganizationMembers(response: AxiosResponse): Promise<ListResultOfOrganizationMemberResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultOfOrganizationMemberResponseModel.fromJS(resultData200);
            return Promise.resolve<ListResultOfOrganizationMemberResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultOfOrganizationMemberResponseModel>(null as any);
    }
}

export class PrivacyPolicyClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    getEULAStatus(model: EulaStatusPostModel, cancelToken?: CancelToken): Promise<EulaStatusResultModel> {
        let url_ = this.baseUrl + "/api/privacy-policy/get-eula-status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEULAStatus(_response);
        });
    }

    protected processGetEULAStatus(response: AxiosResponse): Promise<EulaStatusResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EulaStatusResultModel.fromJS(resultData200);
            return Promise.resolve<EulaStatusResultModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EulaStatusResultModel>(null as any);
    }

    acceptEula(model: EulaStatusPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/privacy-policy/accept";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptEula(_response);
        });
    }

    protected processAcceptEula(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getEulaStatusByPrinicipal(model: GetEulaByUserPrincipalModel, cancelToken?: CancelToken): Promise<EulaStatusResultModel> {
        let url_ = this.baseUrl + "/api/privacy-policy/get-eula-status-by-principal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEulaStatusByPrinicipal(_response);
        });
    }

    protected processGetEulaStatusByPrinicipal(response: AxiosResponse): Promise<EulaStatusResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EulaStatusResultModel.fromJS(resultData200);
            return Promise.resolve<EulaStatusResultModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EulaStatusResultModel>(null as any);
    }

    acceptEula2(model: EulaStatusPrincipalPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/privacy-policy/accept-by-principal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptEula2(_response);
        });
    }

    protected processAcceptEula2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class QuestionnairesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    shouldShowLoginQuestionnaire( cancelToken?: CancelToken): Promise<ShouldShowLoginQuestionnaireResponseModel> {
        let url_ = this.baseUrl + "/api/questionnaires/should-show-login-questionnaire";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShouldShowLoginQuestionnaire(_response);
        });
    }

    protected processShouldShowLoginQuestionnaire(response: AxiosResponse): Promise<ShouldShowLoginQuestionnaireResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ShouldShowLoginQuestionnaireResponseModel.fromJS(resultData200);
            return Promise.resolve<ShouldShowLoginQuestionnaireResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShouldShowLoginQuestionnaireResponseModel>(null as any);
    }

    submitLoginQuestionnaireAnswers(model: LoginQuestionnairePostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/questionnaires/submit-login-answers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitLoginQuestionnaireAnswers(_response);
        });
    }

    protected processSubmitLoginQuestionnaireAnswers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ReadyToOrderClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    submitReadyToOrderForm(model: ReadyToOrderPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ready-to-order/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitReadyToOrderForm(_response);
        });
    }

    protected processSubmitReadyToOrderForm(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ResetPasswordClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    resetPassword(model: ResetPasswordRequestModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    setPasswordForUser(model: SetPasswordForUserModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/reset-password/set-password-for-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetPasswordForUser(_response);
        });
    }

    protected processSetPasswordForUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    changePassword(model: ResetPasswordPostModel, cancelToken?: CancelToken): Promise<ChangePasswordResponseModel> {
        let url_ = this.baseUrl + "/api/reset-password/set-new-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<ChangePasswordResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChangePasswordResponseModel.fromJS(resultData200);
            return Promise.resolve<ChangePasswordResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangePasswordResponseModel>(null as any);
    }
}

export class SharingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    isUserAdmin( cancelToken?: CancelToken): Promise<AdminCheckResponseModel> {
        let url_ = this.baseUrl + "/api/ui/sharing/admincheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsUserAdmin(_response);
        });
    }

    protected processIsUserAdmin(response: AxiosResponse): Promise<AdminCheckResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AdminCheckResponseModel.fromJS(resultData200);
            return Promise.resolve<AdminCheckResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdminCheckResponseModel>(null as any);
    }

    stopSharing(fileUniqueId: string, sharingDefinitionId: number, isPending: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/sharing/stop/{fileUniqueId}/{sharingDefinitionId}?";
        if (fileUniqueId === undefined || fileUniqueId === null)
            throw new globalThis.Error("The parameter 'fileUniqueId' must be defined.");
        url_ = url_.replace("{fileUniqueId}", encodeURIComponent("" + fileUniqueId));
        if (sharingDefinitionId === undefined || sharingDefinitionId === null)
            throw new globalThis.Error("The parameter 'sharingDefinitionId' must be defined.");
        url_ = url_.replace("{sharingDefinitionId}", encodeURIComponent("" + sharingDefinitionId));
        if (isPending === null)
            throw new globalThis.Error("The parameter 'isPending' cannot be null.");
        else if (isPending !== undefined)
            url_ += "isPending=" + encodeURIComponent("" + isPending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStopSharing(_response);
        });
    }

    protected processStopSharing(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    shareWith(model: ShareDefinitionPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/sharing/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShareWith(_response);
        });
    }

    protected processShareWith(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getSharedSourceTypeIds(fileUniqueId: string, sourceType: ShareDefinitionSourceType, cancelToken?: CancelToken): Promise<SharedSourceTypeIdsResponseModel> {
        let url_ = this.baseUrl + "/api/shared/{fileUniqueId}/shared-source-type-ids/{sourceType}";
        if (fileUniqueId === undefined || fileUniqueId === null)
            throw new globalThis.Error("The parameter 'fileUniqueId' must be defined.");
        url_ = url_.replace("{fileUniqueId}", encodeURIComponent("" + fileUniqueId));
        if (sourceType === undefined || sourceType === null)
            throw new globalThis.Error("The parameter 'sourceType' must be defined.");
        url_ = url_.replace("{sourceType}", encodeURIComponent("" + sourceType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSharedSourceTypeIds(_response);
        });
    }

    protected processGetSharedSourceTypeIds(response: AxiosResponse): Promise<SharedSourceTypeIdsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SharedSourceTypeIdsResponseModel.fromJS(resultData200);
            return Promise.resolve<SharedSourceTypeIdsResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SharedSourceTypeIdsResponseModel>(null as any);
    }

    getSharedDefinitions(sourceId: string, sourceType: ShareDefinitionSourceType, cancelToken?: CancelToken): Promise<ShareDefinitionResponseModel[]> {
        let url_ = this.baseUrl + "/api/sharing/{sourceId}/{sourceType}";
        if (sourceId === undefined || sourceId === null)
            throw new globalThis.Error("The parameter 'sourceId' must be defined.");
        url_ = url_.replace("{sourceId}", encodeURIComponent("" + sourceId));
        if (sourceType === undefined || sourceType === null)
            throw new globalThis.Error("The parameter 'sourceType' must be defined.");
        url_ = url_.replace("{sourceType}", encodeURIComponent("" + sourceType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSharedDefinitions(_response);
        });
    }

    protected processGetSharedDefinitions(response: AxiosResponse): Promise<ShareDefinitionResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShareDefinitionResponseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ShareDefinitionResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShareDefinitionResponseModel[]>(null as any);
    }

    getFileSharedObjectsCount(fileUniqueId: string | null | undefined, sourceType: ShareDefinitionSourceType | null | undefined, isSharedByMe: boolean | null | undefined, cancelToken?: CancelToken): Promise<FileSharedObjectsCountResponseModel> {
        let url_ = this.baseUrl + "/api/sharing/shared-count?";
        if (fileUniqueId !== undefined && fileUniqueId !== null)
            url_ += "FileUniqueId=" + encodeURIComponent("" + fileUniqueId) + "&";
        if (sourceType !== undefined && sourceType !== null)
            url_ += "SourceType=" + encodeURIComponent("" + sourceType) + "&";
        if (isSharedByMe !== undefined && isSharedByMe !== null)
            url_ += "IsSharedByMe=" + encodeURIComponent("" + isSharedByMe) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFileSharedObjectsCount(_response);
        });
    }

    protected processGetFileSharedObjectsCount(response: AxiosResponse): Promise<FileSharedObjectsCountResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileSharedObjectsCountResponseModel.fromJS(resultData200);
            return Promise.resolve<FileSharedObjectsCountResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileSharedObjectsCountResponseModel>(null as any);
    }

    isSharedWithMe(sourceId: string, sourceType: ShareDefinitionSourceType, cancelToken?: CancelToken): Promise<IsFileSharedResponseModel> {
        let url_ = this.baseUrl + "/api/sharing/{sourceId}/{sourceType}/is-shared-with-me";
        if (sourceId === undefined || sourceId === null)
            throw new globalThis.Error("The parameter 'sourceId' must be defined.");
        url_ = url_.replace("{sourceId}", encodeURIComponent("" + sourceId));
        if (sourceType === undefined || sourceType === null)
            throw new globalThis.Error("The parameter 'sourceType' must be defined.");
        url_ = url_.replace("{sourceType}", encodeURIComponent("" + sourceType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsSharedWithMe(_response);
        });
    }

    protected processIsSharedWithMe(response: AxiosResponse): Promise<IsFileSharedResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IsFileSharedResponseModel.fromJS(resultData200);
            return Promise.resolve<IsFileSharedResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IsFileSharedResponseModel>(null as any);
    }

    getPublicExamples(sourceType: ShareDefinitionSourceType, cancelToken?: CancelToken): Promise<ShareDefinitionResponseModel[]> {
        let url_ = this.baseUrl + "/api/sharing/public-examples/{sourceType}";
        if (sourceType === undefined || sourceType === null)
            throw new globalThis.Error("The parameter 'sourceType' must be defined.");
        url_ = url_.replace("{sourceType}", encodeURIComponent("" + sourceType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublicExamples(_response);
        });
    }

    protected processGetPublicExamples(response: AxiosResponse): Promise<ShareDefinitionResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShareDefinitionResponseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ShareDefinitionResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShareDefinitionResponseModel[]>(null as any);
    }

    getSharedByMeDocuments(parentSourceId: string | null, sortBy: FileSortFields | null | undefined, isDescending: boolean | null | undefined, cancelToken?: CancelToken): Promise<SharedByMeWithBreadcrumbsResponseModel> {
        let url_ = this.baseUrl + "/api/sharing/shared-by-me-files/{parentSourceId}?";
        if (parentSourceId === undefined || parentSourceId === null)
            throw new globalThis.Error("The parameter 'parentSourceId' must be defined.");
        url_ = url_.replace("{parentSourceId}", encodeURIComponent("" + parentSourceId));
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (isDescending !== undefined && isDescending !== null)
            url_ += "isDescending=" + encodeURIComponent("" + isDescending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSharedByMeDocuments(_response);
        });
    }

    protected processGetSharedByMeDocuments(response: AxiosResponse): Promise<SharedByMeWithBreadcrumbsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SharedByMeWithBreadcrumbsResponseModel.fromJS(resultData200);
            return Promise.resolve<SharedByMeWithBreadcrumbsResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SharedByMeWithBreadcrumbsResponseModel>(null as any);
    }

    getSharedByMeFilters( cancelToken?: CancelToken): Promise<ShareByMeFilterResponseModel[]> {
        let url_ = this.baseUrl + "/api/sharing/shared-by-me-filters";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSharedByMeFilters(_response);
        });
    }

    protected processGetSharedByMeFilters(response: AxiosResponse): Promise<ShareByMeFilterResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShareByMeFilterResponseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ShareByMeFilterResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShareByMeFilterResponseModel[]>(null as any);
    }

    getSharedWithMeFilters( cancelToken?: CancelToken): Promise<ShareWithMeFilterResponseModel[]> {
        let url_ = this.baseUrl + "/api/sharing/shared-with-me-filters";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSharedWithMeFilters(_response);
        });
    }

    protected processGetSharedWithMeFilters(response: AxiosResponse): Promise<ShareWithMeFilterResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShareWithMeFilterResponseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ShareWithMeFilterResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShareWithMeFilterResponseModel[]>(null as any);
    }

    getSharedByMeMssStudies(isOptimumTest: boolean | undefined, cancelToken?: CancelToken): Promise<ShareByMeStudyResponseModel[]> {
        let url_ = this.baseUrl + "/api/sharing/shared-by-me-mss-studies?";
        if (isOptimumTest === null)
            throw new globalThis.Error("The parameter 'isOptimumTest' cannot be null.");
        else if (isOptimumTest !== undefined)
            url_ += "isOptimumTest=" + encodeURIComponent("" + isOptimumTest) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSharedByMeMssStudies(_response);
        });
    }

    protected processGetSharedByMeMssStudies(response: AxiosResponse): Promise<ShareByMeStudyResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShareByMeStudyResponseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ShareByMeStudyResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShareByMeStudyResponseModel[]>(null as any);
    }

    getSharedWithMeMssStudies(isOptimumTest: boolean | undefined, cancelToken?: CancelToken): Promise<ShareWithMeStudyResponseModel[]> {
        let url_ = this.baseUrl + "/api/sharing/shared-with-me-mss-studies?";
        if (isOptimumTest === null)
            throw new globalThis.Error("The parameter 'isOptimumTest' cannot be null.");
        else if (isOptimumTest !== undefined)
            url_ += "isOptimumTest=" + encodeURIComponent("" + isOptimumTest) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSharedWithMeMssStudies(_response);
        });
    }

    protected processGetSharedWithMeMssStudies(response: AxiosResponse): Promise<ShareWithMeStudyResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShareWithMeStudyResponseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ShareWithMeStudyResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShareWithMeStudyResponseModel[]>(null as any);
    }

    getSharedByMeDoEExperiments( cancelToken?: CancelToken): Promise<ShareByMeScenarioResponseModel[]> {
        let url_ = this.baseUrl + "/api/sharing/shared-by-me-doe-experiments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSharedByMeDoEExperiments(_response);
        });
    }

    protected processGetSharedByMeDoEExperiments(response: AxiosResponse): Promise<ShareByMeScenarioResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShareByMeScenarioResponseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ShareByMeScenarioResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShareByMeScenarioResponseModel[]>(null as any);
    }

    getSharedWithMeDoEExperiments( cancelToken?: CancelToken): Promise<ShareWithMeScenarioResponseModel[]> {
        let url_ = this.baseUrl + "/api/sharing/shared-with-me-doe-experiments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSharedWithMeDoEExperiments(_response);
        });
    }

    protected processGetSharedWithMeDoEExperiments(response: AxiosResponse): Promise<ShareWithMeScenarioResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShareWithMeScenarioResponseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ShareWithMeScenarioResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShareWithMeScenarioResponseModel[]>(null as any);
    }

    getSharedWithMeDocuments(parentSourceId: string | null, sortBy: FileSortFields | null | undefined, isDescending: boolean | null | undefined, accessType: AccessType | null | undefined, cancelToken?: CancelToken): Promise<SharedWithMeWithBreadcrumbsResponseModel> {
        let url_ = this.baseUrl + "/api/sharing/shared-with-me-files/{parentSourceId}?";
        if (parentSourceId === undefined || parentSourceId === null)
            throw new globalThis.Error("The parameter 'parentSourceId' must be defined.");
        url_ = url_.replace("{parentSourceId}", encodeURIComponent("" + parentSourceId));
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (isDescending !== undefined && isDescending !== null)
            url_ += "isDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (accessType !== undefined && accessType !== null)
            url_ += "accessType=" + encodeURIComponent("" + accessType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSharedWithMeDocuments(_response);
        });
    }

    protected processGetSharedWithMeDocuments(response: AxiosResponse): Promise<SharedWithMeWithBreadcrumbsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SharedWithMeWithBreadcrumbsResponseModel.fromJS(resultData200);
            return Promise.resolve<SharedWithMeWithBreadcrumbsResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SharedWithMeWithBreadcrumbsResponseModel>(null as any);
    }

    getExamples(parentSourceId: string | null, sortBy: FileSortFields | null | undefined, isDescending: boolean | null | undefined, cancelToken?: CancelToken): Promise<ExamplesWithBreadcrumbsResponseModel> {
        let url_ = this.baseUrl + "/api/sharing/examples/{parentSourceId}?";
        if (parentSourceId === undefined || parentSourceId === null)
            throw new globalThis.Error("The parameter 'parentSourceId' must be defined.");
        url_ = url_.replace("{parentSourceId}", encodeURIComponent("" + parentSourceId));
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (isDescending !== undefined && isDescending !== null)
            url_ += "isDescending=" + encodeURIComponent("" + isDescending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExamples(_response);
        });
    }

    protected processGetExamples(response: AxiosResponse): Promise<ExamplesWithBreadcrumbsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExamplesWithBreadcrumbsResponseModel.fromJS(resultData200);
            return Promise.resolve<ExamplesWithBreadcrumbsResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExamplesWithBreadcrumbsResponseModel>(null as any);
    }
}

export class StatisticsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    getLatestUploadedFile(userId: string, cancelToken?: CancelToken): Promise<LastUploadedFileResponseModel | null> {
        let url_ = this.baseUrl + "/api/statistics/{userId}/latest-uploaded-file";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatestUploadedFile(_response);
        });
    }

    protected processGetLatestUploadedFile(response: AxiosResponse): Promise<LastUploadedFileResponseModel | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? LastUploadedFileResponseModel.fromJS(resultData200) : null as any;
            return Promise.resolve<LastUploadedFileResponseModel | null>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500 ? ErrorResponseModel.fromJS(resultData500) : null as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LastUploadedFileResponseModel | null>(null as any);
    }

    getLatestSharedFile(userId: string, cancelToken?: CancelToken): Promise<LastSharedFileResponseModel | null> {
        let url_ = this.baseUrl + "/api/statistics/{userId}/latest-shared-file";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatestSharedFile(_response);
        });
    }

    protected processGetLatestSharedFile(response: AxiosResponse): Promise<LastSharedFileResponseModel | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? LastSharedFileResponseModel.fromJS(resultData200) : null as any;
            return Promise.resolve<LastSharedFileResponseModel | null>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500 ? ErrorResponseModel.fromJS(resultData500) : null as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LastSharedFileResponseModel | null>(null as any);
    }
}

export class SubscriptionsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    getActiveSubscription(productType: ProductType | null | undefined, cancelToken?: CancelToken): Promise<ActiveSubscriptionUsageResponseModel> {
        let url_ = this.baseUrl + "/api/subscriptions/get-active-subscription?";
        if (productType !== undefined && productType !== null)
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveSubscription(_response);
        });
    }

    protected processGetActiveSubscription(response: AxiosResponse): Promise<ActiveSubscriptionUsageResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActiveSubscriptionUsageResponseModel.fromJS(resultData200);
            return Promise.resolve<ActiveSubscriptionUsageResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActiveSubscriptionUsageResponseModel>(null as any);
    }

    changeOwnerUsesSubscription(model: OwnerUsesBillingInstancePostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/subscriptions/change-owner-uses-subscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeOwnerUsesSubscription(_response);
        });
    }

    protected processChangeOwnerUsesSubscription(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SupportClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    sendSimulationFileTicket(model: ContactFormPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/support/send-email-to-support";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendSimulationFileTicket(_response);
        });
    }

    protected processSendSimulationFileTicket(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TagsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    getFileTagSuggestions(tagName: string | undefined, fileId: number | undefined, cancelToken?: CancelToken): Promise<TagResponseModel[]> {
        let url_ = this.baseUrl + "/api/tags/file-suggestions?";
        if (tagName === null)
            throw new globalThis.Error("The parameter 'tagName' cannot be null.");
        else if (tagName !== undefined)
            url_ += "tagName=" + encodeURIComponent("" + tagName) + "&";
        if (fileId === null)
            throw new globalThis.Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFileTagSuggestions(_response);
        });
    }

    protected processGetFileTagSuggestions(response: AxiosResponse): Promise<TagResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TagResponseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TagResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagResponseModel[]>(null as any);
    }

    getDirectoryTagSuggestions(tagName: string | undefined, directoryId: number | undefined, cancelToken?: CancelToken): Promise<TagResponseModel[]> {
        let url_ = this.baseUrl + "/api/tags/directory-suggestions?";
        if (tagName === null)
            throw new globalThis.Error("The parameter 'tagName' cannot be null.");
        else if (tagName !== undefined)
            url_ += "tagName=" + encodeURIComponent("" + tagName) + "&";
        if (directoryId === null)
            throw new globalThis.Error("The parameter 'directoryId' cannot be null.");
        else if (directoryId !== undefined)
            url_ += "directoryId=" + encodeURIComponent("" + directoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDirectoryTagSuggestions(_response);
        });
    }

    protected processGetDirectoryTagSuggestions(response: AxiosResponse): Promise<TagResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TagResponseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TagResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagResponseModel[]>(null as any);
    }

    addFileTag(model: FileTagPostModel, cancelToken?: CancelToken): Promise<TagResponseModel> {
        let url_ = this.baseUrl + "/api/tags/file-tag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddFileTag(_response);
        });
    }

    protected processAddFileTag(response: AxiosResponse): Promise<TagResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TagResponseModel.fromJS(resultData200);
            return Promise.resolve<TagResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagResponseModel>(null as any);
    }

    addDirectoryTag(model: DirectoryTagPostModel, cancelToken?: CancelToken): Promise<TagResponseModel> {
        let url_ = this.baseUrl + "/api/tags/directory-tag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddDirectoryTag(_response);
        });
    }

    protected processAddDirectoryTag(response: AxiosResponse): Promise<TagResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TagResponseModel.fromJS(resultData200);
            return Promise.resolve<TagResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagResponseModel>(null as any);
    }

    deleteTag(fileUniqueIdentifier: string, tagId: number, isDirectory: boolean | undefined, cancelToken?: CancelToken): Promise<TagResponseModel> {
        let url_ = this.baseUrl + "/api/tags/{fileUniqueIdentifier}/{tagId}?";
        if (fileUniqueIdentifier === undefined || fileUniqueIdentifier === null)
            throw new globalThis.Error("The parameter 'fileUniqueIdentifier' must be defined.");
        url_ = url_.replace("{fileUniqueIdentifier}", encodeURIComponent("" + fileUniqueIdentifier));
        if (tagId === undefined || tagId === null)
            throw new globalThis.Error("The parameter 'tagId' must be defined.");
        url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
        if (isDirectory === null)
            throw new globalThis.Error("The parameter 'isDirectory' cannot be null.");
        else if (isDirectory !== undefined)
            url_ += "isDirectory=" + encodeURIComponent("" + isDirectory) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTag(_response);
        });
    }

    protected processDeleteTag(response: AxiosResponse): Promise<TagResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TagResponseModel.fromJS(resultData200);
            return Promise.resolve<TagResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagResponseModel>(null as any);
    }
}

export class ThumbnailsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    generateThumbnail(fileId: number, versionNumber: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/files/{fileId}/versions/{versionNumber}/thumbnail/generate";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (versionNumber === undefined || versionNumber === null)
            throw new globalThis.Error("The parameter 'versionNumber' must be defined.");
        url_ = url_.replace("{versionNumber}", encodeURIComponent("" + versionNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateThumbnail(_response);
        });
    }

    protected processGenerateThumbnail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getThumbnailFull(fileUniqueIdentifier: string, versionNumber: number, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/files/{fileUniqueIdentifier}/versions/{versionNumber}/thumbnail/full";
        if (fileUniqueIdentifier === undefined || fileUniqueIdentifier === null)
            throw new globalThis.Error("The parameter 'fileUniqueIdentifier' must be defined.");
        url_ = url_.replace("{fileUniqueIdentifier}", encodeURIComponent("" + fileUniqueIdentifier));
        if (versionNumber === undefined || versionNumber === null)
            throw new globalThis.Error("The parameter 'versionNumber' must be defined.");
        url_ = url_.replace("{versionNumber}", encodeURIComponent("" + versionNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetThumbnailFull(_response);
        });
    }

    protected processGetThumbnailFull(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getThumbnailSmall(fileUniqueIdentifier: string, versionNumber: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/files/{fileUniqueIdentifier}/versions/{versionNumber}/thumbnail/small";
        if (fileUniqueIdentifier === undefined || fileUniqueIdentifier === null)
            throw new globalThis.Error("The parameter 'fileUniqueIdentifier' must be defined.");
        url_ = url_.replace("{fileUniqueIdentifier}", encodeURIComponent("" + fileUniqueIdentifier));
        if (versionNumber === undefined || versionNumber === null)
            throw new globalThis.Error("The parameter 'versionNumber' must be defined.");
        url_ = url_.replace("{versionNumber}", encodeURIComponent("" + versionNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetThumbnailSmall(_response);
        });
    }

    protected processGetThumbnailSmall(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TourClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    getTourStatus( cancelToken?: CancelToken): Promise<TourStatusResponseModel> {
        let url_ = this.baseUrl + "/api/tour/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTourStatus(_response);
        });
    }

    protected processGetTourStatus(response: AxiosResponse): Promise<TourStatusResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TourStatusResponseModel.fromJS(resultData200);
            return Promise.resolve<TourStatusResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TourStatusResponseModel>(null as any);
    }

    userAcceptedTour( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/tour/accepted";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserAcceptedTour(_response);
        });
    }

    protected processUserAcceptedTour(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UsersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    getUser(userId: string, cancelToken?: CancelToken): Promise<UserResponseModel> {
        let url_ = this.baseUrl + "/api/users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: AxiosResponse): Promise<UserResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserResponseModel.fromJS(resultData200);
            return Promise.resolve<UserResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserResponseModel>(null as any);
    }

    getReadyToOrderStatus( cancelToken?: CancelToken): Promise<ReadyToOrderResponseModel> {
        let url_ = this.baseUrl + "/api/users/ready-to-order";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReadyToOrderStatus(_response);
        });
    }

    protected processGetReadyToOrderStatus(response: AxiosResponse): Promise<ReadyToOrderResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReadyToOrderResponseModel.fromJS(resultData200);
            return Promise.resolve<ReadyToOrderResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReadyToOrderResponseModel>(null as any);
    }

    getUserDetails(userPrincipalName: string | null | undefined, cancelToken?: CancelToken): Promise<UserResponseModel> {
        let url_ = this.baseUrl + "/api/users/user-details?";
        if (userPrincipalName !== undefined && userPrincipalName !== null)
            url_ += "userPrincipalName=" + encodeURIComponent("" + userPrincipalName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserDetails(_response);
        });
    }

    protected processGetUserDetails(response: AxiosResponse): Promise<UserResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserResponseModel.fromJS(resultData200);
            return Promise.resolve<UserResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserResponseModel>(null as any);
    }

    getUserBusinessDetails( cancelToken?: CancelToken): Promise<UserBusinessResponseModel> {
        let url_ = this.baseUrl + "/api/users/user-business-details";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserBusinessDetails(_response);
        });
    }

    protected processGetUserBusinessDetails(response: AxiosResponse): Promise<UserBusinessResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserBusinessResponseModel.fromJS(resultData200);
            return Promise.resolve<UserBusinessResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserBusinessResponseModel>(null as any);
    }

    isUserExamplesAdmin( cancelToken?: CancelToken): Promise<IsUserExamplesAdminResponseModel> {
        let url_ = this.baseUrl + "/api/users/is-examples-admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsUserExamplesAdmin(_response);
        });
    }

    protected processIsUserExamplesAdmin(response: AxiosResponse): Promise<IsUserExamplesAdminResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IsUserExamplesAdminResponseModel.fromJS(resultData200);
            return Promise.resolve<IsUserExamplesAdminResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IsUserExamplesAdminResponseModel>(null as any);
    }

    isDwsimProUser( cancelToken?: CancelToken): Promise<IsDwsimProUserResponseModel> {
        let url_ = this.baseUrl + "/api/users/is-dwsim-pro-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsDwsimProUser(_response);
        });
    }

    protected processIsDwsimProUser(response: AxiosResponse): Promise<IsDwsimProUserResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IsDwsimProUserResponseModel.fromJS(resultData200);
            return Promise.resolve<IsDwsimProUserResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IsDwsimProUserResponseModel>(null as any);
    }

    getUserEmailCategory(model: UserEmailCategoryPostModel, cancelToken?: CancelToken): Promise<UserEmailCategoryResponseModel> {
        let url_ = this.baseUrl + "/api/users/email-category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserEmailCategory(_response);
        });
    }

    protected processGetUserEmailCategory(response: AxiosResponse): Promise<UserEmailCategoryResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserEmailCategoryResponseModel.fromJS(resultData200);
            return Promise.resolve<UserEmailCategoryResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserEmailCategoryResponseModel>(null as any);
    }

    createUser(postModel: CreateUserPostModel, cancelToken?: CancelToken): Promise<CreateUserResponseModel> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(postModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: AxiosResponse): Promise<CreateUserResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateUserResponseModel.fromJS(resultData200);
            return Promise.resolve<CreateUserResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateUserResponseModel>(null as any);
    }

    resendEmailConfirmation(postModel: RegistrationConfirmationPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/users/send-confirmation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(postModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResendEmailConfirmation(_response);
        });
    }

    protected processResendEmailConfirmation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    confirmRegistration(confirmationToken: string | undefined, cancelToken?: CancelToken): Promise<ConfirmUserRegistrationResultModel> {
        let url_ = this.baseUrl + "/api/users/confirmation?";
        if (confirmationToken === null)
            throw new globalThis.Error("The parameter 'confirmationToken' cannot be null.");
        else if (confirmationToken !== undefined)
            url_ += "confirmationToken=" + encodeURIComponent("" + confirmationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmRegistration(_response);
        });
    }

    protected processConfirmRegistration(response: AxiosResponse): Promise<ConfirmUserRegistrationResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConfirmUserRegistrationResultModel.fromJS(resultData200);
            return Promise.resolve<ConfirmUserRegistrationResultModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfirmUserRegistrationResultModel>(null as any);
    }

    getRealEmailFromUserPrincipal(model: UserPrincipalToRealEmailPostModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/users/user-principal-to-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRealEmailFromUserPrincipal(_response);
        });
    }

    protected processGetRealEmailFromUserPrincipal(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createDefaultApplicationForExistingUsers( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/users/create-default-application";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDefaultApplicationForExistingUsers(_response);
        });
    }

    protected processCreateDefaultApplicationForExistingUsers(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class UserTrackingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    pricingDialogShown(dialogType: PricingDialogType, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/users/pricing/{dialogType}";
        if (dialogType === undefined || dialogType === null)
            throw new globalThis.Error("The parameter 'dialogType' must be defined.");
        url_ = url_.replace("{dialogType}", encodeURIComponent("" + dialogType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPricingDialogShown(_response);
        });
    }

    protected processPricingDialogShown(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class InboundWebhookClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    index( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/stripe/webhook";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PricingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    getPrice(hours: number | undefined, engineers: number | undefined, months: number | undefined, cancelToken?: CancelToken): Promise<GetPriceResponseModel> {
        let url_ = this.baseUrl + "/api/pricing/get-price?";
        if (hours === null)
            throw new globalThis.Error("The parameter 'hours' cannot be null.");
        else if (hours !== undefined)
            url_ += "hours=" + encodeURIComponent("" + hours) + "&";
        if (engineers === null)
            throw new globalThis.Error("The parameter 'engineers' cannot be null.");
        else if (engineers !== undefined)
            url_ += "engineers=" + encodeURIComponent("" + engineers) + "&";
        if (months === null)
            throw new globalThis.Error("The parameter 'months' cannot be null.");
        else if (months !== undefined)
            url_ += "months=" + encodeURIComponent("" + months) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPrice(_response);
        });
    }

    protected processGetPrice(response: AxiosResponse): Promise<GetPriceResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPriceResponseModel.fromJS(resultData200);
            return Promise.resolve<GetPriceResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPriceResponseModel>(null as any);
    }

    buyNow(model: BuyNowPostModel, cancelToken?: CancelToken): Promise<BuyNowResponseModel> {
        let url_ = this.baseUrl + "/api/pricing/buy-now";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBuyNow(_response);
        });
    }

    protected processBuyNow(response: AxiosResponse): Promise<BuyNowResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BuyNowResponseModel.fromJS(resultData200);
            return Promise.resolve<BuyNowResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BuyNowResponseModel>(null as any);
    }
}

export class StripeCustomersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    getBillingPortalUrl( cancelToken?: CancelToken): Promise<BillingPortalUrlResponseModel> {
        let url_ = this.baseUrl + "/api/stripe-customers/get-billing-portal-url";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBillingPortalUrl(_response);
        });
    }

    protected processGetBillingPortalUrl(response: AxiosResponse): Promise<BillingPortalUrlResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BillingPortalUrlResponseModel.fromJS(resultData200);
            return Promise.resolve<BillingPortalUrlResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BillingPortalUrlResponseModel>(null as any);
    }

    getCustomerSession( cancelToken?: CancelToken): Promise<CustomerSessionResponseModel> {
        let url_ = this.baseUrl + "/api/stripe-customers/customer-session";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerSession(_response);
        });
    }

    protected processGetCustomerSession(response: AxiosResponse): Promise<CustomerSessionResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerSessionResponseModel.fromJS(resultData200);
            return Promise.resolve<CustomerSessionResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerSessionResponseModel>(null as any);
    }
}

export class StripeProductsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    getHourlyProducts( cancelToken?: CancelToken): Promise<StripeProductSlimModel[]> {
        let url_ = this.baseUrl + "/api/products/hourly";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHourlyProducts(_response);
        });
    }

    protected processGetHourlyProducts(response: AxiosResponse): Promise<StripeProductSlimModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StripeProductSlimModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<StripeProductSlimModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StripeProductSlimModel[]>(null as any);
    }

    getChangePlanUrl(model: ChangePlanPostModel, cancelToken?: CancelToken): Promise<ChangePlanResponseModel> {
        let url_ = this.baseUrl + "/api/sessions/change-plan-url";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChangePlanUrl(_response);
        });
    }

    protected processGetChangePlanUrl(response: AxiosResponse): Promise<ChangePlanResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChangePlanResponseModel.fromJS(resultData200);
            return Promise.resolve<ChangePlanResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangePlanResponseModel>(null as any);
    }
}

export class SessionsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7076";

    }

    getUsageData( cancelToken?: CancelToken): Promise<BillingInstanceSummary[]> {
        let url_ = this.baseUrl + "/api/sessions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsageData(_response);
        });
    }

    protected processGetUsageData(response: AxiosResponse): Promise<BillingInstanceSummary[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BillingInstanceSummary.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BillingInstanceSummary[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BillingInstanceSummary[]>(null as any);
    }
}

export class FileModel implements IFileModel {
    id?: number;
    name?: string;
    uniqueIdentifier?: string;
    currentVersionNumber?: number;
    createdAt?: Date;
    comment?: string | undefined;
    stared?: boolean;
    parentDirectoryId?: number;
    lastModifiedAt?: Date;
    ownerId?: string;
    isSoftDeleted?: boolean;
    isSharedForCollaboration?: boolean;
    type?: FileSystemEntityType;
    tags?: TagResponseModel[];

    constructor(data?: IFileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.uniqueIdentifier = _data["uniqueIdentifier"];
            this.currentVersionNumber = _data["currentVersionNumber"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.comment = _data["comment"];
            this.stared = _data["stared"];
            this.parentDirectoryId = _data["parentDirectoryId"];
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : undefined as any;
            this.ownerId = _data["ownerId"];
            this.isSoftDeleted = _data["isSoftDeleted"];
            this.isSharedForCollaboration = _data["isSharedForCollaboration"];
            this.type = _data["type"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["uniqueIdentifier"] = this.uniqueIdentifier;
        data["currentVersionNumber"] = this.currentVersionNumber;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["comment"] = this.comment;
        data["stared"] = this.stared;
        data["parentDirectoryId"] = this.parentDirectoryId;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : undefined as any;
        data["ownerId"] = this.ownerId;
        data["isSoftDeleted"] = this.isSoftDeleted;
        data["isSharedForCollaboration"] = this.isSharedForCollaboration;
        data["type"] = this.type;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFileModel {
    id?: number;
    name?: string;
    uniqueIdentifier?: string;
    currentVersionNumber?: number;
    createdAt?: Date;
    comment?: string | undefined;
    stared?: boolean;
    parentDirectoryId?: number;
    lastModifiedAt?: Date;
    ownerId?: string;
    isSoftDeleted?: boolean;
    isSharedForCollaboration?: boolean;
    type?: FileSystemEntityType;
    tags?: TagResponseModel[];
}

export enum FileSystemEntityType {
    File = 0,
    Directory = 1,
}

export class TagResponseModel implements ITagResponseModel {
    id?: number;
    name?: string;

    constructor(data?: ITagResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TagResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TagResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITagResponseModel {
    id?: number;
    name?: string;
}

export class ErrorResponseModel implements IErrorResponseModel {
    errors?: string[] | undefined;
    validationErrors?: { [key: string]: string[]; } | undefined;

    constructor(data?: IErrorResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (_data["validationErrors"]) {
                this.validationErrors = {} as any;
                for (let key in _data["validationErrors"]) {
                    if (_data["validationErrors"].hasOwnProperty(key))
                        (this.validationErrors as any)![key] = _data["validationErrors"][key] !== undefined ? _data["validationErrors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ErrorResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (this.validationErrors) {
            data["validationErrors"] = {};
            for (let key in this.validationErrors) {
                if (this.validationErrors.hasOwnProperty(key))
                    (data["validationErrors"] as any)[key] = (this.validationErrors as any)[key];
            }
        }
        return data;
    }
}

export interface IErrorResponseModel {
    errors?: string[] | undefined;
    validationErrors?: { [key: string]: string[]; } | undefined;
}

export class DirectoryDeletePostModel implements IDirectoryDeletePostModel {
    permanentDelete?: boolean | undefined;
    deleteChildData?: boolean | undefined;

    constructor(data?: IDirectoryDeletePostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permanentDelete = _data["permanentDelete"];
            this.deleteChildData = _data["deleteChildData"];
        }
    }

    static fromJS(data: any): DirectoryDeletePostModel {
        data = typeof data === 'object' ? data : {};
        let result = new DirectoryDeletePostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permanentDelete"] = this.permanentDelete;
        data["deleteChildData"] = this.deleteChildData;
        return data;
    }
}

export interface IDirectoryDeletePostModel {
    permanentDelete?: boolean | undefined;
    deleteChildData?: boolean | undefined;
}

export class AmeliaAppointmentBookingCompletePostModel implements IAmeliaAppointmentBookingCompletePostModel {
    appointment?: Appointment;
    bookings?: Bookings;

    constructor(data?: IAmeliaAppointmentBookingCompletePostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointment = _data["appointment"] ? Appointment.fromJS(_data["appointment"]) : undefined as any;
            this.bookings = _data["bookings"] ? Bookings.fromJS(_data["bookings"]) : undefined as any;
        }
    }

    static fromJS(data: any): AmeliaAppointmentBookingCompletePostModel {
        data = typeof data === 'object' ? data : {};
        let result = new AmeliaAppointmentBookingCompletePostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointment"] = this.appointment ? this.appointment.toJSON() : undefined as any;
        data["bookings"] = this.bookings ? this.bookings.toJSON() : undefined as any;
        return data;
    }
}

export interface IAmeliaAppointmentBookingCompletePostModel {
    appointment?: Appointment;
    bookings?: Bookings;
}

export class Appointment implements IAppointment {
    id?: number;
    bookings?: Bookings;
    notifyParticipants?: number;
    internalNotes?: string;
    status?: string;
    serviceId?: number;
    parentId?: any;
    providerId?: number;
    locationId?: any;
    provider?: Provider;
    service?: Service;
    location?: any;
    googleCalendarEventId?: any;
    googleMeetUrl?: any;
    outlookCalendarEventId?: any;
    zoomMeeting?: ZoomMeeting;
    lessonSpace?: any;
    bookingStart?: string;
    bookingEnd?: string;
    type?: string;
    isRescheduled?: any;

    constructor(data?: IAppointment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bookings = _data["bookings"] ? Bookings.fromJS(_data["bookings"]) : undefined as any;
            this.notifyParticipants = _data["notifyParticipants"];
            this.internalNotes = _data["internalNotes"];
            this.status = _data["status"];
            this.serviceId = _data["serviceId"];
            this.parentId = _data["parentId"];
            this.providerId = _data["providerId"];
            this.locationId = _data["locationId"];
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : undefined as any;
            this.service = _data["service"] ? Service.fromJS(_data["service"]) : undefined as any;
            this.location = _data["location"];
            this.googleCalendarEventId = _data["googleCalendarEventId"];
            this.googleMeetUrl = _data["googleMeetUrl"];
            this.outlookCalendarEventId = _data["outlookCalendarEventId"];
            this.zoomMeeting = _data["zoomMeeting"] ? ZoomMeeting.fromJS(_data["zoomMeeting"]) : undefined as any;
            this.lessonSpace = _data["lessonSpace"];
            this.bookingStart = _data["bookingStart"];
            this.bookingEnd = _data["bookingEnd"];
            this.type = _data["type"];
            this.isRescheduled = _data["isRescheduled"];
        }
    }

    static fromJS(data: any): Appointment {
        data = typeof data === 'object' ? data : {};
        let result = new Appointment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bookings"] = this.bookings ? this.bookings.toJSON() : undefined as any;
        data["notifyParticipants"] = this.notifyParticipants;
        data["internalNotes"] = this.internalNotes;
        data["status"] = this.status;
        data["serviceId"] = this.serviceId;
        data["parentId"] = this.parentId;
        data["providerId"] = this.providerId;
        data["locationId"] = this.locationId;
        data["provider"] = this.provider ? this.provider.toJSON() : undefined as any;
        data["service"] = this.service ? this.service.toJSON() : undefined as any;
        data["location"] = this.location;
        data["googleCalendarEventId"] = this.googleCalendarEventId;
        data["googleMeetUrl"] = this.googleMeetUrl;
        data["outlookCalendarEventId"] = this.outlookCalendarEventId;
        data["zoomMeeting"] = this.zoomMeeting ? this.zoomMeeting.toJSON() : undefined as any;
        data["lessonSpace"] = this.lessonSpace;
        data["bookingStart"] = this.bookingStart;
        data["bookingEnd"] = this.bookingEnd;
        data["type"] = this.type;
        data["isRescheduled"] = this.isRescheduled;
        return data;
    }
}

export interface IAppointment {
    id?: number;
    bookings?: Bookings;
    notifyParticipants?: number;
    internalNotes?: string;
    status?: string;
    serviceId?: number;
    parentId?: any;
    providerId?: number;
    locationId?: any;
    provider?: Provider;
    service?: Service;
    location?: any;
    googleCalendarEventId?: any;
    googleMeetUrl?: any;
    outlookCalendarEventId?: any;
    zoomMeeting?: ZoomMeeting;
    lessonSpace?: any;
    bookingStart?: string;
    bookingEnd?: string;
    type?: string;
    isRescheduled?: any;
}

export class Bookings implements IBookings {
    _0?: Booking;

    constructor(data?: IBookings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._0 = _data["0"] ? Booking.fromJS(_data["0"]) : undefined as any;
        }
    }

    static fromJS(data: any): Bookings {
        data = typeof data === 'object' ? data : {};
        let result = new Bookings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["0"] = this._0 ? this._0.toJSON() : undefined as any;
        return data;
    }
}

export interface IBookings {
    _0?: Booking;
}

export class Booking implements IBooking {
    id?: number;
    customerId?: number;
    customer?: Customer;
    status?: string;
    extras?: Extras;
    couponId?: any;
    price?: number;
    coupon?: any;
    customFields?: any;
    info?: string;
    appointmentId?: number;
    persons?: number;
    token?: string;
    payments?: Payments;
    utcOffset?: number;
    aggregatedPrice?: boolean;
    isChangedStatus?: boolean;
    isLastBooking?: any;
    packageCustomerService?: any;
    ticketsData?: TicketsData;
    cancelUrl?: string;
    customerPanelUrl?: string;
    infoArray?: InfoArray;
    customerBookingId?: number;
    packageCustomerId?: any;
    parentId?: any;
    amount?: number;
    gateway?: string;
    gatewayTitle?: string;
    dateTime?: string;
    data?: string;
    entity?: any;
    created?: any;
    actionsCompleted?: any;
    wcOrderId?: any;
    wcOrderUrl?: any;
    wcItemCouponValue?: any;
    wcItemTaxValue?: any;
    dayIndex?: number;
    startTime?: string;
    endTime?: string;
    timeOutList?: TimeOutList;
    periodList?: PeriodList;
    locationId?: any;
    periodServiceList?: PeriodServiceList;
    isRecurringBooking?: boolean;
    isPackageBooking?: boolean;

    constructor(data?: IBooking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : undefined as any;
            this.status = _data["status"];
            this.extras = _data["extras"] ? Extras.fromJS(_data["extras"]) : undefined as any;
            this.couponId = _data["couponId"];
            this.price = _data["price"];
            this.coupon = _data["coupon"];
            this.customFields = _data["customFields"];
            this.info = _data["info"];
            this.appointmentId = _data["appointmentId"];
            this.persons = _data["persons"];
            this.token = _data["token"];
            this.payments = _data["payments"] ? Payments.fromJS(_data["payments"]) : undefined as any;
            this.utcOffset = _data["utcOffset"];
            this.aggregatedPrice = _data["aggregatedPrice"];
            this.isChangedStatus = _data["isChangedStatus"];
            this.isLastBooking = _data["isLastBooking"];
            this.packageCustomerService = _data["packageCustomerService"];
            this.ticketsData = _data["ticketsData"] ? TicketsData.fromJS(_data["ticketsData"]) : undefined as any;
            this.cancelUrl = _data["cancelUrl"];
            this.customerPanelUrl = _data["customerPanelUrl"];
            this.infoArray = _data["infoArray"] ? InfoArray.fromJS(_data["infoArray"]) : undefined as any;
            this.customerBookingId = _data["customerBookingId"];
            this.packageCustomerId = _data["packageCustomerId"];
            this.parentId = _data["parentId"];
            this.amount = _data["amount"];
            this.gateway = _data["gateway"];
            this.gatewayTitle = _data["gatewayTitle"];
            this.dateTime = _data["dateTime"];
            this.data = _data["data"];
            this.entity = _data["entity"];
            this.created = _data["created"];
            this.actionsCompleted = _data["actionsCompleted"];
            this.wcOrderId = _data["wcOrderId"];
            this.wcOrderUrl = _data["wcOrderUrl"];
            this.wcItemCouponValue = _data["wcItemCouponValue"];
            this.wcItemTaxValue = _data["wcItemTaxValue"];
            this.dayIndex = _data["dayIndex"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.timeOutList = _data["timeOutList"] ? TimeOutList.fromJS(_data["timeOutList"]) : undefined as any;
            this.periodList = _data["periodList"] ? PeriodList.fromJS(_data["periodList"]) : undefined as any;
            this.locationId = _data["locationId"];
            this.periodServiceList = _data["periodServiceList"] ? PeriodServiceList.fromJS(_data["periodServiceList"]) : undefined as any;
            this.isRecurringBooking = _data["isRecurringBooking"];
            this.isPackageBooking = _data["isPackageBooking"];
        }
    }

    static fromJS(data: any): Booking {
        data = typeof data === 'object' ? data : {};
        let result = new Booking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["status"] = this.status;
        data["extras"] = this.extras ? this.extras.toJSON() : undefined as any;
        data["couponId"] = this.couponId;
        data["price"] = this.price;
        data["coupon"] = this.coupon;
        data["customFields"] = this.customFields;
        data["info"] = this.info;
        data["appointmentId"] = this.appointmentId;
        data["persons"] = this.persons;
        data["token"] = this.token;
        data["payments"] = this.payments ? this.payments.toJSON() : undefined as any;
        data["utcOffset"] = this.utcOffset;
        data["aggregatedPrice"] = this.aggregatedPrice;
        data["isChangedStatus"] = this.isChangedStatus;
        data["isLastBooking"] = this.isLastBooking;
        data["packageCustomerService"] = this.packageCustomerService;
        data["ticketsData"] = this.ticketsData ? this.ticketsData.toJSON() : undefined as any;
        data["cancelUrl"] = this.cancelUrl;
        data["customerPanelUrl"] = this.customerPanelUrl;
        data["infoArray"] = this.infoArray ? this.infoArray.toJSON() : undefined as any;
        data["customerBookingId"] = this.customerBookingId;
        data["packageCustomerId"] = this.packageCustomerId;
        data["parentId"] = this.parentId;
        data["amount"] = this.amount;
        data["gateway"] = this.gateway;
        data["gatewayTitle"] = this.gatewayTitle;
        data["dateTime"] = this.dateTime;
        data["data"] = this.data;
        data["entity"] = this.entity;
        data["created"] = this.created;
        data["actionsCompleted"] = this.actionsCompleted;
        data["wcOrderId"] = this.wcOrderId;
        data["wcOrderUrl"] = this.wcOrderUrl;
        data["wcItemCouponValue"] = this.wcItemCouponValue;
        data["wcItemTaxValue"] = this.wcItemTaxValue;
        data["dayIndex"] = this.dayIndex;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["timeOutList"] = this.timeOutList ? this.timeOutList.toJSON() : undefined as any;
        data["periodList"] = this.periodList ? this.periodList.toJSON() : undefined as any;
        data["locationId"] = this.locationId;
        data["periodServiceList"] = this.periodServiceList ? this.periodServiceList.toJSON() : undefined as any;
        data["isRecurringBooking"] = this.isRecurringBooking;
        data["isPackageBooking"] = this.isPackageBooking;
        return data;
    }
}

export interface IBooking {
    id?: number;
    customerId?: number;
    customer?: Customer;
    status?: string;
    extras?: Extras;
    couponId?: any;
    price?: number;
    coupon?: any;
    customFields?: any;
    info?: string;
    appointmentId?: number;
    persons?: number;
    token?: string;
    payments?: Payments;
    utcOffset?: number;
    aggregatedPrice?: boolean;
    isChangedStatus?: boolean;
    isLastBooking?: any;
    packageCustomerService?: any;
    ticketsData?: TicketsData;
    cancelUrl?: string;
    customerPanelUrl?: string;
    infoArray?: InfoArray;
    customerBookingId?: number;
    packageCustomerId?: any;
    parentId?: any;
    amount?: number;
    gateway?: string;
    gatewayTitle?: string;
    dateTime?: string;
    data?: string;
    entity?: any;
    created?: any;
    actionsCompleted?: any;
    wcOrderId?: any;
    wcOrderUrl?: any;
    wcItemCouponValue?: any;
    wcItemTaxValue?: any;
    dayIndex?: number;
    startTime?: string;
    endTime?: string;
    timeOutList?: TimeOutList;
    periodList?: PeriodList;
    locationId?: any;
    periodServiceList?: PeriodServiceList;
    isRecurringBooking?: boolean;
    isPackageBooking?: boolean;
}

export class Customer implements ICustomer {
    id?: number;
    firstName?: string;
    lastName?: string;
    birthday?: any;
    email?: string;
    phone?: string;
    type?: string;
    status?: string;
    note?: any;
    zoomUserId?: any;
    countryPhoneIso?: string;
    externalId?: any;
    pictureFullPath?: any;
    pictureThumbPath?: any;
    gender?: any;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthday = _data["birthday"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.note = _data["note"];
            this.zoomUserId = _data["zoomUserId"];
            this.countryPhoneIso = _data["countryPhoneIso"];
            this.externalId = _data["externalId"];
            this.pictureFullPath = _data["pictureFullPath"];
            this.pictureThumbPath = _data["pictureThumbPath"];
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthday"] = this.birthday;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["type"] = this.type;
        data["status"] = this.status;
        data["note"] = this.note;
        data["zoomUserId"] = this.zoomUserId;
        data["countryPhoneIso"] = this.countryPhoneIso;
        data["externalId"] = this.externalId;
        data["pictureFullPath"] = this.pictureFullPath;
        data["pictureThumbPath"] = this.pictureThumbPath;
        data["gender"] = this.gender;
        return data;
    }
}

export interface ICustomer {
    id?: number;
    firstName?: string;
    lastName?: string;
    birthday?: any;
    email?: string;
    phone?: string;
    type?: string;
    status?: string;
    note?: any;
    zoomUserId?: any;
    countryPhoneIso?: string;
    externalId?: any;
    pictureFullPath?: any;
    pictureThumbPath?: any;
    gender?: any;
}

export class Extras implements IExtras {

    constructor(data?: IExtras) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Extras {
        data = typeof data === 'object' ? data : {};
        let result = new Extras();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IExtras {
}

export class Payments implements IPayments {

    constructor(data?: IPayments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Payments {
        data = typeof data === 'object' ? data : {};
        let result = new Payments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IPayments {
}

export class TicketsData implements ITicketsData {

    constructor(data?: ITicketsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): TicketsData {
        data = typeof data === 'object' ? data : {};
        let result = new TicketsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ITicketsData {
}

export class InfoArray implements IInfoArray {
    firstName?: string;
    lastName?: string;
    phone?: string;
    locale?: string;
    timeZone?: string;
    urlParams?: any;

    constructor(data?: IInfoArray) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.locale = _data["locale"];
            this.timeZone = _data["timeZone"];
            this.urlParams = _data["urlParams"];
        }
    }

    static fromJS(data: any): InfoArray {
        data = typeof data === 'object' ? data : {};
        let result = new InfoArray();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["locale"] = this.locale;
        data["timeZone"] = this.timeZone;
        data["urlParams"] = this.urlParams;
        return data;
    }
}

export interface IInfoArray {
    firstName?: string;
    lastName?: string;
    phone?: string;
    locale?: string;
    timeZone?: string;
    urlParams?: any;
}

export class TimeOutList implements ITimeOutList {

    constructor(data?: ITimeOutList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): TimeOutList {
        data = typeof data === 'object' ? data : {};
        let result = new TimeOutList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ITimeOutList {
}

export class PeriodList implements IPeriodList {

    constructor(data?: IPeriodList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): PeriodList {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IPeriodList {
}

export class PeriodServiceList implements IPeriodServiceList {

    constructor(data?: IPeriodServiceList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): PeriodServiceList {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodServiceList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IPeriodServiceList {
}

export class Provider implements IProvider {
    id?: number;
    firstName?: string;
    lastName?: string;
    birthday?: any;
    email?: string;
    phone?: string;
    type?: string;
    status?: string;
    note?: any;
    zoomUserId?: string;
    countryPhoneIso?: string;
    externalId?: any;
    pictureFullPath?: any;
    pictureThumbPath?: any;
    weekDayList?: WeekDayList;
    serviceList?: ServiceList;
    dayOffList?: DayOffList;
    specialDayList?: SpecialDayList;
    locationId?: any;
    googleCalendar?: any;
    outlookCalendar?: any;
    translations?: any;
    timeZone?: any;

    constructor(data?: IProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthday = _data["birthday"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.note = _data["note"];
            this.zoomUserId = _data["zoomUserId"];
            this.countryPhoneIso = _data["countryPhoneIso"];
            this.externalId = _data["externalId"];
            this.pictureFullPath = _data["pictureFullPath"];
            this.pictureThumbPath = _data["pictureThumbPath"];
            this.weekDayList = _data["weekDayList"] ? WeekDayList.fromJS(_data["weekDayList"]) : undefined as any;
            this.serviceList = _data["serviceList"] ? ServiceList.fromJS(_data["serviceList"]) : undefined as any;
            this.dayOffList = _data["dayOffList"] ? DayOffList.fromJS(_data["dayOffList"]) : undefined as any;
            this.specialDayList = _data["specialDayList"] ? SpecialDayList.fromJS(_data["specialDayList"]) : undefined as any;
            this.locationId = _data["locationId"];
            this.googleCalendar = _data["googleCalendar"];
            this.outlookCalendar = _data["outlookCalendar"];
            this.translations = _data["translations"];
            this.timeZone = _data["timeZone"];
        }
    }

    static fromJS(data: any): Provider {
        data = typeof data === 'object' ? data : {};
        let result = new Provider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthday"] = this.birthday;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["type"] = this.type;
        data["status"] = this.status;
        data["note"] = this.note;
        data["zoomUserId"] = this.zoomUserId;
        data["countryPhoneIso"] = this.countryPhoneIso;
        data["externalId"] = this.externalId;
        data["pictureFullPath"] = this.pictureFullPath;
        data["pictureThumbPath"] = this.pictureThumbPath;
        data["weekDayList"] = this.weekDayList ? this.weekDayList.toJSON() : undefined as any;
        data["serviceList"] = this.serviceList ? this.serviceList.toJSON() : undefined as any;
        data["dayOffList"] = this.dayOffList ? this.dayOffList.toJSON() : undefined as any;
        data["specialDayList"] = this.specialDayList ? this.specialDayList.toJSON() : undefined as any;
        data["locationId"] = this.locationId;
        data["googleCalendar"] = this.googleCalendar;
        data["outlookCalendar"] = this.outlookCalendar;
        data["translations"] = this.translations;
        data["timeZone"] = this.timeZone;
        return data;
    }
}

export interface IProvider {
    id?: number;
    firstName?: string;
    lastName?: string;
    birthday?: any;
    email?: string;
    phone?: string;
    type?: string;
    status?: string;
    note?: any;
    zoomUserId?: string;
    countryPhoneIso?: string;
    externalId?: any;
    pictureFullPath?: any;
    pictureThumbPath?: any;
    weekDayList?: WeekDayList;
    serviceList?: ServiceList;
    dayOffList?: DayOffList;
    specialDayList?: SpecialDayList;
    locationId?: any;
    googleCalendar?: any;
    outlookCalendar?: any;
    translations?: any;
    timeZone?: any;
}

export class WeekDayList implements IWeekDayList {

    constructor(data?: IWeekDayList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): WeekDayList {
        data = typeof data === 'object' ? data : {};
        let result = new WeekDayList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IWeekDayList {
}

export class ServiceList implements IServiceList {

    constructor(data?: IServiceList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ServiceList {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IServiceList {
}

export class DayOffList implements IDayOffList {

    constructor(data?: IDayOffList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DayOffList {
        data = typeof data === 'object' ? data : {};
        let result = new DayOffList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDayOffList {
}

export class SpecialDayList implements ISpecialDayList {

    constructor(data?: ISpecialDayList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SpecialDayList {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialDayList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISpecialDayList {
}

export class Service implements IService {
    id?: number;
    name?: string;
    description?: string;
    color?: string;
    price?: number;
    deposit?: number;
    depositPayment?: string;
    depositPerPerson?: boolean;
    pictureFullPath?: string;
    pictureThumbPath?: string;
    extras?: Extras;
    coupons?: Coupons;
    position?: any;
    settings?: string;
    fullPayment?: boolean;
    minCapacity?: number;
    maxCapacity?: number;
    duration?: number;
    timeBefore?: any;
    timeAfter?: any;
    bringingAnyone?: boolean;
    show?: boolean;
    aggregatedPrice?: boolean;
    status?: string;
    categoryId?: number;
    category?: any;
    priority?: Priority;
    gallery?: Gallery;
    recurringCycle?: any;
    recurringSub?: any;
    recurringPayment?: number;
    translations?: any;
    minSelectedExtras?: any;
    mandatoryExtra?: any;

    constructor(data?: IService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.color = _data["color"];
            this.price = _data["price"];
            this.deposit = _data["deposit"];
            this.depositPayment = _data["depositPayment"];
            this.depositPerPerson = _data["depositPerPerson"];
            this.pictureFullPath = _data["pictureFullPath"];
            this.pictureThumbPath = _data["pictureThumbPath"];
            this.extras = _data["extras"] ? Extras.fromJS(_data["extras"]) : undefined as any;
            this.coupons = _data["coupons"] ? Coupons.fromJS(_data["coupons"]) : undefined as any;
            this.position = _data["position"];
            this.settings = _data["settings"];
            this.fullPayment = _data["fullPayment"];
            this.minCapacity = _data["minCapacity"];
            this.maxCapacity = _data["maxCapacity"];
            this.duration = _data["duration"];
            this.timeBefore = _data["timeBefore"];
            this.timeAfter = _data["timeAfter"];
            this.bringingAnyone = _data["bringingAnyone"];
            this.show = _data["show"];
            this.aggregatedPrice = _data["aggregatedPrice"];
            this.status = _data["status"];
            this.categoryId = _data["categoryId"];
            this.category = _data["category"];
            this.priority = _data["priority"] ? Priority.fromJS(_data["priority"]) : undefined as any;
            this.gallery = _data["gallery"] ? Gallery.fromJS(_data["gallery"]) : undefined as any;
            this.recurringCycle = _data["recurringCycle"];
            this.recurringSub = _data["recurringSub"];
            this.recurringPayment = _data["recurringPayment"];
            this.translations = _data["translations"];
            this.minSelectedExtras = _data["minSelectedExtras"];
            this.mandatoryExtra = _data["mandatoryExtra"];
        }
    }

    static fromJS(data: any): Service {
        data = typeof data === 'object' ? data : {};
        let result = new Service();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["color"] = this.color;
        data["price"] = this.price;
        data["deposit"] = this.deposit;
        data["depositPayment"] = this.depositPayment;
        data["depositPerPerson"] = this.depositPerPerson;
        data["pictureFullPath"] = this.pictureFullPath;
        data["pictureThumbPath"] = this.pictureThumbPath;
        data["extras"] = this.extras ? this.extras.toJSON() : undefined as any;
        data["coupons"] = this.coupons ? this.coupons.toJSON() : undefined as any;
        data["position"] = this.position;
        data["settings"] = this.settings;
        data["fullPayment"] = this.fullPayment;
        data["minCapacity"] = this.minCapacity;
        data["maxCapacity"] = this.maxCapacity;
        data["duration"] = this.duration;
        data["timeBefore"] = this.timeBefore;
        data["timeAfter"] = this.timeAfter;
        data["bringingAnyone"] = this.bringingAnyone;
        data["show"] = this.show;
        data["aggregatedPrice"] = this.aggregatedPrice;
        data["status"] = this.status;
        data["categoryId"] = this.categoryId;
        data["category"] = this.category;
        data["priority"] = this.priority ? this.priority.toJSON() : undefined as any;
        data["gallery"] = this.gallery ? this.gallery.toJSON() : undefined as any;
        data["recurringCycle"] = this.recurringCycle;
        data["recurringSub"] = this.recurringSub;
        data["recurringPayment"] = this.recurringPayment;
        data["translations"] = this.translations;
        data["minSelectedExtras"] = this.minSelectedExtras;
        data["mandatoryExtra"] = this.mandatoryExtra;
        return data;
    }
}

export interface IService {
    id?: number;
    name?: string;
    description?: string;
    color?: string;
    price?: number;
    deposit?: number;
    depositPayment?: string;
    depositPerPerson?: boolean;
    pictureFullPath?: string;
    pictureThumbPath?: string;
    extras?: Extras;
    coupons?: Coupons;
    position?: any;
    settings?: string;
    fullPayment?: boolean;
    minCapacity?: number;
    maxCapacity?: number;
    duration?: number;
    timeBefore?: any;
    timeAfter?: any;
    bringingAnyone?: boolean;
    show?: boolean;
    aggregatedPrice?: boolean;
    status?: string;
    categoryId?: number;
    category?: any;
    priority?: Priority;
    gallery?: Gallery;
    recurringCycle?: any;
    recurringSub?: any;
    recurringPayment?: number;
    translations?: any;
    minSelectedExtras?: any;
    mandatoryExtra?: any;
}

export class Coupons implements ICoupons {

    constructor(data?: ICoupons) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Coupons {
        data = typeof data === 'object' ? data : {};
        let result = new Coupons();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICoupons {
}

export class Priority implements IPriority {

    constructor(data?: IPriority) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Priority {
        data = typeof data === 'object' ? data : {};
        let result = new Priority();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IPriority {
}

export class Gallery implements IGallery {

    constructor(data?: IGallery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Gallery {
        data = typeof data === 'object' ? data : {};
        let result = new Gallery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGallery {
}

export class ZoomMeeting implements IZoomMeeting {
    id?: number;
    startUrl?: string;
    joinUrl?: string;

    constructor(data?: IZoomMeeting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startUrl = _data["startUrl"];
            this.joinUrl = _data["joinUrl"];
        }
    }

    static fromJS(data: any): ZoomMeeting {
        data = typeof data === 'object' ? data : {};
        let result = new ZoomMeeting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startUrl"] = this.startUrl;
        data["joinUrl"] = this.joinUrl;
        return data;
    }
}

export interface IZoomMeeting {
    id?: number;
    startUrl?: string;
    joinUrl?: string;
}

export class AmeliaEventBookingCompletePostModel implements IAmeliaEventBookingCompletePostModel {
    event?: Event;
    bookings?: Bookings2;

    constructor(data?: IAmeliaEventBookingCompletePostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.event = _data["event"] ? Event.fromJS(_data["event"]) : undefined as any;
            this.bookings = _data["bookings"] ? Bookings2.fromJS(_data["bookings"]) : undefined as any;
        }
    }

    static fromJS(data: any): AmeliaEventBookingCompletePostModel {
        data = typeof data === 'object' ? data : {};
        let result = new AmeliaEventBookingCompletePostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event ? this.event.toJSON() : undefined as any;
        data["bookings"] = this.bookings ? this.bookings.toJSON() : undefined as any;
        return data;
    }
}

export interface IAmeliaEventBookingCompletePostModel {
    event?: Event;
    bookings?: Bookings2;
}

export class Event implements IEvent {
    id?: number;
    name?: string;
    description?: string;
    color?: string;
    price?: number;
    deposit?: number;
    depositPayment?: string;
    depositPerPerson?: boolean;
    pictureFullPath?: any;
    pictureThumbPath?: any;
    extras?: Extras2;
    coupons?: Coupons2;
    position?: any;
    settings?: string;
    fullPayment?: boolean;
    bookings?: Bookings2;
    periods?: Periods;
    bookingOpens?: any;
    bookingCloses?: any;
    bookingOpensRec?: any;
    bookingClosesRec?: any;
    ticketRangeRec?: any;
    status?: string;
    recurring?: any;
    maxCapacity?: number;
    maxCustomCapacity?: any;
    show?: boolean;
    tags?: Tags;
    customTickets?: CustomTickets;
    gallery?: Gallery2;
    providers?: Providers;
    notifyParticipants?: number;
    locationId?: any;
    location?: any;
    customLocation?: any;
    parentId?: any;
    created?: string;
    zoomUserId?: any;
    organizerId?: number;
    type?: string;
    bringingAnyone?: boolean;
    bookMultipleTimes?: boolean;
    translations?: any;
    customPricing?: boolean;

    constructor(data?: IEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.color = _data["color"];
            this.price = _data["price"];
            this.deposit = _data["deposit"];
            this.depositPayment = _data["depositPayment"];
            this.depositPerPerson = _data["depositPerPerson"];
            this.pictureFullPath = _data["pictureFullPath"];
            this.pictureThumbPath = _data["pictureThumbPath"];
            this.extras = _data["extras"] ? Extras2.fromJS(_data["extras"]) : undefined as any;
            this.coupons = _data["coupons"] ? Coupons2.fromJS(_data["coupons"]) : undefined as any;
            this.position = _data["position"];
            this.settings = _data["settings"];
            this.fullPayment = _data["fullPayment"];
            this.bookings = _data["bookings"] ? Bookings2.fromJS(_data["bookings"]) : undefined as any;
            this.periods = _data["periods"] ? Periods.fromJS(_data["periods"]) : undefined as any;
            this.bookingOpens = _data["bookingOpens"];
            this.bookingCloses = _data["bookingCloses"];
            this.bookingOpensRec = _data["bookingOpensRec"];
            this.bookingClosesRec = _data["bookingClosesRec"];
            this.ticketRangeRec = _data["ticketRangeRec"];
            this.status = _data["status"];
            this.recurring = _data["recurring"];
            this.maxCapacity = _data["maxCapacity"];
            this.maxCustomCapacity = _data["maxCustomCapacity"];
            this.show = _data["show"];
            this.tags = _data["tags"] ? Tags.fromJS(_data["tags"]) : undefined as any;
            this.customTickets = _data["customTickets"] ? CustomTickets.fromJS(_data["customTickets"]) : undefined as any;
            this.gallery = _data["gallery"] ? Gallery2.fromJS(_data["gallery"]) : undefined as any;
            this.providers = _data["providers"] ? Providers.fromJS(_data["providers"]) : undefined as any;
            this.notifyParticipants = _data["notifyParticipants"];
            this.locationId = _data["locationId"];
            this.location = _data["location"];
            this.customLocation = _data["customLocation"];
            this.parentId = _data["parentId"];
            this.created = _data["created"];
            this.zoomUserId = _data["zoomUserId"];
            this.organizerId = _data["organizerId"];
            this.type = _data["type"];
            this.bringingAnyone = _data["bringingAnyone"];
            this.bookMultipleTimes = _data["bookMultipleTimes"];
            this.translations = _data["translations"];
            this.customPricing = _data["customPricing"];
        }
    }

    static fromJS(data: any): Event {
        data = typeof data === 'object' ? data : {};
        let result = new Event();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["color"] = this.color;
        data["price"] = this.price;
        data["deposit"] = this.deposit;
        data["depositPayment"] = this.depositPayment;
        data["depositPerPerson"] = this.depositPerPerson;
        data["pictureFullPath"] = this.pictureFullPath;
        data["pictureThumbPath"] = this.pictureThumbPath;
        data["extras"] = this.extras ? this.extras.toJSON() : undefined as any;
        data["coupons"] = this.coupons ? this.coupons.toJSON() : undefined as any;
        data["position"] = this.position;
        data["settings"] = this.settings;
        data["fullPayment"] = this.fullPayment;
        data["bookings"] = this.bookings ? this.bookings.toJSON() : undefined as any;
        data["periods"] = this.periods ? this.periods.toJSON() : undefined as any;
        data["bookingOpens"] = this.bookingOpens;
        data["bookingCloses"] = this.bookingCloses;
        data["bookingOpensRec"] = this.bookingOpensRec;
        data["bookingClosesRec"] = this.bookingClosesRec;
        data["ticketRangeRec"] = this.ticketRangeRec;
        data["status"] = this.status;
        data["recurring"] = this.recurring;
        data["maxCapacity"] = this.maxCapacity;
        data["maxCustomCapacity"] = this.maxCustomCapacity;
        data["show"] = this.show;
        data["tags"] = this.tags ? this.tags.toJSON() : undefined as any;
        data["customTickets"] = this.customTickets ? this.customTickets.toJSON() : undefined as any;
        data["gallery"] = this.gallery ? this.gallery.toJSON() : undefined as any;
        data["providers"] = this.providers ? this.providers.toJSON() : undefined as any;
        data["notifyParticipants"] = this.notifyParticipants;
        data["locationId"] = this.locationId;
        data["location"] = this.location;
        data["customLocation"] = this.customLocation;
        data["parentId"] = this.parentId;
        data["created"] = this.created;
        data["zoomUserId"] = this.zoomUserId;
        data["organizerId"] = this.organizerId;
        data["type"] = this.type;
        data["bringingAnyone"] = this.bringingAnyone;
        data["bookMultipleTimes"] = this.bookMultipleTimes;
        data["translations"] = this.translations;
        data["customPricing"] = this.customPricing;
        return data;
    }
}

export interface IEvent {
    id?: number;
    name?: string;
    description?: string;
    color?: string;
    price?: number;
    deposit?: number;
    depositPayment?: string;
    depositPerPerson?: boolean;
    pictureFullPath?: any;
    pictureThumbPath?: any;
    extras?: Extras2;
    coupons?: Coupons2;
    position?: any;
    settings?: string;
    fullPayment?: boolean;
    bookings?: Bookings2;
    periods?: Periods;
    bookingOpens?: any;
    bookingCloses?: any;
    bookingOpensRec?: any;
    bookingClosesRec?: any;
    ticketRangeRec?: any;
    status?: string;
    recurring?: any;
    maxCapacity?: number;
    maxCustomCapacity?: any;
    show?: boolean;
    tags?: Tags;
    customTickets?: CustomTickets;
    gallery?: Gallery2;
    providers?: Providers;
    notifyParticipants?: number;
    locationId?: any;
    location?: any;
    customLocation?: any;
    parentId?: any;
    created?: string;
    zoomUserId?: any;
    organizerId?: number;
    type?: string;
    bringingAnyone?: boolean;
    bookMultipleTimes?: boolean;
    translations?: any;
    customPricing?: boolean;
}

export class Extras2 implements IExtras2 {

    constructor(data?: IExtras2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Extras2 {
        data = typeof data === 'object' ? data : {};
        let result = new Extras2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IExtras2 {
}

export class Coupons2 implements ICoupons2 {

    constructor(data?: ICoupons2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Coupons2 {
        data = typeof data === 'object' ? data : {};
        let result = new Coupons2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICoupons2 {
}

export class Bookings2 implements IBookings2 {
    _0?: EventBooking;

    constructor(data?: IBookings2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._0 = _data["0"] ? EventBooking.fromJS(_data["0"]) : undefined as any;
        }
    }

    static fromJS(data: any): Bookings2 {
        data = typeof data === 'object' ? data : {};
        let result = new Bookings2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["0"] = this._0 ? this._0.toJSON() : undefined as any;
        return data;
    }
}

export interface IBookings2 {
    _0?: EventBooking;
}

export class EventBooking implements IEventBooking {
    id?: number;
    customerId?: number;
    customer?: Customer2;
    status?: string;
    extras?: Extras2;
    couponId?: any;
    price?: number;
    coupon?: any;
    customFields?: any;
    info?: string;
    appointmentId?: any;
    persons?: number;
    token?: string;
    payments?: Payments2;
    utcOffset?: number;
    aggregatedPrice?: boolean;
    isChangedStatus?: boolean;
    isLastBooking?: any;
    packageCustomerService?: any;
    ticketsData?: TicketsData2;
    cancelUrl?: string;
    customerPanelUrl?: string;
    infoArray?: InfoArray2;
    customerBookingId?: number;
    packageCustomerId?: any;
    parentId?: any;
    amount?: number;
    gateway?: string;
    gatewayTitle?: string;
    dateTime?: string;
    data?: string;
    entity?: any;
    created?: any;
    actionsCompleted?: any;
    wcOrderId?: any;
    wcOrderUrl?: any;
    wcItemCouponValue?: any;
    wcItemTaxValue?: any;
    eventId?: number;
    periodStart?: string;
    periodEnd?: string;
    zoomMeeting?: any;
    lessonSpace?: any;
    bookings?: Bookings2;
    googleCalendarEventId?: any;
    googleMeetUrl?: any;
    outlookCalendarEventId?: string;
    entityId?: number;
    entityType?: string;
    pictureFullPath?: string;
    pictureThumbPath?: string;
    position?: number;
    firstName?: string;
    lastName?: string;
    birthday?: any;
    email?: string;
    phone?: string;
    type?: string;
    note?: any;
    zoomUserId?: any;
    countryPhoneIso?: any;
    externalId?: any;
    weekDayList?: WeekDayList2;
    serviceList?: ServiceList2;
    dayOffList?: DayOffList2;
    specialDayList?: SpecialDayList2;
    locationId?: any;
    googleCalendar?: any;
    outlookCalendar?: any;
    translations?: any;
    timeZone?: any;
    isRecurringBooking?: boolean;
    isPackageBooking?: boolean;

    constructor(data?: IEventBooking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer2.fromJS(_data["customer"]) : undefined as any;
            this.status = _data["status"];
            this.extras = _data["extras"] ? Extras2.fromJS(_data["extras"]) : undefined as any;
            this.couponId = _data["couponId"];
            this.price = _data["price"];
            this.coupon = _data["coupon"];
            this.customFields = _data["customFields"];
            this.info = _data["info"];
            this.appointmentId = _data["appointmentId"];
            this.persons = _data["persons"];
            this.token = _data["token"];
            this.payments = _data["payments"] ? Payments2.fromJS(_data["payments"]) : undefined as any;
            this.utcOffset = _data["utcOffset"];
            this.aggregatedPrice = _data["aggregatedPrice"];
            this.isChangedStatus = _data["isChangedStatus"];
            this.isLastBooking = _data["isLastBooking"];
            this.packageCustomerService = _data["packageCustomerService"];
            this.ticketsData = _data["ticketsData"] ? TicketsData2.fromJS(_data["ticketsData"]) : undefined as any;
            this.cancelUrl = _data["cancelUrl"];
            this.customerPanelUrl = _data["customerPanelUrl"];
            this.infoArray = _data["infoArray"] ? InfoArray2.fromJS(_data["infoArray"]) : undefined as any;
            this.customerBookingId = _data["customerBookingId"];
            this.packageCustomerId = _data["packageCustomerId"];
            this.parentId = _data["parentId"];
            this.amount = _data["amount"];
            this.gateway = _data["gateway"];
            this.gatewayTitle = _data["gatewayTitle"];
            this.dateTime = _data["dateTime"];
            this.data = _data["data"];
            this.entity = _data["entity"];
            this.created = _data["created"];
            this.actionsCompleted = _data["actionsCompleted"];
            this.wcOrderId = _data["wcOrderId"];
            this.wcOrderUrl = _data["wcOrderUrl"];
            this.wcItemCouponValue = _data["wcItemCouponValue"];
            this.wcItemTaxValue = _data["wcItemTaxValue"];
            this.eventId = _data["eventId"];
            this.periodStart = _data["periodStart"];
            this.periodEnd = _data["periodEnd"];
            this.zoomMeeting = _data["zoomMeeting"];
            this.lessonSpace = _data["lessonSpace"];
            this.bookings = _data["bookings"] ? Bookings2.fromJS(_data["bookings"]) : undefined as any;
            this.googleCalendarEventId = _data["googleCalendarEventId"];
            this.googleMeetUrl = _data["googleMeetUrl"];
            this.outlookCalendarEventId = _data["outlookCalendarEventId"];
            this.entityId = _data["entityId"];
            this.entityType = _data["entityType"];
            this.pictureFullPath = _data["pictureFullPath"];
            this.pictureThumbPath = _data["pictureThumbPath"];
            this.position = _data["position"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthday = _data["birthday"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.type = _data["type"];
            this.note = _data["note"];
            this.zoomUserId = _data["zoomUserId"];
            this.countryPhoneIso = _data["countryPhoneIso"];
            this.externalId = _data["externalId"];
            this.weekDayList = _data["weekDayList"] ? WeekDayList2.fromJS(_data["weekDayList"]) : undefined as any;
            this.serviceList = _data["serviceList"] ? ServiceList2.fromJS(_data["serviceList"]) : undefined as any;
            this.dayOffList = _data["dayOffList"] ? DayOffList2.fromJS(_data["dayOffList"]) : undefined as any;
            this.specialDayList = _data["specialDayList"] ? SpecialDayList2.fromJS(_data["specialDayList"]) : undefined as any;
            this.locationId = _data["locationId"];
            this.googleCalendar = _data["googleCalendar"];
            this.outlookCalendar = _data["outlookCalendar"];
            this.translations = _data["translations"];
            this.timeZone = _data["timeZone"];
            this.isRecurringBooking = _data["isRecurringBooking"];
            this.isPackageBooking = _data["isPackageBooking"];
        }
    }

    static fromJS(data: any): EventBooking {
        data = typeof data === 'object' ? data : {};
        let result = new EventBooking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["status"] = this.status;
        data["extras"] = this.extras ? this.extras.toJSON() : undefined as any;
        data["couponId"] = this.couponId;
        data["price"] = this.price;
        data["coupon"] = this.coupon;
        data["customFields"] = this.customFields;
        data["info"] = this.info;
        data["appointmentId"] = this.appointmentId;
        data["persons"] = this.persons;
        data["token"] = this.token;
        data["payments"] = this.payments ? this.payments.toJSON() : undefined as any;
        data["utcOffset"] = this.utcOffset;
        data["aggregatedPrice"] = this.aggregatedPrice;
        data["isChangedStatus"] = this.isChangedStatus;
        data["isLastBooking"] = this.isLastBooking;
        data["packageCustomerService"] = this.packageCustomerService;
        data["ticketsData"] = this.ticketsData ? this.ticketsData.toJSON() : undefined as any;
        data["cancelUrl"] = this.cancelUrl;
        data["customerPanelUrl"] = this.customerPanelUrl;
        data["infoArray"] = this.infoArray ? this.infoArray.toJSON() : undefined as any;
        data["customerBookingId"] = this.customerBookingId;
        data["packageCustomerId"] = this.packageCustomerId;
        data["parentId"] = this.parentId;
        data["amount"] = this.amount;
        data["gateway"] = this.gateway;
        data["gatewayTitle"] = this.gatewayTitle;
        data["dateTime"] = this.dateTime;
        data["data"] = this.data;
        data["entity"] = this.entity;
        data["created"] = this.created;
        data["actionsCompleted"] = this.actionsCompleted;
        data["wcOrderId"] = this.wcOrderId;
        data["wcOrderUrl"] = this.wcOrderUrl;
        data["wcItemCouponValue"] = this.wcItemCouponValue;
        data["wcItemTaxValue"] = this.wcItemTaxValue;
        data["eventId"] = this.eventId;
        data["periodStart"] = this.periodStart;
        data["periodEnd"] = this.periodEnd;
        data["zoomMeeting"] = this.zoomMeeting;
        data["lessonSpace"] = this.lessonSpace;
        data["bookings"] = this.bookings ? this.bookings.toJSON() : undefined as any;
        data["googleCalendarEventId"] = this.googleCalendarEventId;
        data["googleMeetUrl"] = this.googleMeetUrl;
        data["outlookCalendarEventId"] = this.outlookCalendarEventId;
        data["entityId"] = this.entityId;
        data["entityType"] = this.entityType;
        data["pictureFullPath"] = this.pictureFullPath;
        data["pictureThumbPath"] = this.pictureThumbPath;
        data["position"] = this.position;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthday"] = this.birthday;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["type"] = this.type;
        data["note"] = this.note;
        data["zoomUserId"] = this.zoomUserId;
        data["countryPhoneIso"] = this.countryPhoneIso;
        data["externalId"] = this.externalId;
        data["weekDayList"] = this.weekDayList ? this.weekDayList.toJSON() : undefined as any;
        data["serviceList"] = this.serviceList ? this.serviceList.toJSON() : undefined as any;
        data["dayOffList"] = this.dayOffList ? this.dayOffList.toJSON() : undefined as any;
        data["specialDayList"] = this.specialDayList ? this.specialDayList.toJSON() : undefined as any;
        data["locationId"] = this.locationId;
        data["googleCalendar"] = this.googleCalendar;
        data["outlookCalendar"] = this.outlookCalendar;
        data["translations"] = this.translations;
        data["timeZone"] = this.timeZone;
        data["isRecurringBooking"] = this.isRecurringBooking;
        data["isPackageBooking"] = this.isPackageBooking;
        return data;
    }
}

export interface IEventBooking {
    id?: number;
    customerId?: number;
    customer?: Customer2;
    status?: string;
    extras?: Extras2;
    couponId?: any;
    price?: number;
    coupon?: any;
    customFields?: any;
    info?: string;
    appointmentId?: any;
    persons?: number;
    token?: string;
    payments?: Payments2;
    utcOffset?: number;
    aggregatedPrice?: boolean;
    isChangedStatus?: boolean;
    isLastBooking?: any;
    packageCustomerService?: any;
    ticketsData?: TicketsData2;
    cancelUrl?: string;
    customerPanelUrl?: string;
    infoArray?: InfoArray2;
    customerBookingId?: number;
    packageCustomerId?: any;
    parentId?: any;
    amount?: number;
    gateway?: string;
    gatewayTitle?: string;
    dateTime?: string;
    data?: string;
    entity?: any;
    created?: any;
    actionsCompleted?: any;
    wcOrderId?: any;
    wcOrderUrl?: any;
    wcItemCouponValue?: any;
    wcItemTaxValue?: any;
    eventId?: number;
    periodStart?: string;
    periodEnd?: string;
    zoomMeeting?: any;
    lessonSpace?: any;
    bookings?: Bookings2;
    googleCalendarEventId?: any;
    googleMeetUrl?: any;
    outlookCalendarEventId?: string;
    entityId?: number;
    entityType?: string;
    pictureFullPath?: string;
    pictureThumbPath?: string;
    position?: number;
    firstName?: string;
    lastName?: string;
    birthday?: any;
    email?: string;
    phone?: string;
    type?: string;
    note?: any;
    zoomUserId?: any;
    countryPhoneIso?: any;
    externalId?: any;
    weekDayList?: WeekDayList2;
    serviceList?: ServiceList2;
    dayOffList?: DayOffList2;
    specialDayList?: SpecialDayList2;
    locationId?: any;
    googleCalendar?: any;
    outlookCalendar?: any;
    translations?: any;
    timeZone?: any;
    isRecurringBooking?: boolean;
    isPackageBooking?: boolean;
}

export class Customer2 implements ICustomer2 {
    id?: number;
    firstName?: string;
    lastName?: string;
    birthday?: any;
    email?: string;
    phone?: string;
    type?: string;
    status?: any;
    note?: any;
    zoomUserId?: any;
    countryPhoneIso?: any;
    externalId?: any;
    pictureFullPath?: any;
    pictureThumbPath?: any;
    gender?: any;

    constructor(data?: ICustomer2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthday = _data["birthday"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.note = _data["note"];
            this.zoomUserId = _data["zoomUserId"];
            this.countryPhoneIso = _data["countryPhoneIso"];
            this.externalId = _data["externalId"];
            this.pictureFullPath = _data["pictureFullPath"];
            this.pictureThumbPath = _data["pictureThumbPath"];
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): Customer2 {
        data = typeof data === 'object' ? data : {};
        let result = new Customer2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthday"] = this.birthday;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["type"] = this.type;
        data["status"] = this.status;
        data["note"] = this.note;
        data["zoomUserId"] = this.zoomUserId;
        data["countryPhoneIso"] = this.countryPhoneIso;
        data["externalId"] = this.externalId;
        data["pictureFullPath"] = this.pictureFullPath;
        data["pictureThumbPath"] = this.pictureThumbPath;
        data["gender"] = this.gender;
        return data;
    }
}

export interface ICustomer2 {
    id?: number;
    firstName?: string;
    lastName?: string;
    birthday?: any;
    email?: string;
    phone?: string;
    type?: string;
    status?: any;
    note?: any;
    zoomUserId?: any;
    countryPhoneIso?: any;
    externalId?: any;
    pictureFullPath?: any;
    pictureThumbPath?: any;
    gender?: any;
}

export class Payments2 implements IPayments2 {

    constructor(data?: IPayments2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Payments2 {
        data = typeof data === 'object' ? data : {};
        let result = new Payments2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IPayments2 {
}

export class TicketsData2 implements ITicketsData2 {

    constructor(data?: ITicketsData2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): TicketsData2 {
        data = typeof data === 'object' ? data : {};
        let result = new TicketsData2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ITicketsData2 {
}

export class InfoArray2 implements IInfoArray2 {
    firstName?: string;
    lastName?: string;
    phone?: string;
    locale?: string;
    timeZone?: string;
    urlParams?: any;

    constructor(data?: IInfoArray2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.locale = _data["locale"];
            this.timeZone = _data["timeZone"];
            this.urlParams = _data["urlParams"];
        }
    }

    static fromJS(data: any): InfoArray2 {
        data = typeof data === 'object' ? data : {};
        let result = new InfoArray2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["locale"] = this.locale;
        data["timeZone"] = this.timeZone;
        data["urlParams"] = this.urlParams;
        return data;
    }
}

export interface IInfoArray2 {
    firstName?: string;
    lastName?: string;
    phone?: string;
    locale?: string;
    timeZone?: string;
    urlParams?: any;
}

export class WeekDayList2 implements IWeekDayList2 {

    constructor(data?: IWeekDayList2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): WeekDayList2 {
        data = typeof data === 'object' ? data : {};
        let result = new WeekDayList2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IWeekDayList2 {
}

export class ServiceList2 implements IServiceList2 {

    constructor(data?: IServiceList2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ServiceList2 {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceList2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IServiceList2 {
}

export class DayOffList2 implements IDayOffList2 {

    constructor(data?: IDayOffList2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DayOffList2 {
        data = typeof data === 'object' ? data : {};
        let result = new DayOffList2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDayOffList2 {
}

export class SpecialDayList2 implements ISpecialDayList2 {

    constructor(data?: ISpecialDayList2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SpecialDayList2 {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialDayList2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISpecialDayList2 {
}

export class Periods implements IPeriods {

    constructor(data?: IPeriods) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Periods {
        data = typeof data === 'object' ? data : {};
        let result = new Periods();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IPeriods {
}

export class Tags implements ITags {

    constructor(data?: ITags) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Tags {
        data = typeof data === 'object' ? data : {};
        let result = new Tags();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ITags {
}

export class CustomTickets implements ICustomTickets {

    constructor(data?: ICustomTickets) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CustomTickets {
        data = typeof data === 'object' ? data : {};
        let result = new CustomTickets();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICustomTickets {
}

export class Gallery2 implements IGallery2 {

    constructor(data?: IGallery2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Gallery2 {
        data = typeof data === 'object' ? data : {};
        let result = new Gallery2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGallery2 {
}

export class Providers implements IProviders {

    constructor(data?: IProviders) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Providers {
        data = typeof data === 'object' ? data : {};
        let result = new Providers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IProviders {
}

export class ContactResponseModel implements IContactResponseModel {
    id?: number;
    userInfo?: UserModel;
    contactType?: ContactType;
    privateEmail?: string;
    confirmed?: boolean | undefined;

    constructor(data?: IContactResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userInfo = _data["userInfo"] ? UserModel.fromJS(_data["userInfo"]) : undefined as any;
            this.contactType = _data["contactType"];
            this.privateEmail = _data["privateEmail"];
            this.confirmed = _data["confirmed"];
        }
    }

    static fromJS(data: any): ContactResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userInfo"] = this.userInfo ? this.userInfo.toJSON() : undefined as any;
        data["contactType"] = this.contactType;
        data["privateEmail"] = this.privateEmail;
        data["confirmed"] = this.confirmed;
        return data;
    }
}

export interface IContactResponseModel {
    id?: number;
    userInfo?: UserModel;
    contactType?: ContactType;
    privateEmail?: string;
    confirmed?: boolean | undefined;
}

export class UserModel implements IUserModel {
    id?: string;
    displayName?: string;
    givenName?: string;
    surname?: string;
    userPrincipalName?: string;
    privateEmail?: string;

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.givenName = _data["givenName"];
            this.surname = _data["surname"];
            this.userPrincipalName = _data["userPrincipalName"];
            this.privateEmail = _data["privateEmail"];
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["givenName"] = this.givenName;
        data["surname"] = this.surname;
        data["userPrincipalName"] = this.userPrincipalName;
        data["privateEmail"] = this.privateEmail;
        return data;
    }
}

export interface IUserModel {
    id?: string;
    displayName?: string;
    givenName?: string;
    surname?: string;
    userPrincipalName?: string;
    privateEmail?: string;
}

export enum ContactType {
    MyOrganization = 0,
    External = 1,
}

export class PendingInvitationResponseModel implements IPendingInvitationResponseModel {
    contactId?: number;
    userInfo?: UserModel;

    constructor(data?: IPendingInvitationResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.userInfo = _data["userInfo"] ? UserModel.fromJS(_data["userInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): PendingInvitationResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PendingInvitationResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["userInfo"] = this.userInfo ? this.userInfo.toJSON() : undefined as any;
        return data;
    }
}

export interface IPendingInvitationResponseModel {
    contactId?: number;
    userInfo?: UserModel;
}

export class AddContactResponseModel implements IAddContactResponseModel {
    sentInvitation?: boolean;
    acceptedAutomatically?: boolean;

    constructor(data?: IAddContactResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sentInvitation = _data["sentInvitation"];
            this.acceptedAutomatically = _data["acceptedAutomatically"];
        }
    }

    static fromJS(data: any): AddContactResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddContactResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sentInvitation"] = this.sentInvitation;
        data["acceptedAutomatically"] = this.acceptedAutomatically;
        return data;
    }
}

export interface IAddContactResponseModel {
    sentInvitation?: boolean;
    acceptedAutomatically?: boolean;
}

export class CreateContactPostModel implements ICreateContactPostModel {
    emailOrUserPrincipalName!: string;

    constructor(data?: ICreateContactPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailOrUserPrincipalName = _data["emailOrUserPrincipalName"];
        }
    }

    static fromJS(data: any): CreateContactPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContactPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailOrUserPrincipalName"] = this.emailOrUserPrincipalName;
        return data;
    }
}

export interface ICreateContactPostModel {
    emailOrUserPrincipalName: string;
}

export class UserResponseModel implements IUserResponseModel {
    id?: string;
    givenName?: string;
    surname?: string;
    displayName?: string;
    userPrincipalName?: string;
    email?: string;
    createdAtUtc?: Date | undefined;
    confirmedEmailAtUtc?: Date | undefined;

    constructor(data?: IUserResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.givenName = _data["givenName"];
            this.surname = _data["surname"];
            this.displayName = _data["displayName"];
            this.userPrincipalName = _data["userPrincipalName"];
            this.email = _data["email"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : undefined as any;
            this.confirmedEmailAtUtc = _data["confirmedEmailAtUtc"] ? new Date(_data["confirmedEmailAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["givenName"] = this.givenName;
        data["surname"] = this.surname;
        data["displayName"] = this.displayName;
        data["userPrincipalName"] = this.userPrincipalName;
        data["email"] = this.email;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined as any;
        data["confirmedEmailAtUtc"] = this.confirmedEmailAtUtc ? this.confirmedEmailAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IUserResponseModel {
    id?: string;
    givenName?: string;
    surname?: string;
    displayName?: string;
    userPrincipalName?: string;
    email?: string;
    createdAtUtc?: Date | undefined;
    confirmedEmailAtUtc?: Date | undefined;
}

export class AcceptInvitePostModel implements IAcceptInvitePostModel {
    invitationCode!: string;

    constructor(data?: IAcceptInvitePostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invitationCode = _data["invitationCode"];
        }
    }

    static fromJS(data: any): AcceptInvitePostModel {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptInvitePostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitationCode"] = this.invitationCode;
        return data;
    }
}

export interface IAcceptInvitePostModel {
    invitationCode: string;
}

export class CallbackModelBase implements ICallbackModelBase {
    jobId?: number;
    flowsheetDriveId?: string | undefined;
    flowsheetItemId?: string | undefined;
    flowsheetVersion?: string | undefined;

    constructor(data?: ICallbackModelBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.flowsheetDriveId = _data["flowsheetDriveId"];
            this.flowsheetItemId = _data["flowsheetItemId"];
            this.flowsheetVersion = _data["flowsheetVersion"];
        }
    }

    static fromJS(data: any): CallbackModelBase {
        data = typeof data === 'object' ? data : {};
        let result = new CallbackModelBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["flowsheetDriveId"] = this.flowsheetDriveId;
        data["flowsheetItemId"] = this.flowsheetItemId;
        data["flowsheetVersion"] = this.flowsheetVersion;
        return data;
    }
}

export interface ICallbackModelBase {
    jobId?: number;
    flowsheetDriveId?: string | undefined;
    flowsheetItemId?: string | undefined;
    flowsheetVersion?: string | undefined;
}

export class AnalysisCompletedCallbackModel extends CallbackModelBase implements IAnalysisCompletedCallbackModel {

    constructor(data?: IAnalysisCompletedCallbackModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AnalysisCompletedCallbackModel {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisCompletedCallbackModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAnalysisCompletedCallbackModel extends ICallbackModelBase {
}

export class AnalysisFailedCallbackModel extends CallbackModelBase implements IAnalysisFailedCallbackModel {
    errorMessage?: string | undefined;

    constructor(data?: IAnalysisFailedCallbackModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.errorMessage = _data["errorMessage"];
        }
    }

    static override fromJS(data: any): AnalysisFailedCallbackModel {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisFailedCallbackModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        super.toJSON(data);
        return data;
    }
}

export interface IAnalysisFailedCallbackModel extends ICallbackModelBase {
    errorMessage?: string | undefined;
}

export class DownloadFilesResponseModel implements IDownloadFilesResponseModel {
    requestId?: string;

    constructor(data?: IDownloadFilesResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): DownloadFilesResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadFilesResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        return data;
    }
}

export interface IDownloadFilesResponseModel {
    requestId?: string;
}

export class DownloadFilesPostModel implements IDownloadFilesPostModel {
    items?: DownloadItemModel[];

    constructor(data?: IDownloadFilesPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DownloadItemModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadFilesPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadFilesPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDownloadFilesPostModel {
    items?: DownloadItemModel[];
}

export class DownloadItemModel implements IDownloadItemModel {
    uniqueIdentifier!: string;
    isFolder!: boolean;

    constructor(data?: IDownloadItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueIdentifier = _data["uniqueIdentifier"];
            this.isFolder = _data["isFolder"];
        }
    }

    static fromJS(data: any): DownloadItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueIdentifier"] = this.uniqueIdentifier;
        data["isFolder"] = this.isFolder;
        return data;
    }
}

export interface IDownloadItemModel {
    uniqueIdentifier: string;
    isFolder: boolean;
}

export class DownloadFilesZipStatusResponse implements IDownloadFilesZipStatusResponse {
    requestId?: string;
    status?: GenerateZipStatus;
    totalCount?: number;
    finishedCount?: number;
    errorMessage?: string;

    constructor(data?: IDownloadFilesZipStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.status = _data["status"];
            this.totalCount = _data["totalCount"];
            this.finishedCount = _data["finishedCount"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): DownloadFilesZipStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadFilesZipStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["status"] = this.status;
        data["totalCount"] = this.totalCount;
        data["finishedCount"] = this.finishedCount;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IDownloadFilesZipStatusResponse {
    requestId?: string;
    status?: GenerateZipStatus;
    totalCount?: number;
    finishedCount?: number;
    errorMessage?: string;
}

export enum GenerateZipStatus {
    Pending = 0,
    InProgress = 1,
    Finished = 2,
    Failed = 3,
}

export class CreateStartupActionPostModel implements ICreateStartupActionPostModel {
    actions?: DwsimProAction[];

    constructor(data?: ICreateStartupActionPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(DwsimProAction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateStartupActionPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStartupActionPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateStartupActionPostModel {
    actions?: DwsimProAction[];
}

export class DwsimProAction implements IDwsimProAction {
    action?: string;
    data?: { [key: string]: string; };

    constructor(data?: IDwsimProAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (this.data as any)![key] = _data["data"][key];
                }
            }
        }
    }

    static fromJS(data: any): DwsimProAction {
        data = typeof data === 'object' ? data : {};
        let result = new DwsimProAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (data["data"] as any)[key] = (this.data as any)[key];
            }
        }
        return data;
    }
}

export interface IDwsimProAction {
    action?: string;
    data?: { [key: string]: string; };
}

export class DwsimProActionResponseModel implements IDwsimProActionResponseModel {
    actionId?: number;
    actions?: string;

    constructor(data?: IDwsimProActionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionId = _data["actionId"];
            this.actions = _data["actions"];
        }
    }

    static fromJS(data: any): DwsimProActionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DwsimProActionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionId"] = this.actionId;
        data["actions"] = this.actions;
        return data;
    }
}

export interface IDwsimProActionResponseModel {
    actionId?: number;
    actions?: string;
}

export class FileMetadataFieldResponseModel implements IFileMetadataFieldResponseModel {
    key?: string;
    value?: string;

    constructor(data?: IFileMetadataFieldResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FileMetadataFieldResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileMetadataFieldResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IFileMetadataFieldResponseModel {
    key?: string;
    value?: string;
}

export class UpdateLocallyOpenedFilesPostModel implements IUpdateLocallyOpenedFilesPostModel {
    files?: string[];

    constructor(data?: IUpdateLocallyOpenedFilesPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateLocallyOpenedFilesPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLocallyOpenedFilesPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item);
        }
        return data;
    }
}

export interface IUpdateLocallyOpenedFilesPostModel {
    files?: string[];
}

export class SuggestDocumentNameResponseModel implements ISuggestDocumentNameResponseModel {
    name?: string;

    constructor(data?: ISuggestDocumentNameResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SuggestDocumentNameResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestDocumentNameResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ISuggestDocumentNameResponseModel {
    name?: string;
}

export class SuggestDocumentNamePostModel implements ISuggestDocumentNamePostModel {
    sourceUniqueId!: string;
    destinationDirectoryUniqueId?: string | undefined;
    fileSystemEntityType!: FileSystemEntityType;

    constructor(data?: ISuggestDocumentNamePostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceUniqueId = _data["sourceUniqueId"];
            this.destinationDirectoryUniqueId = _data["destinationDirectoryUniqueId"];
            this.fileSystemEntityType = _data["fileSystemEntityType"];
        }
    }

    static fromJS(data: any): SuggestDocumentNamePostModel {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestDocumentNamePostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceUniqueId"] = this.sourceUniqueId;
        data["destinationDirectoryUniqueId"] = this.destinationDirectoryUniqueId;
        data["fileSystemEntityType"] = this.fileSystemEntityType;
        return data;
    }
}

export interface ISuggestDocumentNamePostModel {
    sourceUniqueId: string;
    destinationDirectoryUniqueId?: string | undefined;
    fileSystemEntityType: FileSystemEntityType;
}

export class FilesWithBreadcrumbsResponseModel implements IFilesWithBreadcrumbsResponseModel {
    files?: FileModel[] | undefined;
    breadcrumbItems?: BreadcrumbItem[] | undefined;

    constructor(data?: IFilesWithBreadcrumbsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileModel.fromJS(item));
            }
            if (Array.isArray(_data["breadcrumbItems"])) {
                this.breadcrumbItems = [] as any;
                for (let item of _data["breadcrumbItems"])
                    this.breadcrumbItems!.push(BreadcrumbItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilesWithBreadcrumbsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilesWithBreadcrumbsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.breadcrumbItems)) {
            data["breadcrumbItems"] = [];
            for (let item of this.breadcrumbItems)
                data["breadcrumbItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilesWithBreadcrumbsResponseModel {
    files?: FileModel[] | undefined;
    breadcrumbItems?: BreadcrumbItem[] | undefined;
}

export class BreadcrumbItem implements IBreadcrumbItem {
    name?: string | undefined;
    uniqueIdentifier?: string;

    constructor(data?: IBreadcrumbItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.uniqueIdentifier = _data["uniqueIdentifier"];
        }
    }

    static fromJS(data: any): BreadcrumbItem {
        data = typeof data === 'object' ? data : {};
        let result = new BreadcrumbItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["uniqueIdentifier"] = this.uniqueIdentifier;
        return data;
    }
}

export interface IBreadcrumbItem {
    name?: string | undefined;
    uniqueIdentifier?: string;
}

export enum FileSortFields {
    Name = 0,
    LastModifiedAt = 1,
    SharedAtUtc = 2,
}

export class StaredFileModel extends FileModel implements IStaredFileModel {
    directoryPaths?: ParentReferenceModel[];

    constructor(data?: IStaredFileModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["directoryPaths"])) {
                this.directoryPaths = [] as any;
                for (let item of _data["directoryPaths"])
                    this.directoryPaths!.push(ParentReferenceModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): StaredFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new StaredFileModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.directoryPaths)) {
            data["directoryPaths"] = [];
            for (let item of this.directoryPaths)
                data["directoryPaths"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IStaredFileModel extends IFileModel {
    directoryPaths?: ParentReferenceModel[];
}

export class ParentReferenceModel implements IParentReferenceModel {
    name?: string;
    uniqueIdentifier?: string | undefined;

    constructor(data?: IParentReferenceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.uniqueIdentifier = _data["uniqueIdentifier"];
        }
    }

    static fromJS(data: any): ParentReferenceModel {
        data = typeof data === 'object' ? data : {};
        let result = new ParentReferenceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["uniqueIdentifier"] = this.uniqueIdentifier;
        return data;
    }
}

export interface IParentReferenceModel {
    name?: string;
    uniqueIdentifier?: string | undefined;
}

export class DeletedFileModel extends StaredFileModel implements IDeletedFileModel {
    deletedAt?: Date;

    constructor(data?: IDeletedFileModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.deletedAt = _data["deletedAt"] ? new Date(_data["deletedAt"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): DeletedFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeletedFileModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IDeletedFileModel extends IStaredFileModel {
    deletedAt?: Date;
}

export class RestoreFilePostModel implements IRestoreFilePostModel {
    fileUniqueId!: string;
    fileType!: FileSystemEntityType;
    newName?: string;

    constructor(data?: IRestoreFilePostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileUniqueId = _data["fileUniqueId"];
            this.fileType = _data["fileType"];
            this.newName = _data["newName"];
        }
    }

    static fromJS(data: any): RestoreFilePostModel {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreFilePostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileUniqueId"] = this.fileUniqueId;
        data["fileType"] = this.fileType;
        data["newName"] = this.newName;
        return data;
    }
}

export interface IRestoreFilePostModel {
    fileUniqueId: string;
    fileType: FileSystemEntityType;
    newName?: string;
}

export class FileWithBreadcrumbsResponseModel implements IFileWithBreadcrumbsResponseModel {
    file?: FileModel | undefined;
    breadcrumbItems?: BreadcrumbItem[] | undefined;

    constructor(data?: IFileWithBreadcrumbsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"] ? FileModel.fromJS(_data["file"]) : undefined as any;
            if (Array.isArray(_data["breadcrumbItems"])) {
                this.breadcrumbItems = [] as any;
                for (let item of _data["breadcrumbItems"])
                    this.breadcrumbItems!.push(BreadcrumbItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileWithBreadcrumbsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileWithBreadcrumbsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file ? this.file.toJSON() : undefined as any;
        if (Array.isArray(this.breadcrumbItems)) {
            data["breadcrumbItems"] = [];
            for (let item of this.breadcrumbItems)
                data["breadcrumbItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFileWithBreadcrumbsResponseModel {
    file?: FileModel | undefined;
    breadcrumbItems?: BreadcrumbItem[] | undefined;
}

export enum AccessType {
    ReadOnly = 0,
    Collaboration = 1,
}

export enum ShareDefinitionSourceType {
    File = 0,
    Directory = 1,
    CopilotExperiment = 2,
    DoEExperiment = 3,
    MssStudy = 4,
    OptimumTest = 5,
    Filter = 6,
}

export class FileVersionResponseModel implements IFileVersionResponseModel {
    id?: number;
    version?: number;
    createdByUser?: UserModel;
    createdAt?: Date;
    comment?: string | undefined;

    constructor(data?: IFileVersionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.version = _data["version"];
            this.createdByUser = _data["createdByUser"] ? UserModel.fromJS(_data["createdByUser"]) : undefined as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): FileVersionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileVersionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["version"] = this.version;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IFileVersionResponseModel {
    id?: number;
    version?: number;
    createdByUser?: UserModel;
    createdAt?: Date;
    comment?: string | undefined;
}

export class UpdateCommentPostModel implements IUpdateCommentPostModel {
    comment?: string;
    fileType?: FileSystemEntityType;

    constructor(data?: IUpdateCommentPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
            this.fileType = _data["fileType"];
        }
    }

    static fromJS(data: any): UpdateCommentPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCommentPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["fileType"] = this.fileType;
        return data;
    }
}

export interface IUpdateCommentPostModel {
    comment?: string;
    fileType?: FileSystemEntityType;
}

export class ToogleStaredPostModel implements IToogleStaredPostModel {
    fileType?: FileSystemEntityType;

    constructor(data?: IToogleStaredPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileType = _data["fileType"];
        }
    }

    static fromJS(data: any): ToogleStaredPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ToogleStaredPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileType"] = this.fileType;
        return data;
    }
}

export interface IToogleStaredPostModel {
    fileType?: FileSystemEntityType;
}

export class UploadFileResponseModel implements IUploadFileResponseModel {
    filename?: string;
    originalFilename?: string;
    parentDirectoryUniqueIdentifier?: string | undefined;
    fileUniqueIdentifier?: string;
    fileVersion?: string;
    simulatePath?: string;
    ownerId?: string;
    isSharedForCollaboration?: boolean;

    constructor(data?: IUploadFileResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filename = _data["filename"];
            this.originalFilename = _data["originalFilename"];
            this.parentDirectoryUniqueIdentifier = _data["parentDirectoryUniqueIdentifier"];
            this.fileUniqueIdentifier = _data["fileUniqueIdentifier"];
            this.fileVersion = _data["fileVersion"];
            this.simulatePath = _data["simulatePath"];
            this.ownerId = _data["ownerId"];
            this.isSharedForCollaboration = _data["isSharedForCollaboration"];
        }
    }

    static fromJS(data: any): UploadFileResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFileResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filename"] = this.filename;
        data["originalFilename"] = this.originalFilename;
        data["parentDirectoryUniqueIdentifier"] = this.parentDirectoryUniqueIdentifier;
        data["fileUniqueIdentifier"] = this.fileUniqueIdentifier;
        data["fileVersion"] = this.fileVersion;
        data["simulatePath"] = this.simulatePath;
        data["ownerId"] = this.ownerId;
        data["isSharedForCollaboration"] = this.isSharedForCollaboration;
        return data;
    }
}

export interface IUploadFileResponseModel {
    filename?: string;
    originalFilename?: string;
    parentDirectoryUniqueIdentifier?: string | undefined;
    fileUniqueIdentifier?: string;
    fileVersion?: string;
    simulatePath?: string;
    ownerId?: string;
    isSharedForCollaboration?: boolean;
}

export enum UploadConflictAction {
    Overwrite = 0,
    KeepBoth = 1,
}

export class CreateDirectoryPostModel implements ICreateDirectoryPostModel {
    parentDirectoryUniqueId?: string | undefined;
    directoryName?: string;
    conflictAction?: UploadConflictAction;

    constructor(data?: ICreateDirectoryPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentDirectoryUniqueId = _data["parentDirectoryUniqueId"];
            this.directoryName = _data["directoryName"];
            this.conflictAction = _data["conflictAction"];
        }
    }

    static fromJS(data: any): CreateDirectoryPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDirectoryPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentDirectoryUniqueId"] = this.parentDirectoryUniqueId;
        data["directoryName"] = this.directoryName;
        data["conflictAction"] = this.conflictAction;
        return data;
    }
}

export interface ICreateDirectoryPostModel {
    parentDirectoryUniqueId?: string | undefined;
    directoryName?: string;
    conflictAction?: UploadConflictAction;
}

export class ValidateFileNamesResponseModel implements IValidateFileNamesResponseModel {
    existingFiles?: string[];
    existingDirectories?: string[];

    constructor(data?: IValidateFileNamesResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["existingFiles"])) {
                this.existingFiles = [] as any;
                for (let item of _data["existingFiles"])
                    this.existingFiles!.push(item);
            }
            if (Array.isArray(_data["existingDirectories"])) {
                this.existingDirectories = [] as any;
                for (let item of _data["existingDirectories"])
                    this.existingDirectories!.push(item);
            }
        }
    }

    static fromJS(data: any): ValidateFileNamesResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateFileNamesResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.existingFiles)) {
            data["existingFiles"] = [];
            for (let item of this.existingFiles)
                data["existingFiles"].push(item);
        }
        if (Array.isArray(this.existingDirectories)) {
            data["existingDirectories"] = [];
            for (let item of this.existingDirectories)
                data["existingDirectories"].push(item);
        }
        return data;
    }
}

export interface IValidateFileNamesResponseModel {
    existingFiles?: string[];
    existingDirectories?: string[];
}

export class ValidateFileNamesPostModel implements IValidateFileNamesPostModel {
    fileNames?: string[];
    parentDirectoryUniqueId?: string | undefined;

    constructor(data?: IValidateFileNamesPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fileNames"])) {
                this.fileNames = [] as any;
                for (let item of _data["fileNames"])
                    this.fileNames!.push(item);
            }
            this.parentDirectoryUniqueId = _data["parentDirectoryUniqueId"];
        }
    }

    static fromJS(data: any): ValidateFileNamesPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateFileNamesPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fileNames)) {
            data["fileNames"] = [];
            for (let item of this.fileNames)
                data["fileNames"].push(item);
        }
        data["parentDirectoryUniqueId"] = this.parentDirectoryUniqueId;
        return data;
    }
}

export interface IValidateFileNamesPostModel {
    fileNames?: string[];
    parentDirectoryUniqueId?: string | undefined;
}

export class RenameFilePostModel implements IRenameFilePostModel {
    newName!: string;
    fileId!: number;

    constructor(data?: IRenameFilePostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newName = _data["newName"];
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): RenameFilePostModel {
        data = typeof data === 'object' ? data : {};
        let result = new RenameFilePostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newName"] = this.newName;
        data["fileId"] = this.fileId;
        return data;
    }
}

export interface IRenameFilePostModel {
    newName: string;
    fileId: number;
}

export class RenameDirectoryPostModel implements IRenameDirectoryPostModel {
    newName!: string;
    directoryId!: number;

    constructor(data?: IRenameDirectoryPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newName = _data["newName"];
            this.directoryId = _data["directoryId"];
        }
    }

    static fromJS(data: any): RenameDirectoryPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new RenameDirectoryPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newName"] = this.newName;
        data["directoryId"] = this.directoryId;
        return data;
    }
}

export interface IRenameDirectoryPostModel {
    newName: string;
    directoryId: number;
}

export class FileExistsResponseModel implements IFileExistsResponseModel {
    exists?: boolean;

    constructor(data?: IFileExistsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exists = _data["exists"];
        }
    }

    static fromJS(data: any): FileExistsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileExistsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exists"] = this.exists;
        return data;
    }
}

export interface IFileExistsResponseModel {
    exists?: boolean;
}

export class FileExistsByPathPostModel implements IFileExistsByPathPostModel {
    filePath!: string;

    constructor(data?: IFileExistsByPathPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filePath = _data["filePath"];
        }
    }

    static fromJS(data: any): FileExistsByPathPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileExistsByPathPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filePath"] = this.filePath;
        return data;
    }
}

export interface IFileExistsByPathPostModel {
    filePath: string;
}

export class ResubmitForAnalysisPostModel implements IResubmitForAnalysisPostModel {
    fileUniqueIdentifier!: string;
    fileVersionNumber!: number;

    constructor(data?: IResubmitForAnalysisPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileUniqueIdentifier = _data["fileUniqueIdentifier"];
            this.fileVersionNumber = _data["fileVersionNumber"];
        }
    }

    static fromJS(data: any): ResubmitForAnalysisPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResubmitForAnalysisPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileUniqueIdentifier"] = this.fileUniqueIdentifier;
        data["fileVersionNumber"] = this.fileVersionNumber;
        return data;
    }
}

export interface IResubmitForAnalysisPostModel {
    fileUniqueIdentifier: string;
    fileVersionNumber: number;
}

export enum AnalysisStatus {
    Submitted = 0,
    Success = 1,
    Fail = 2,
}

export class MoveFilePostModel implements IMoveFilePostModel {
    name!: string;
    fileType?: FileSystemEntityType;
    destinationUniqueIdentifier?: string | undefined;
    sourceUniqueIdentifier!: string;
    conflictAction?: UploadConflictAction | undefined;

    constructor(data?: IMoveFilePostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.fileType = _data["fileType"];
            this.destinationUniqueIdentifier = _data["destinationUniqueIdentifier"];
            this.sourceUniqueIdentifier = _data["sourceUniqueIdentifier"];
            this.conflictAction = _data["conflictAction"];
        }
    }

    static fromJS(data: any): MoveFilePostModel {
        data = typeof data === 'object' ? data : {};
        let result = new MoveFilePostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["fileType"] = this.fileType;
        data["destinationUniqueIdentifier"] = this.destinationUniqueIdentifier;
        data["sourceUniqueIdentifier"] = this.sourceUniqueIdentifier;
        data["conflictAction"] = this.conflictAction;
        return data;
    }
}

export interface IMoveFilePostModel {
    name: string;
    fileType?: FileSystemEntityType;
    destinationUniqueIdentifier?: string | undefined;
    sourceUniqueIdentifier: string;
    conflictAction?: UploadConflictAction | undefined;
}

export class CopyFilePostModel implements ICopyFilePostModel {
    name!: string;
    fileType?: FileSystemEntityType;
    destinationUniqueIdentifier?: string | undefined;
    sourceUniqueIdentifier!: string;
    conflictAction?: UploadConflictAction | undefined;
    isClone?: boolean;
    filterIds?: number[] | undefined;
    doeExperimentIds?: CopyApplicationItemModel[] | undefined;
    mssStudyIds?: CopyApplicationItemModel[] | undefined;
    optimumTestIds?: CopyApplicationItemModel[] | undefined;
    copilotExperimentIds?: CopyApplicationItemModel[] | undefined;
    theeExamIds?: CopyApplicationItemModel[] | undefined;

    constructor(data?: ICopyFilePostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.fileType = _data["fileType"];
            this.destinationUniqueIdentifier = _data["destinationUniqueIdentifier"];
            this.sourceUniqueIdentifier = _data["sourceUniqueIdentifier"];
            this.conflictAction = _data["conflictAction"];
            this.isClone = _data["isClone"];
            if (Array.isArray(_data["filterIds"])) {
                this.filterIds = [] as any;
                for (let item of _data["filterIds"])
                    this.filterIds!.push(item);
            }
            if (Array.isArray(_data["doeExperimentIds"])) {
                this.doeExperimentIds = [] as any;
                for (let item of _data["doeExperimentIds"])
                    this.doeExperimentIds!.push(CopyApplicationItemModel.fromJS(item));
            }
            if (Array.isArray(_data["mssStudyIds"])) {
                this.mssStudyIds = [] as any;
                for (let item of _data["mssStudyIds"])
                    this.mssStudyIds!.push(CopyApplicationItemModel.fromJS(item));
            }
            if (Array.isArray(_data["optimumTestIds"])) {
                this.optimumTestIds = [] as any;
                for (let item of _data["optimumTestIds"])
                    this.optimumTestIds!.push(CopyApplicationItemModel.fromJS(item));
            }
            if (Array.isArray(_data["copilotExperimentIds"])) {
                this.copilotExperimentIds = [] as any;
                for (let item of _data["copilotExperimentIds"])
                    this.copilotExperimentIds!.push(CopyApplicationItemModel.fromJS(item));
            }
            if (Array.isArray(_data["theeExamIds"])) {
                this.theeExamIds = [] as any;
                for (let item of _data["theeExamIds"])
                    this.theeExamIds!.push(CopyApplicationItemModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CopyFilePostModel {
        data = typeof data === 'object' ? data : {};
        let result = new CopyFilePostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["fileType"] = this.fileType;
        data["destinationUniqueIdentifier"] = this.destinationUniqueIdentifier;
        data["sourceUniqueIdentifier"] = this.sourceUniqueIdentifier;
        data["conflictAction"] = this.conflictAction;
        data["isClone"] = this.isClone;
        if (Array.isArray(this.filterIds)) {
            data["filterIds"] = [];
            for (let item of this.filterIds)
                data["filterIds"].push(item);
        }
        if (Array.isArray(this.doeExperimentIds)) {
            data["doeExperimentIds"] = [];
            for (let item of this.doeExperimentIds)
                data["doeExperimentIds"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.mssStudyIds)) {
            data["mssStudyIds"] = [];
            for (let item of this.mssStudyIds)
                data["mssStudyIds"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.optimumTestIds)) {
            data["optimumTestIds"] = [];
            for (let item of this.optimumTestIds)
                data["optimumTestIds"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.copilotExperimentIds)) {
            data["copilotExperimentIds"] = [];
            for (let item of this.copilotExperimentIds)
                data["copilotExperimentIds"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.theeExamIds)) {
            data["theeExamIds"] = [];
            for (let item of this.theeExamIds)
                data["theeExamIds"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICopyFilePostModel {
    name: string;
    fileType?: FileSystemEntityType;
    destinationUniqueIdentifier?: string | undefined;
    sourceUniqueIdentifier: string;
    conflictAction?: UploadConflictAction | undefined;
    isClone?: boolean;
    filterIds?: number[] | undefined;
    doeExperimentIds?: CopyApplicationItemModel[] | undefined;
    mssStudyIds?: CopyApplicationItemModel[] | undefined;
    optimumTestIds?: CopyApplicationItemModel[] | undefined;
    copilotExperimentIds?: CopyApplicationItemModel[] | undefined;
    theeExamIds?: CopyApplicationItemModel[] | undefined;
}

export class CopyApplicationItemModel implements ICopyApplicationItemModel {
    id?: number;
    filterId?: number | undefined;
    filterVersionId?: number | undefined;

    constructor(data?: ICopyApplicationItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.filterId = _data["filterId"];
            this.filterVersionId = _data["filterVersionId"];
        }
    }

    static fromJS(data: any): CopyApplicationItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new CopyApplicationItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["filterId"] = this.filterId;
        data["filterVersionId"] = this.filterVersionId;
        return data;
    }
}

export interface ICopyApplicationItemModel {
    id?: number;
    filterId?: number | undefined;
    filterVersionId?: number | undefined;
}

export class SearchFileModel extends StaredFileModel implements ISearchFileModel {

    constructor(data?: ISearchFileModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SearchFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchFileModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISearchFileModel extends IStaredFileModel {
}

export class FilterResultModel implements IFilterResultModel {
    id?: number;
    fileId?: number;
    fileUniqueIdentifier?: string;
    fileVersionNumber?: number;
    currentVersionId?: number;
    currentVersion?: FilterVersionResultModel;
    enableWebForm?: boolean;
    webFormIntro?: string | undefined;
    webFormOutputDescription?: string | undefined;
    webFormApplicationId?: number | undefined;
    name?: string;
    userId?: string;
    createdAt?: Date;
    isDeleted?: boolean;
    inputFilterParameters?: InputFilterParameterResultModel[];
    outputFilterParameters?: OutputFilterParameterResultModel[];

    constructor(data?: IFilterResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.fileUniqueIdentifier = _data["fileUniqueIdentifier"];
            this.fileVersionNumber = _data["fileVersionNumber"];
            this.currentVersionId = _data["currentVersionId"];
            this.currentVersion = _data["currentVersion"] ? FilterVersionResultModel.fromJS(_data["currentVersion"]) : undefined as any;
            this.enableWebForm = _data["enableWebForm"];
            this.webFormIntro = _data["webFormIntro"];
            this.webFormOutputDescription = _data["webFormOutputDescription"];
            this.webFormApplicationId = _data["webFormApplicationId"];
            this.name = _data["name"];
            this.userId = _data["userId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["inputFilterParameters"])) {
                this.inputFilterParameters = [] as any;
                for (let item of _data["inputFilterParameters"])
                    this.inputFilterParameters!.push(InputFilterParameterResultModel.fromJS(item));
            }
            if (Array.isArray(_data["outputFilterParameters"])) {
                this.outputFilterParameters = [] as any;
                for (let item of _data["outputFilterParameters"])
                    this.outputFilterParameters!.push(OutputFilterParameterResultModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["fileUniqueIdentifier"] = this.fileUniqueIdentifier;
        data["fileVersionNumber"] = this.fileVersionNumber;
        data["currentVersionId"] = this.currentVersionId;
        data["currentVersion"] = this.currentVersion ? this.currentVersion.toJSON() : undefined as any;
        data["enableWebForm"] = this.enableWebForm;
        data["webFormIntro"] = this.webFormIntro;
        data["webFormOutputDescription"] = this.webFormOutputDescription;
        data["webFormApplicationId"] = this.webFormApplicationId;
        data["name"] = this.name;
        data["userId"] = this.userId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.inputFilterParameters)) {
            data["inputFilterParameters"] = [];
            for (let item of this.inputFilterParameters)
                data["inputFilterParameters"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.outputFilterParameters)) {
            data["outputFilterParameters"] = [];
            for (let item of this.outputFilterParameters)
                data["outputFilterParameters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterResultModel {
    id?: number;
    fileId?: number;
    fileUniqueIdentifier?: string;
    fileVersionNumber?: number;
    currentVersionId?: number;
    currentVersion?: FilterVersionResultModel;
    enableWebForm?: boolean;
    webFormIntro?: string | undefined;
    webFormOutputDescription?: string | undefined;
    webFormApplicationId?: number | undefined;
    name?: string;
    userId?: string;
    createdAt?: Date;
    isDeleted?: boolean;
    inputFilterParameters?: InputFilterParameterResultModel[];
    outputFilterParameters?: OutputFilterParameterResultModel[];
}

export class FilterVersionResultModel implements IFilterVersionResultModel {
    id?: number;
    fileVersionNumber?: number;
    createdAt?: Date;
    filterId?: number;
    inputFilterParameters?: InputFilterParameterResultModel[];
    outputFilterParameters?: OutputFilterParameterResultModel[];

    constructor(data?: IFilterVersionResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileVersionNumber = _data["fileVersionNumber"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.filterId = _data["filterId"];
            if (Array.isArray(_data["inputFilterParameters"])) {
                this.inputFilterParameters = [] as any;
                for (let item of _data["inputFilterParameters"])
                    this.inputFilterParameters!.push(InputFilterParameterResultModel.fromJS(item));
            }
            if (Array.isArray(_data["outputFilterParameters"])) {
                this.outputFilterParameters = [] as any;
                for (let item of _data["outputFilterParameters"])
                    this.outputFilterParameters!.push(OutputFilterParameterResultModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterVersionResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilterVersionResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileVersionNumber"] = this.fileVersionNumber;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["filterId"] = this.filterId;
        if (Array.isArray(this.inputFilterParameters)) {
            data["inputFilterParameters"] = [];
            for (let item of this.inputFilterParameters)
                data["inputFilterParameters"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.outputFilterParameters)) {
            data["outputFilterParameters"] = [];
            for (let item of this.outputFilterParameters)
                data["outputFilterParameters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterVersionResultModel {
    id?: number;
    fileVersionNumber?: number;
    createdAt?: Date;
    filterId?: number;
    inputFilterParameters?: InputFilterParameterResultModel[];
    outputFilterParameters?: OutputFilterParameterResultModel[];
}

export class InputFilterParameterResultModel implements IInputFilterParameterResultModel {
    id?: number;
    name?: string | undefined;
    parameterType?: FilterParameterType;
    webFormName?: string | undefined;
    webFormDescription?: string | undefined;
    webFormShowDefaultValue?: boolean;
    webFormIsDesignParameter?: boolean;
    webFormDefaultValue?: number | undefined;
    webFormMinValue?: number | undefined;
    webFormMaxValue?: number | undefined;
    alias?: string;
    fixedValue?: number | undefined;
    formula?: string | undefined;
    order?: number;
    filterVersionId?: number;

    constructor(data?: IInputFilterParameterResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parameterType = _data["parameterType"];
            this.webFormName = _data["webFormName"];
            this.webFormDescription = _data["webFormDescription"];
            this.webFormShowDefaultValue = _data["webFormShowDefaultValue"];
            this.webFormIsDesignParameter = _data["webFormIsDesignParameter"];
            this.webFormDefaultValue = _data["webFormDefaultValue"];
            this.webFormMinValue = _data["webFormMinValue"];
            this.webFormMaxValue = _data["webFormMaxValue"];
            this.alias = _data["alias"];
            this.fixedValue = _data["fixedValue"];
            this.formula = _data["formula"];
            this.order = _data["order"];
            this.filterVersionId = _data["filterVersionId"];
        }
    }

    static fromJS(data: any): InputFilterParameterResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new InputFilterParameterResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parameterType"] = this.parameterType;
        data["webFormName"] = this.webFormName;
        data["webFormDescription"] = this.webFormDescription;
        data["webFormShowDefaultValue"] = this.webFormShowDefaultValue;
        data["webFormIsDesignParameter"] = this.webFormIsDesignParameter;
        data["webFormDefaultValue"] = this.webFormDefaultValue;
        data["webFormMinValue"] = this.webFormMinValue;
        data["webFormMaxValue"] = this.webFormMaxValue;
        data["alias"] = this.alias;
        data["fixedValue"] = this.fixedValue;
        data["formula"] = this.formula;
        data["order"] = this.order;
        data["filterVersionId"] = this.filterVersionId;
        return data;
    }
}

export interface IInputFilterParameterResultModel {
    id?: number;
    name?: string | undefined;
    parameterType?: FilterParameterType;
    webFormName?: string | undefined;
    webFormDescription?: string | undefined;
    webFormShowDefaultValue?: boolean;
    webFormIsDesignParameter?: boolean;
    webFormDefaultValue?: number | undefined;
    webFormMinValue?: number | undefined;
    webFormMaxValue?: number | undefined;
    alias?: string;
    fixedValue?: number | undefined;
    formula?: string | undefined;
    order?: number;
    filterVersionId?: number;
}

export enum FilterParameterType {
    ExpectedInput = 0,
    ExpectedOutput = 1,
    FixedValue = 2,
    Formula = 3,
}

export class OutputFilterParameterResultModel implements IOutputFilterParameterResultModel {
    id?: number;
    name?: string | undefined;
    parameterType?: FilterParameterType;
    alias?: string;
    formula?: string | undefined;
    order?: number;
    filterVersionId?: number;

    constructor(data?: IOutputFilterParameterResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parameterType = _data["parameterType"];
            this.alias = _data["alias"];
            this.formula = _data["formula"];
            this.order = _data["order"];
            this.filterVersionId = _data["filterVersionId"];
        }
    }

    static fromJS(data: any): OutputFilterParameterResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new OutputFilterParameterResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parameterType"] = this.parameterType;
        data["alias"] = this.alias;
        data["formula"] = this.formula;
        data["order"] = this.order;
        data["filterVersionId"] = this.filterVersionId;
        return data;
    }
}

export interface IOutputFilterParameterResultModel {
    id?: number;
    name?: string | undefined;
    parameterType?: FilterParameterType;
    alias?: string;
    formula?: string | undefined;
    order?: number;
    filterVersionId?: number;
}

export class FilterQuery implements IFilterQuery {
    fileId!: number;
    filterVersion?: number | undefined;

    constructor(data?: IFilterQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.filterVersion = _data["filterVersion"];
        }
    }

    static fromJS(data: any): FilterQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FilterQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["filterVersion"] = this.filterVersion;
        return data;
    }
}

export interface IFilterQuery {
    fileId: number;
    filterVersion?: number | undefined;
}

export class CloneSharedFilterResponseModel implements ICloneSharedFilterResponseModel {
    uniqueFileId?: string;
    filterId?: number;
    filterVersionId?: number | undefined;
    oldFilterId?: number;
    oldFilterVersionId?: number | undefined;

    constructor(data?: ICloneSharedFilterResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueFileId = _data["uniqueFileId"];
            this.filterId = _data["filterId"];
            this.filterVersionId = _data["filterVersionId"];
            this.oldFilterId = _data["oldFilterId"];
            this.oldFilterVersionId = _data["oldFilterVersionId"];
        }
    }

    static fromJS(data: any): CloneSharedFilterResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CloneSharedFilterResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueFileId"] = this.uniqueFileId;
        data["filterId"] = this.filterId;
        data["filterVersionId"] = this.filterVersionId;
        data["oldFilterId"] = this.oldFilterId;
        data["oldFilterVersionId"] = this.oldFilterVersionId;
        return data;
    }
}

export interface ICloneSharedFilterResponseModel {
    uniqueFileId?: string;
    filterId?: number;
    filterVersionId?: number | undefined;
    oldFilterId?: number;
    oldFilterVersionId?: number | undefined;
}

export class CloneSharedFilterPostModel implements ICloneSharedFilterPostModel {
    filterId!: number;
    filterVersionId?: number | undefined;
    filename!: string;
    flowsheetUniqueId!: string;
    flowsheetVersionNumber!: number;
    destinationDirectoryUniqueId?: string | undefined;
    uploadConflictAction?: UploadConflictAction | undefined;
    shareSourceId?: string | undefined;
    shareSourceType?: ShareDefinitionSourceType | undefined;

    constructor(data?: ICloneSharedFilterPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterId = _data["filterId"];
            this.filterVersionId = _data["filterVersionId"];
            this.filename = _data["filename"];
            this.flowsheetUniqueId = _data["flowsheetUniqueId"];
            this.flowsheetVersionNumber = _data["flowsheetVersionNumber"];
            this.destinationDirectoryUniqueId = _data["destinationDirectoryUniqueId"];
            this.uploadConflictAction = _data["uploadConflictAction"];
            this.shareSourceId = _data["shareSourceId"];
            this.shareSourceType = _data["shareSourceType"];
        }
    }

    static fromJS(data: any): CloneSharedFilterPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new CloneSharedFilterPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterId"] = this.filterId;
        data["filterVersionId"] = this.filterVersionId;
        data["filename"] = this.filename;
        data["flowsheetUniqueId"] = this.flowsheetUniqueId;
        data["flowsheetVersionNumber"] = this.flowsheetVersionNumber;
        data["destinationDirectoryUniqueId"] = this.destinationDirectoryUniqueId;
        data["uploadConflictAction"] = this.uploadConflictAction;
        data["shareSourceId"] = this.shareSourceId;
        data["shareSourceType"] = this.shareSourceType;
        return data;
    }
}

export interface ICloneSharedFilterPostModel {
    filterId: number;
    filterVersionId?: number | undefined;
    filename: string;
    flowsheetUniqueId: string;
    flowsheetVersionNumber: number;
    destinationDirectoryUniqueId?: string | undefined;
    uploadConflictAction?: UploadConflictAction | undefined;
    shareSourceId?: string | undefined;
    shareSourceType?: ShareDefinitionSourceType | undefined;
}

export class FilterListResponseModel implements IFilterListResponseModel {
    totalRecords?: number;
    filters?: FilterResultModel[];

    constructor(data?: IFilterListResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(FilterResultModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterListResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilterListResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterListResponseModel {
    totalRecords?: number;
    filters?: FilterResultModel[];
}

export class FilterFileResponseModel implements IFilterFileResponseModel {
    fileUniqueIdentifier?: string;
    fileVersionNumber?: number | undefined;

    constructor(data?: IFilterFileResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileUniqueIdentifier = _data["fileUniqueIdentifier"];
            this.fileVersionNumber = _data["fileVersionNumber"];
        }
    }

    static fromJS(data: any): FilterFileResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilterFileResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileUniqueIdentifier"] = this.fileUniqueIdentifier;
        data["fileVersionNumber"] = this.fileVersionNumber;
        return data;
    }
}

export interface IFilterFileResponseModel {
    fileUniqueIdentifier?: string;
    fileVersionNumber?: number | undefined;
}

export class FilterFlowsheetQuery implements IFilterFlowsheetQuery {
    sourceId!: number;
    filterId!: number;
    filterVersionId?: number | undefined;
    sourceType!: ShareDefinitionSourceType;

    constructor(data?: IFilterFlowsheetQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.filterId = _data["filterId"];
            this.filterVersionId = _data["filterVersionId"];
            this.sourceType = _data["sourceType"];
        }
    }

    static fromJS(data: any): FilterFlowsheetQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FilterFlowsheetQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["filterId"] = this.filterId;
        data["filterVersionId"] = this.filterVersionId;
        data["sourceType"] = this.sourceType;
        return data;
    }
}

export interface IFilterFlowsheetQuery {
    sourceId: number;
    filterId: number;
    filterVersionId?: number | undefined;
    sourceType: ShareDefinitionSourceType;
}

export class FilterPostModel implements IFilterPostModel {
    id?: number;
    fileId!: number;
    name!: string;
    fileVersionNumber!: number;
    enableWebForm?: boolean;
    webFormIntro?: string | undefined;
    webFormOutputDescription?: string | undefined;
    webFormApplicationId?: number | undefined;
    inputFilterParameters?: InputFilterParameterPostModel[];
    outputFilterParameters?: OutputFilterParameterPostModel[];

    constructor(data?: IFilterPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileId = _data["fileId"];
            this.name = _data["name"];
            this.fileVersionNumber = _data["fileVersionNumber"];
            this.enableWebForm = _data["enableWebForm"];
            this.webFormIntro = _data["webFormIntro"];
            this.webFormOutputDescription = _data["webFormOutputDescription"];
            this.webFormApplicationId = _data["webFormApplicationId"];
            if (Array.isArray(_data["inputFilterParameters"])) {
                this.inputFilterParameters = [] as any;
                for (let item of _data["inputFilterParameters"])
                    this.inputFilterParameters!.push(InputFilterParameterPostModel.fromJS(item));
            }
            if (Array.isArray(_data["outputFilterParameters"])) {
                this.outputFilterParameters = [] as any;
                for (let item of _data["outputFilterParameters"])
                    this.outputFilterParameters!.push(OutputFilterParameterPostModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilterPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileId"] = this.fileId;
        data["name"] = this.name;
        data["fileVersionNumber"] = this.fileVersionNumber;
        data["enableWebForm"] = this.enableWebForm;
        data["webFormIntro"] = this.webFormIntro;
        data["webFormOutputDescription"] = this.webFormOutputDescription;
        data["webFormApplicationId"] = this.webFormApplicationId;
        if (Array.isArray(this.inputFilterParameters)) {
            data["inputFilterParameters"] = [];
            for (let item of this.inputFilterParameters)
                data["inputFilterParameters"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.outputFilterParameters)) {
            data["outputFilterParameters"] = [];
            for (let item of this.outputFilterParameters)
                data["outputFilterParameters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterPostModel {
    id?: number;
    fileId: number;
    name: string;
    fileVersionNumber: number;
    enableWebForm?: boolean;
    webFormIntro?: string | undefined;
    webFormOutputDescription?: string | undefined;
    webFormApplicationId?: number | undefined;
    inputFilterParameters?: InputFilterParameterPostModel[];
    outputFilterParameters?: OutputFilterParameterPostModel[];
}

export class InputFilterParameterPostModel implements IInputFilterParameterPostModel {
    id?: number;
    name!: string;
    parameterType!: FilterParameterTypePostModel;
    webFormName?: string | undefined;
    webFormDescription?: string | undefined;
    webFormShowDefaultValue?: boolean;
    webFormIsDesignParameter?: boolean;
    webFormDefaultValue?: number | undefined;
    webFormMinValue?: number | undefined;
    webFormMaxValue?: number | undefined;
    alias?: string;
    fixedValue?: number | undefined;
    formula?: string;
    order?: number;

    constructor(data?: IInputFilterParameterPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parameterType = _data["parameterType"];
            this.webFormName = _data["webFormName"];
            this.webFormDescription = _data["webFormDescription"];
            this.webFormShowDefaultValue = _data["webFormShowDefaultValue"];
            this.webFormIsDesignParameter = _data["webFormIsDesignParameter"];
            this.webFormDefaultValue = _data["webFormDefaultValue"];
            this.webFormMinValue = _data["webFormMinValue"];
            this.webFormMaxValue = _data["webFormMaxValue"];
            this.alias = _data["alias"];
            this.fixedValue = _data["fixedValue"];
            this.formula = _data["formula"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): InputFilterParameterPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new InputFilterParameterPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parameterType"] = this.parameterType;
        data["webFormName"] = this.webFormName;
        data["webFormDescription"] = this.webFormDescription;
        data["webFormShowDefaultValue"] = this.webFormShowDefaultValue;
        data["webFormIsDesignParameter"] = this.webFormIsDesignParameter;
        data["webFormDefaultValue"] = this.webFormDefaultValue;
        data["webFormMinValue"] = this.webFormMinValue;
        data["webFormMaxValue"] = this.webFormMaxValue;
        data["alias"] = this.alias;
        data["fixedValue"] = this.fixedValue;
        data["formula"] = this.formula;
        data["order"] = this.order;
        return data;
    }
}

export interface IInputFilterParameterPostModel {
    id?: number;
    name: string;
    parameterType: FilterParameterTypePostModel;
    webFormName?: string | undefined;
    webFormDescription?: string | undefined;
    webFormShowDefaultValue?: boolean;
    webFormIsDesignParameter?: boolean;
    webFormDefaultValue?: number | undefined;
    webFormMinValue?: number | undefined;
    webFormMaxValue?: number | undefined;
    alias?: string;
    fixedValue?: number | undefined;
    formula?: string;
    order?: number;
}

export enum FilterParameterTypePostModel {
    ExpectedInput = 0,
    ExpectedOutput = 1,
    FixedValue = 2,
    Formula = 3,
}

export class OutputFilterParameterPostModel implements IOutputFilterParameterPostModel {
    id?: number;
    name?: string;
    parameterType!: FilterParameterTypePostModel;
    alias?: string;
    order?: number;
    formula?: string;

    constructor(data?: IOutputFilterParameterPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parameterType = _data["parameterType"];
            this.alias = _data["alias"];
            this.order = _data["order"];
            this.formula = _data["formula"];
        }
    }

    static fromJS(data: any): OutputFilterParameterPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new OutputFilterParameterPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parameterType"] = this.parameterType;
        data["alias"] = this.alias;
        data["order"] = this.order;
        data["formula"] = this.formula;
        return data;
    }
}

export interface IOutputFilterParameterPostModel {
    id?: number;
    name?: string;
    parameterType: FilterParameterTypePostModel;
    alias?: string;
    order?: number;
    formula?: string;
}

export class CreateExcelFilePostModel implements ICreateExcelFilePostModel {
    filterId!: number;
    filename!: string;
    parentDirectoryUniqueId?: string | undefined;
    conflictAction?: UploadConflictAction | undefined;

    constructor(data?: ICreateExcelFilePostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterId = _data["filterId"];
            this.filename = _data["filename"];
            this.parentDirectoryUniqueId = _data["parentDirectoryUniqueId"];
            this.conflictAction = _data["conflictAction"];
        }
    }

    static fromJS(data: any): CreateExcelFilePostModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExcelFilePostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterId"] = this.filterId;
        data["filename"] = this.filename;
        data["parentDirectoryUniqueId"] = this.parentDirectoryUniqueId;
        data["conflictAction"] = this.conflictAction;
        return data;
    }
}

export interface ICreateExcelFilePostModel {
    filterId: number;
    filename: string;
    parentDirectoryUniqueId?: string | undefined;
    conflictAction?: UploadConflictAction | undefined;
}

export class PublicWebFormIdResponseModel implements IPublicWebFormIdResponseModel {
    id?: string;

    constructor(data?: IPublicWebFormIdResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PublicWebFormIdResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicWebFormIdResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IPublicWebFormIdResponseModel {
    id?: string;
}

export class CreatePythonScriptResultModel implements ICreatePythonScriptResultModel {
    script?: string;

    constructor(data?: ICreatePythonScriptResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.script = _data["script"];
        }
    }

    static fromJS(data: any): CreatePythonScriptResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePythonScriptResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["script"] = this.script;
        return data;
    }
}

export interface ICreatePythonScriptResultModel {
    script?: string;
}

export class FilterPythonScriptPostModel implements IFilterPythonScriptPostModel {
    filterId!: number;
    inputParameterValues?: ParameterDefaultValue[];

    constructor(data?: IFilterPythonScriptPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterId = _data["filterId"];
            if (Array.isArray(_data["inputParameterValues"])) {
                this.inputParameterValues = [] as any;
                for (let item of _data["inputParameterValues"])
                    this.inputParameterValues!.push(ParameterDefaultValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterPythonScriptPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilterPythonScriptPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterId"] = this.filterId;
        if (Array.isArray(this.inputParameterValues)) {
            data["inputParameterValues"] = [];
            for (let item of this.inputParameterValues)
                data["inputParameterValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterPythonScriptPostModel {
    filterId: number;
    inputParameterValues?: ParameterDefaultValue[];
}

export class ParameterDefaultValue implements IParameterDefaultValue {
    parameterName?: string;
    value?: number | undefined;

    constructor(data?: IParameterDefaultValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameterName = _data["parameterName"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ParameterDefaultValue {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterDefaultValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameterName"] = this.parameterName;
        data["value"] = this.value;
        return data;
    }
}

export interface IParameterDefaultValue {
    parameterName?: string;
    value?: number | undefined;
}

export class FilterCountResultModel implements IFilterCountResultModel {
    fileUniqueIdentifier?: string;
    count?: number;

    constructor(data?: IFilterCountResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileUniqueIdentifier = _data["fileUniqueIdentifier"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): FilterCountResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilterCountResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileUniqueIdentifier"] = this.fileUniqueIdentifier;
        data["count"] = this.count;
        return data;
    }
}

export interface IFilterCountResultModel {
    fileUniqueIdentifier?: string;
    count?: number;
}

export class ErrorResultModel implements IErrorResultModel {
    errors?: string[] | undefined;
    validationErrors?: { [key: string]: string[]; } | undefined;

    constructor(data?: IErrorResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (_data["validationErrors"]) {
                this.validationErrors = {} as any;
                for (let key in _data["validationErrors"]) {
                    if (_data["validationErrors"].hasOwnProperty(key))
                        (this.validationErrors as any)![key] = _data["validationErrors"][key] !== undefined ? _data["validationErrors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ErrorResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (this.validationErrors) {
            data["validationErrors"] = {};
            for (let key in this.validationErrors) {
                if (this.validationErrors.hasOwnProperty(key))
                    (data["validationErrors"] as any)[key] = (this.validationErrors as any)[key];
            }
        }
        return data;
    }
}

export interface IErrorResultModel {
    errors?: string[] | undefined;
    validationErrors?: { [key: string]: string[]; } | undefined;
}

export class FiltersCountPostModel implements IFiltersCountPostModel {
    fileUniqueIdentifiers?: string[];

    constructor(data?: IFiltersCountPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fileUniqueIdentifiers"])) {
                this.fileUniqueIdentifiers = [] as any;
                for (let item of _data["fileUniqueIdentifiers"])
                    this.fileUniqueIdentifiers!.push(item);
            }
        }
    }

    static fromJS(data: any): FiltersCountPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new FiltersCountPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fileUniqueIdentifiers)) {
            data["fileUniqueIdentifiers"] = [];
            for (let item of this.fileUniqueIdentifiers)
                data["fileUniqueIdentifiers"].push(item);
        }
        return data;
    }
}

export interface IFiltersCountPostModel {
    fileUniqueIdentifiers?: string[];
}

export class FilterWebFormResponseModel implements IFilterWebFormResponseModel {
    intro?: string | undefined;
    inputParameters?: WebFormInputParameterResponseModel[];

    constructor(data?: IFilterWebFormResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.intro = _data["intro"];
            if (Array.isArray(_data["inputParameters"])) {
                this.inputParameters = [] as any;
                for (let item of _data["inputParameters"])
                    this.inputParameters!.push(WebFormInputParameterResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterWebFormResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilterWebFormResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["intro"] = this.intro;
        if (Array.isArray(this.inputParameters)) {
            data["inputParameters"] = [];
            for (let item of this.inputParameters)
                data["inputParameters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterWebFormResponseModel {
    intro?: string | undefined;
    inputParameters?: WebFormInputParameterResponseModel[];
}

export class WebFormInputParameterResponseModel implements IWebFormInputParameterResponseModel {
    inputParameterId?: number;
    name?: string | undefined;
    description?: string | undefined;
    defaultValue?: number | undefined;
    showDefaultValue?: boolean;
    isDesignParameter?: boolean;
    minValue?: number | undefined;
    maxValue?: number | undefined;

    constructor(data?: IWebFormInputParameterResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputParameterId = _data["inputParameterId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.showDefaultValue = _data["showDefaultValue"];
            this.isDesignParameter = _data["isDesignParameter"];
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
        }
    }

    static fromJS(data: any): WebFormInputParameterResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new WebFormInputParameterResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputParameterId"] = this.inputParameterId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["showDefaultValue"] = this.showDefaultValue;
        data["isDesignParameter"] = this.isDesignParameter;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        return data;
    }
}

export interface IWebFormInputParameterResponseModel {
    inputParameterId?: number;
    name?: string | undefined;
    description?: string | undefined;
    defaultValue?: number | undefined;
    showDefaultValue?: boolean;
    isDesignParameter?: boolean;
    minValue?: number | undefined;
    maxValue?: number | undefined;
}

export class FilterWebFormDataRequestModel implements IFilterWebFormDataRequestModel {
    formId!: string;

    constructor(data?: IFilterWebFormDataRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
        }
    }

    static fromJS(data: any): FilterWebFormDataRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilterWebFormDataRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        return data;
    }
}

export interface IFilterWebFormDataRequestModel {
    formId: string;
}

export class SubmitFilterWebFormResponseModel implements ISubmitFilterWebFormResponseModel {
    jobUniqueId?: string;

    constructor(data?: ISubmitFilterWebFormResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobUniqueId = _data["jobUniqueId"];
        }
    }

    static fromJS(data: any): SubmitFilterWebFormResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitFilterWebFormResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobUniqueId"] = this.jobUniqueId;
        return data;
    }
}

export interface ISubmitFilterWebFormResponseModel {
    jobUniqueId?: string;
}

export class FilterWebFormDataPostModel implements IFilterWebFormDataPostModel {
    formId!: string;
    inputParameters!: WebFormInputParameterPostModel[];

    constructor(data?: IFilterWebFormDataPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.inputParameters = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            if (Array.isArray(_data["inputParameters"])) {
                this.inputParameters = [] as any;
                for (let item of _data["inputParameters"])
                    this.inputParameters!.push(WebFormInputParameterPostModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterWebFormDataPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilterWebFormDataPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        if (Array.isArray(this.inputParameters)) {
            data["inputParameters"] = [];
            for (let item of this.inputParameters)
                data["inputParameters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterWebFormDataPostModel {
    formId: string;
    inputParameters: WebFormInputParameterPostModel[];
}

export class WebFormInputParameterPostModel implements IWebFormInputParameterPostModel {
    inputParameterId!: number;
    value!: number;

    constructor(data?: IWebFormInputParameterPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputParameterId = _data["inputParameterId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): WebFormInputParameterPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new WebFormInputParameterPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputParameterId"] = this.inputParameterId;
        data["value"] = this.value;
        return data;
    }
}

export interface IWebFormInputParameterPostModel {
    inputParameterId: number;
    value: number;
}

export class CalculationCompletedCallbackModel extends CallbackModelBase implements ICalculationCompletedCallbackModel {
    simulator?: SimulatorType;
    outputParameters?: OutputParameterCallbackModel[] | undefined;

    constructor(data?: ICalculationCompletedCallbackModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.simulator = _data["simulator"];
            if (Array.isArray(_data["outputParameters"])) {
                this.outputParameters = [] as any;
                for (let item of _data["outputParameters"])
                    this.outputParameters!.push(OutputParameterCallbackModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CalculationCompletedCallbackModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationCompletedCallbackModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["simulator"] = this.simulator;
        if (Array.isArray(this.outputParameters)) {
            data["outputParameters"] = [];
            for (let item of this.outputParameters)
                data["outputParameters"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICalculationCompletedCallbackModel extends ICallbackModelBase {
    simulator?: SimulatorType;
    outputParameters?: OutputParameterCallbackModel[] | undefined;
}

export enum SimulatorType {
    Chemcad7 = 1,
    DWSIM = 2,
    Chemcad8 = 3,
}

export class OutputParameterCallbackModel implements IOutputParameterCallbackModel {
    parameter?: string | undefined;
    value?: number;

    constructor(data?: IOutputParameterCallbackModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameter = _data["parameter"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): OutputParameterCallbackModel {
        data = typeof data === 'object' ? data : {};
        let result = new OutputParameterCallbackModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameter"] = this.parameter;
        data["value"] = this.value;
        return data;
    }
}

export interface IOutputParameterCallbackModel {
    parameter?: string | undefined;
    value?: number;
}

export class CalculationFailedCallbackModel extends CallbackModelBase implements ICalculationFailedCallbackModel {
    errorMessage?: string | undefined;

    constructor(data?: ICalculationFailedCallbackModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.errorMessage = _data["errorMessage"];
        }
    }

    static override fromJS(data: any): CalculationFailedCallbackModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationFailedCallbackModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        super.toJSON(data);
        return data;
    }
}

export interface ICalculationFailedCallbackModel extends ICallbackModelBase {
    errorMessage?: string | undefined;
}

export class FilterWebFormJobResult implements IFilterWebFormJobResult {
    status?: JobProcessingStatus;
    result?: string | undefined;
    error?: string | undefined;

    constructor(data?: IFilterWebFormJobResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.result = _data["result"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): FilterWebFormJobResult {
        data = typeof data === 'object' ? data : {};
        let result = new FilterWebFormJobResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["result"] = this.result;
        data["error"] = this.error;
        return data;
    }
}

export interface IFilterWebFormJobResult {
    status?: JobProcessingStatus;
    result?: string | undefined;
    error?: string | undefined;
}

export enum JobProcessingStatus {
    NotCalculated = 0,
    Finished = 1,
    Failed = 2,
    Cancelled = 3,
}

export class JobStatusRequestModel implements IJobStatusRequestModel {
    requestId?: string;

    constructor(data?: IJobStatusRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): JobStatusRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobStatusRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        return data;
    }
}

export interface IJobStatusRequestModel {
    requestId?: string;
}

export class UpdateGroupResultModel implements IUpdateGroupResultModel {
    id?: string;

    constructor(data?: IUpdateGroupResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateGroupResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGroupResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateGroupResultModel {
    id?: string;
}

export class CreateGroupPostModel implements ICreateGroupPostModel {
    groupname!: string;

    constructor(data?: ICreateGroupPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupname = _data["groupname"];
        }
    }

    static fromJS(data: any): CreateGroupPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGroupPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupname"] = this.groupname;
        return data;
    }
}

export interface ICreateGroupPostModel {
    groupname: string;
}

export class RenameGroupPostModel implements IRenameGroupPostModel {
    groupId!: string;
    groupname!: string;

    constructor(data?: IRenameGroupPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.groupname = _data["groupname"];
        }
    }

    static fromJS(data: any): RenameGroupPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new RenameGroupPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["groupname"] = this.groupname;
        return data;
    }
}

export interface IRenameGroupPostModel {
    groupId: string;
    groupname: string;
}

export class GroupTableResultModel implements IGroupTableResultModel {
    id?: string;
    groupname?: string;
    membersCount?: number;
    ownersCount?: number;
    createdAt?: Date;
    isDeleted?: boolean;

    constructor(data?: IGroupTableResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupname = _data["groupname"];
            this.membersCount = _data["membersCount"];
            this.ownersCount = _data["ownersCount"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): GroupTableResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new GroupTableResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupname"] = this.groupname;
        data["membersCount"] = this.membersCount;
        data["ownersCount"] = this.ownersCount;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IGroupTableResultModel {
    id?: string;
    groupname?: string;
    membersCount?: number;
    ownersCount?: number;
    createdAt?: Date;
    isDeleted?: boolean;
}

export class GroupSlimResponseModel implements IGroupSlimResponseModel {
    id?: string;
    displayName?: string;

    constructor(data?: IGroupSlimResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): GroupSlimResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GroupSlimResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IGroupSlimResponseModel {
    id?: string;
    displayName?: string;
}

export class GroupResultModel implements IGroupResultModel {
    name?: string;
    members?: UserModel[];
    owners?: UserModel[];
    isDeleted?: boolean;

    constructor(data?: IGroupResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(UserModel.fromJS(item));
            }
            if (Array.isArray(_data["owners"])) {
                this.owners = [] as any;
                for (let item of _data["owners"])
                    this.owners!.push(UserModel.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): GroupResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new GroupResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.owners)) {
            data["owners"] = [];
            for (let item of this.owners)
                data["owners"].push(item ? item.toJSON() : undefined as any);
        }
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IGroupResultModel {
    name?: string;
    members?: UserModel[];
    owners?: UserModel[];
    isDeleted?: boolean;
}

export class GroupMembersCountResponseModel implements IGroupMembersCountResponseModel {
    count?: number | undefined;

    constructor(data?: IGroupMembersCountResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GroupMembersCountResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GroupMembersCountResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        return data;
    }
}

export interface IGroupMembersCountResponseModel {
    count?: number | undefined;
}

export class GroupMappingPostModel implements IGroupMappingPostModel {
    group!: string;
    domain!: string;

    constructor(data?: IGroupMappingPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group = _data["group"];
            this.domain = _data["domain"];
        }
    }

    static fromJS(data: any): GroupMappingPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new GroupMappingPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group;
        data["domain"] = this.domain;
        return data;
    }
}

export interface IGroupMappingPostModel {
    group: string;
    domain: string;
}

export class ImpersonateUserResponseModel implements IImpersonateUserResponseModel {
    userToken?: string;
    userDisplayName?: string;
    userPrincipalName?: string;
    expiresAtUtc?: Date;

    constructor(data?: IImpersonateUserResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userToken = _data["userToken"];
            this.userDisplayName = _data["userDisplayName"];
            this.userPrincipalName = _data["userPrincipalName"];
            this.expiresAtUtc = _data["expiresAtUtc"] ? new Date(_data["expiresAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ImpersonateUserResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateUserResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userToken"] = this.userToken;
        data["userDisplayName"] = this.userDisplayName;
        data["userPrincipalName"] = this.userPrincipalName;
        data["expiresAtUtc"] = this.expiresAtUtc ? this.expiresAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IImpersonateUserResponseModel {
    userToken?: string;
    userDisplayName?: string;
    userPrincipalName?: string;
    expiresAtUtc?: Date;
}

export class CanImpersonateUserResponseModel implements ICanImpersonateUserResponseModel {
    canImpersonateUser?: boolean;

    constructor(data?: ICanImpersonateUserResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canImpersonateUser = _data["canImpersonateUser"];
        }
    }

    static fromJS(data: any): CanImpersonateUserResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CanImpersonateUserResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canImpersonateUser"] = this.canImpersonateUser;
        return data;
    }
}

export interface ICanImpersonateUserResponseModel {
    canImpersonateUser?: boolean;
}

export class LicenseResponseModel implements ILicenseResponseModel {
    hasExistingLicense?: boolean;
    trialLicenseCreated?: boolean;
    notEligibleForTrial?: boolean;

    constructor(data?: ILicenseResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasExistingLicense = _data["hasExistingLicense"];
            this.trialLicenseCreated = _data["trialLicenseCreated"];
            this.notEligibleForTrial = _data["notEligibleForTrial"];
        }
    }

    static fromJS(data: any): LicenseResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasExistingLicense"] = this.hasExistingLicense;
        data["trialLicenseCreated"] = this.trialLicenseCreated;
        data["notEligibleForTrial"] = this.notEligibleForTrial;
        return data;
    }
}

export interface ILicenseResponseModel {
    hasExistingLicense?: boolean;
    trialLicenseCreated?: boolean;
    notEligibleForTrial?: boolean;
}

export class GetLicenseInfoPostModel implements IGetLicenseInfoPostModel {
    source!: string;

    constructor(data?: IGetLicenseInfoPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): GetLicenseInfoPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetLicenseInfoPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        return data;
    }
}

export interface IGetLicenseInfoPostModel {
    source: string;
}

export class CurrentLicenseResponseModel implements ICurrentLicenseResponseModel {
    licenseKey?: string;
    dateCreated?: Date;
    expiration?: number;
    is_trial?: string;
    business_mail_submitted?: string;
    isTrial?: boolean;
    businessMailSubmitted?: boolean;

    constructor(data?: ICurrentLicenseResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseKey = _data["licenseKey"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.expiration = _data["expiration"];
            this.is_trial = _data["is_trial"];
            this.business_mail_submitted = _data["business_mail_submitted"];
            this.isTrial = _data["isTrial"];
            this.businessMailSubmitted = _data["businessMailSubmitted"];
        }
    }

    static fromJS(data: any): CurrentLicenseResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentLicenseResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseKey"] = this.licenseKey;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["expiration"] = this.expiration;
        data["is_trial"] = this.is_trial;
        data["business_mail_submitted"] = this.business_mail_submitted;
        data["isTrial"] = this.isTrial;
        data["businessMailSubmitted"] = this.businessMailSubmitted;
        return data;
    }
}

export interface ICurrentLicenseResponseModel {
    licenseKey?: string;
    dateCreated?: Date;
    expiration?: number;
    is_trial?: string;
    business_mail_submitted?: string;
    isTrial?: boolean;
    businessMailSubmitted?: boolean;
}

export class TrialUserEmail implements ITrialUserEmail {
    id?: number;
    userId?: string;
    email?: string;
    createdAtUtc?: Date;

    constructor(data?: ITrialUserEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TrialUserEmail {
        data = typeof data === 'object' ? data : {};
        let result = new TrialUserEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface ITrialUserEmail {
    id?: number;
    userId?: string;
    email?: string;
    createdAtUtc?: Date;
}

export class SubmitBusinessEmailPostModel implements ISubmitBusinessEmailPostModel {
    licenseKey!: string;
    email!: string;

    constructor(data?: ISubmitBusinessEmailPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseKey = _data["licenseKey"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SubmitBusinessEmailPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitBusinessEmailPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseKey"] = this.licenseKey;
        data["email"] = this.email;
        return data;
    }
}

export interface ISubmitBusinessEmailPostModel {
    licenseKey: string;
    email: string;
}

export class SubscriptionShareResponseModel implements ISubscriptionShareResponseModel {
    subscriptionId?: number;
    sharedWithUserId?: string;
    user?: UserModel;
    createdAtUtc?: Date;

    constructor(data?: ISubscriptionShareResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.sharedWithUserId = _data["sharedWithUserId"];
            this.user = _data["user"] ? UserModel.fromJS(_data["user"]) : undefined as any;
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SubscriptionShareResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionShareResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["sharedWithUserId"] = this.sharedWithUserId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface ISubscriptionShareResponseModel {
    subscriptionId?: number;
    sharedWithUserId?: string;
    user?: UserModel;
    createdAtUtc?: Date;
}

export class ShareSubscriptionPostModel implements IShareSubscriptionPostModel {
    subscriptionId!: number;
    userId!: string;

    constructor(data?: IShareSubscriptionPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ShareSubscriptionPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShareSubscriptionPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IShareSubscriptionPostModel {
    subscriptionId: number;
    userId: string;
}

export class StopSharingSubscriptionPostModel implements IStopSharingSubscriptionPostModel {
    subscriptionId!: number;
    userId!: string;

    constructor(data?: IStopSharingSubscriptionPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): StopSharingSubscriptionPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new StopSharingSubscriptionPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IStopSharingSubscriptionPostModel {
    subscriptionId: number;
    userId: string;
}

export class OrderPostModel implements IOrderPostModel {
    purchaseOrderNumber!: string;
    quoteNumber!: string;
    subscriptionStartDate!: Date;
    purchaseOrderSender!: string;
    purchaseOrderSenderRole!: string;
    billingPersonNameAndSurname!: string;
    billingPersonEmail!: string;
    companyName!: string;
    companyStreetName!: string;
    companyStreetNumber!: string;
    companyPostcode!: string;
    companyCity!: string;
    companyCountry!: string;
    companyTelephone!: string;
    companyVATNumber!: string;
    endUserNameAndSurname!: string;
    endUserEmailAddress!: string;
    endUserTelephone!: string;
    additionalInformation?: string;

    constructor(data?: IOrderPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.quoteNumber = _data["quoteNumber"];
            this.subscriptionStartDate = _data["subscriptionStartDate"] ? new Date(_data["subscriptionStartDate"].toString()) : undefined as any;
            this.purchaseOrderSender = _data["purchaseOrderSender"];
            this.purchaseOrderSenderRole = _data["purchaseOrderSenderRole"];
            this.billingPersonNameAndSurname = _data["billingPersonNameAndSurname"];
            this.billingPersonEmail = _data["billingPersonEmail"];
            this.companyName = _data["companyName"];
            this.companyStreetName = _data["companyStreetName"];
            this.companyStreetNumber = _data["companyStreetNumber"];
            this.companyPostcode = _data["companyPostcode"];
            this.companyCity = _data["companyCity"];
            this.companyCountry = _data["companyCountry"];
            this.companyTelephone = _data["companyTelephone"];
            this.companyVATNumber = _data["companyVATNumber"];
            this.endUserNameAndSurname = _data["endUserNameAndSurname"];
            this.endUserEmailAddress = _data["endUserEmailAddress"];
            this.endUserTelephone = _data["endUserTelephone"];
            this.additionalInformation = _data["additionalInformation"];
        }
    }

    static fromJS(data: any): OrderPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["quoteNumber"] = this.quoteNumber;
        data["subscriptionStartDate"] = this.subscriptionStartDate ? this.subscriptionStartDate.toISOString() : undefined as any;
        data["purchaseOrderSender"] = this.purchaseOrderSender;
        data["purchaseOrderSenderRole"] = this.purchaseOrderSenderRole;
        data["billingPersonNameAndSurname"] = this.billingPersonNameAndSurname;
        data["billingPersonEmail"] = this.billingPersonEmail;
        data["companyName"] = this.companyName;
        data["companyStreetName"] = this.companyStreetName;
        data["companyStreetNumber"] = this.companyStreetNumber;
        data["companyPostcode"] = this.companyPostcode;
        data["companyCity"] = this.companyCity;
        data["companyCountry"] = this.companyCountry;
        data["companyTelephone"] = this.companyTelephone;
        data["companyVATNumber"] = this.companyVATNumber;
        data["endUserNameAndSurname"] = this.endUserNameAndSurname;
        data["endUserEmailAddress"] = this.endUserEmailAddress;
        data["endUserTelephone"] = this.endUserTelephone;
        data["additionalInformation"] = this.additionalInformation;
        return data;
    }
}

export interface IOrderPostModel {
    purchaseOrderNumber: string;
    quoteNumber: string;
    subscriptionStartDate: Date;
    purchaseOrderSender: string;
    purchaseOrderSenderRole: string;
    billingPersonNameAndSurname: string;
    billingPersonEmail: string;
    companyName: string;
    companyStreetName: string;
    companyStreetNumber: string;
    companyPostcode: string;
    companyCity: string;
    companyCountry: string;
    companyTelephone: string;
    companyVATNumber: string;
    endUserNameAndSurname: string;
    endUserEmailAddress: string;
    endUserTelephone: string;
    additionalInformation?: string;
}

export class OrganizationResultModel implements IOrganizationResultModel {
    id?: number;
    name?: string;
    azureGroupName?: string;
    rmsServer?: string;
    domains?: OrganizationDomainResultModel[];

    constructor(data?: IOrganizationResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.azureGroupName = _data["azureGroupName"];
            this.rmsServer = _data["rmsServer"];
            if (Array.isArray(_data["domains"])) {
                this.domains = [] as any;
                for (let item of _data["domains"])
                    this.domains!.push(OrganizationDomainResultModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["azureGroupName"] = this.azureGroupName;
        data["rmsServer"] = this.rmsServer;
        if (Array.isArray(this.domains)) {
            data["domains"] = [];
            for (let item of this.domains)
                data["domains"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOrganizationResultModel {
    id?: number;
    name?: string;
    azureGroupName?: string;
    rmsServer?: string;
    domains?: OrganizationDomainResultModel[];
}

export class OrganizationDomainResultModel implements IOrganizationDomainResultModel {
    id?: number;
    name?: string;

    constructor(data?: IOrganizationDomainResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): OrganizationDomainResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDomainResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IOrganizationDomainResultModel {
    id?: number;
    name?: string;
}

export class ListResultOfOrganizationResultModel implements IListResultOfOrganizationResultModel {
    totalRecords?: number;
    items?: OrganizationResultModel[];
    nextPageUrl?: string | undefined;

    constructor(data?: IListResultOfOrganizationResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationResultModel.fromJS(item));
            }
            this.nextPageUrl = _data["nextPageUrl"];
        }
    }

    static fromJS(data: any): ListResultOfOrganizationResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultOfOrganizationResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["nextPageUrl"] = this.nextPageUrl;
        return data;
    }
}

export interface IListResultOfOrganizationResultModel {
    totalRecords?: number;
    items?: OrganizationResultModel[];
    nextPageUrl?: string | undefined;
}

export class OrganizationPostModel implements IOrganizationPostModel {
    id?: number;
    name!: string;
    azureGroupName!: string;
    rmsServer?: string;
    domains?: OrganizationDomainPostModel[];

    constructor(data?: IOrganizationPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.azureGroupName = _data["azureGroupName"];
            this.rmsServer = _data["rmsServer"];
            if (Array.isArray(_data["domains"])) {
                this.domains = [] as any;
                for (let item of _data["domains"])
                    this.domains!.push(OrganizationDomainPostModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["azureGroupName"] = this.azureGroupName;
        data["rmsServer"] = this.rmsServer;
        if (Array.isArray(this.domains)) {
            data["domains"] = [];
            for (let item of this.domains)
                data["domains"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOrganizationPostModel {
    id?: number;
    name: string;
    azureGroupName: string;
    rmsServer?: string;
    domains?: OrganizationDomainPostModel[];
}

export class OrganizationDomainPostModel implements IOrganizationDomainPostModel {
    id?: number;
    name?: string;

    constructor(data?: IOrganizationDomainPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): OrganizationDomainPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDomainPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IOrganizationDomainPostModel {
    id?: number;
    name?: string;
}

export class ListResultOfOrganizationMemberResponseModel implements IListResultOfOrganizationMemberResponseModel {
    totalRecords?: number;
    items?: OrganizationMemberResponseModel[];
    nextPageUrl?: string | undefined;

    constructor(data?: IListResultOfOrganizationMemberResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationMemberResponseModel.fromJS(item));
            }
            this.nextPageUrl = _data["nextPageUrl"];
        }
    }

    static fromJS(data: any): ListResultOfOrganizationMemberResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultOfOrganizationMemberResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["nextPageUrl"] = this.nextPageUrl;
        return data;
    }
}

export interface IListResultOfOrganizationMemberResponseModel {
    totalRecords?: number;
    items?: OrganizationMemberResponseModel[];
    nextPageUrl?: string | undefined;
}

export class OrganizationMemberResponseModel implements IOrganizationMemberResponseModel {
    id?: string;
    givenName?: string;
    surname?: string;
    privateEmail?: string;
    userPrincipalName?: string;

    constructor(data?: IOrganizationMemberResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.givenName = _data["givenName"];
            this.surname = _data["surname"];
            this.privateEmail = _data["privateEmail"];
            this.userPrincipalName = _data["userPrincipalName"];
        }
    }

    static fromJS(data: any): OrganizationMemberResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationMemberResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["givenName"] = this.givenName;
        data["surname"] = this.surname;
        data["privateEmail"] = this.privateEmail;
        data["userPrincipalName"] = this.userPrincipalName;
        return data;
    }
}

export interface IOrganizationMemberResponseModel {
    id?: string;
    givenName?: string;
    surname?: string;
    privateEmail?: string;
    userPrincipalName?: string;
}

export class EulaStatusResultModel implements IEulaStatusResultModel {
    hasAccepted?: boolean;

    constructor(data?: IEulaStatusResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasAccepted = _data["hasAccepted"];
        }
    }

    static fromJS(data: any): EulaStatusResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new EulaStatusResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasAccepted"] = this.hasAccepted;
        return data;
    }
}

export interface IEulaStatusResultModel {
    hasAccepted?: boolean;
}

export class EulaStatusPostModel implements IEulaStatusPostModel {
    accessToken!: string;
    siteId!: string;
    eulaAcceptanceSource!: EulaAcceptanceSource;

    constructor(data?: IEulaStatusPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.siteId = _data["siteId"];
            this.eulaAcceptanceSource = _data["eulaAcceptanceSource"];
        }
    }

    static fromJS(data: any): EulaStatusPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new EulaStatusPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["siteId"] = this.siteId;
        data["eulaAcceptanceSource"] = this.eulaAcceptanceSource;
        return data;
    }
}

export interface IEulaStatusPostModel {
    accessToken: string;
    siteId: string;
    eulaAcceptanceSource: EulaAcceptanceSource;
}

export enum EulaAcceptanceSource {
    Dashboard = 1,
    DwsimPro = 2,
}

export class GetEulaByUserPrincipalModel implements IGetEulaByUserPrincipalModel {
    userPrincipal!: string;
    eulaAcceptanceSource!: EulaAcceptanceSource;

    constructor(data?: IGetEulaByUserPrincipalModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userPrincipal = _data["userPrincipal"];
            this.eulaAcceptanceSource = _data["eulaAcceptanceSource"];
        }
    }

    static fromJS(data: any): GetEulaByUserPrincipalModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetEulaByUserPrincipalModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userPrincipal"] = this.userPrincipal;
        data["eulaAcceptanceSource"] = this.eulaAcceptanceSource;
        return data;
    }
}

export interface IGetEulaByUserPrincipalModel {
    userPrincipal: string;
    eulaAcceptanceSource: EulaAcceptanceSource;
}

export class EulaStatusPrincipalPostModel implements IEulaStatusPrincipalPostModel {
    sourceId!: string;
    principalName!: string;
    eulaAcceptanceSource!: EulaAcceptanceSource;

    constructor(data?: IEulaStatusPrincipalPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.principalName = _data["principalName"];
            this.eulaAcceptanceSource = _data["eulaAcceptanceSource"];
        }
    }

    static fromJS(data: any): EulaStatusPrincipalPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new EulaStatusPrincipalPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["principalName"] = this.principalName;
        data["eulaAcceptanceSource"] = this.eulaAcceptanceSource;
        return data;
    }
}

export interface IEulaStatusPrincipalPostModel {
    sourceId: string;
    principalName: string;
    eulaAcceptanceSource: EulaAcceptanceSource;
}

export class ShouldShowLoginQuestionnaireResponseModel implements IShouldShowLoginQuestionnaireResponseModel {
    shouldShow?: boolean;

    constructor(data?: IShouldShowLoginQuestionnaireResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shouldShow = _data["shouldShow"];
        }
    }

    static fromJS(data: any): ShouldShowLoginQuestionnaireResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShouldShowLoginQuestionnaireResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shouldShow"] = this.shouldShow;
        return data;
    }
}

export interface IShouldShowLoginQuestionnaireResponseModel {
    shouldShow?: boolean;
}

export class LoginQuestionnairePostModel implements ILoginQuestionnairePostModel {
    signupReason!: string;
    usedDwsimFree!: string;
    dwsimRank?: string | undefined;
    howYouWorkOnFlowsheets!: string;
    protectProperty!: string;

    constructor(data?: ILoginQuestionnairePostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signupReason = _data["signupReason"];
            this.usedDwsimFree = _data["usedDwsimFree"];
            this.dwsimRank = _data["dwsimRank"];
            this.howYouWorkOnFlowsheets = _data["howYouWorkOnFlowsheets"];
            this.protectProperty = _data["protectProperty"];
        }
    }

    static fromJS(data: any): LoginQuestionnairePostModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginQuestionnairePostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signupReason"] = this.signupReason;
        data["usedDwsimFree"] = this.usedDwsimFree;
        data["dwsimRank"] = this.dwsimRank;
        data["howYouWorkOnFlowsheets"] = this.howYouWorkOnFlowsheets;
        data["protectProperty"] = this.protectProperty;
        return data;
    }
}

export interface ILoginQuestionnairePostModel {
    signupReason: string;
    usedDwsimFree: string;
    dwsimRank?: string | undefined;
    howYouWorkOnFlowsheets: string;
    protectProperty: string;
}

export class ReadyToOrderPostModel implements IReadyToOrderPostModel {
    purchaseDecisionMaker!: PurchaseDecisionMaker;
    purchaseTimeline!: PurchaseTimeline;

    constructor(data?: IReadyToOrderPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaseDecisionMaker = _data["purchaseDecisionMaker"];
            this.purchaseTimeline = _data["purchaseTimeline"];
        }
    }

    static fromJS(data: any): ReadyToOrderPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReadyToOrderPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseDecisionMaker"] = this.purchaseDecisionMaker;
        data["purchaseTimeline"] = this.purchaseTimeline;
        return data;
    }
}

export interface IReadyToOrderPostModel {
    purchaseDecisionMaker: PurchaseDecisionMaker;
    purchaseTimeline: PurchaseTimeline;
}

export enum PurchaseDecisionMaker {
    Yes = 0,
    InfluenceDecision = 1,
    SomeoneElse = 2,
}

export enum PurchaseTimeline {
    Immediately = 0,
    OneToThreeMonths = 1,
    ThreePlusMonths = 2,
    JustResearching = 3,
}

export class ResetPasswordRequestModel implements IResetPasswordRequestModel {
    emailOrUsername!: string;

    constructor(data?: IResetPasswordRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailOrUsername = _data["emailOrUsername"];
        }
    }

    static fromJS(data: any): ResetPasswordRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailOrUsername"] = this.emailOrUsername;
        return data;
    }
}

export interface IResetPasswordRequestModel {
    emailOrUsername: string;
}

export class SetPasswordForUserModel implements ISetPasswordForUserModel {
    userId!: string;
    password!: string;

    constructor(data?: ISetPasswordForUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): SetPasswordForUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetPasswordForUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["password"] = this.password;
        return data;
    }
}

export interface ISetPasswordForUserModel {
    userId: string;
    password: string;
}

export class ChangePasswordResponseModel implements IChangePasswordResponseModel {
    userPrincipalName?: string;

    constructor(data?: IChangePasswordResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userPrincipalName = _data["userPrincipalName"];
        }
    }

    static fromJS(data: any): ChangePasswordResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userPrincipalName"] = this.userPrincipalName;
        return data;
    }
}

export interface IChangePasswordResponseModel {
    userPrincipalName?: string;
}

export class ResetPasswordPostModel implements IResetPasswordPostModel {
    resetPasswordToken!: string;
    newPassword!: string;

    constructor(data?: IResetPasswordPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resetPasswordToken = _data["resetPasswordToken"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resetPasswordToken"] = this.resetPasswordToken;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IResetPasswordPostModel {
    resetPasswordToken: string;
    newPassword: string;
}

export class AdminCheckResponseModel implements IAdminCheckResponseModel {
    isAdmin?: boolean;

    constructor(data?: IAdminCheckResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAdmin = _data["isAdmin"];
        }
    }

    static fromJS(data: any): AdminCheckResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdminCheckResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAdmin"] = this.isAdmin;
        return data;
    }
}

export interface IAdminCheckResponseModel {
    isAdmin?: boolean;
}

export class ShareDefinitionPostModel implements IShareDefinitionPostModel {
    sourceId!: string;
    sourceType!: ShareDefinitionSourceType;
    destinationId?: string | undefined;
    accessType!: AccessType;
    destinationType!: ShareDefinitionDestinationType;
    specialShareType?: SpecialShareType | undefined;

    constructor(data?: IShareDefinitionPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.sourceType = _data["sourceType"];
            this.destinationId = _data["destinationId"];
            this.accessType = _data["accessType"];
            this.destinationType = _data["destinationType"];
            this.specialShareType = _data["specialShareType"];
        }
    }

    static fromJS(data: any): ShareDefinitionPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShareDefinitionPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["sourceType"] = this.sourceType;
        data["destinationId"] = this.destinationId;
        data["accessType"] = this.accessType;
        data["destinationType"] = this.destinationType;
        data["specialShareType"] = this.specialShareType;
        return data;
    }
}

export interface IShareDefinitionPostModel {
    sourceId: string;
    sourceType: ShareDefinitionSourceType;
    destinationId?: string | undefined;
    accessType: AccessType;
    destinationType: ShareDefinitionDestinationType;
    specialShareType?: SpecialShareType | undefined;
}

export enum ShareDefinitionDestinationType {
    User = 0,
    Group = 1,
    Organization = 2,
    Public = 3,
    External = 4,
}

export enum SpecialShareType {
    Examples = 1,
}

export class SharedSourceTypeIdsResponseModel implements ISharedSourceTypeIdsResponseModel {
    sharedIds?: string[];

    constructor(data?: ISharedSourceTypeIdsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sharedIds"])) {
                this.sharedIds = [] as any;
                for (let item of _data["sharedIds"])
                    this.sharedIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SharedSourceTypeIdsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SharedSourceTypeIdsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sharedIds)) {
            data["sharedIds"] = [];
            for (let item of this.sharedIds)
                data["sharedIds"].push(item);
        }
        return data;
    }
}

export interface ISharedSourceTypeIdsResponseModel {
    sharedIds?: string[];
}

export class ShareDefinitionResponseModel implements IShareDefinitionResponseModel {
    id?: number;
    sourceId?: string;
    user?: UserModel;
    group?: GroupDefinitionModel;
    oraganization?: OrganizationDefinitionModel;
    destinationType?: ShareDefinitionDestinationType;
    sharedWithEmail?: string | undefined;
    isPending?: boolean;
    accessType?: AccessType;
    createdAtUtc?: Date;

    constructor(data?: IShareDefinitionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceId = _data["sourceId"];
            this.user = _data["user"] ? UserModel.fromJS(_data["user"]) : undefined as any;
            this.group = _data["group"] ? GroupDefinitionModel.fromJS(_data["group"]) : undefined as any;
            this.oraganization = _data["oraganization"] ? OrganizationDefinitionModel.fromJS(_data["oraganization"]) : undefined as any;
            this.destinationType = _data["destinationType"];
            this.sharedWithEmail = _data["sharedWithEmail"];
            this.isPending = _data["isPending"];
            this.accessType = _data["accessType"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ShareDefinitionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShareDefinitionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceId"] = this.sourceId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["group"] = this.group ? this.group.toJSON() : undefined as any;
        data["oraganization"] = this.oraganization ? this.oraganization.toJSON() : undefined as any;
        data["destinationType"] = this.destinationType;
        data["sharedWithEmail"] = this.sharedWithEmail;
        data["isPending"] = this.isPending;
        data["accessType"] = this.accessType;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IShareDefinitionResponseModel {
    id?: number;
    sourceId?: string;
    user?: UserModel;
    group?: GroupDefinitionModel;
    oraganization?: OrganizationDefinitionModel;
    destinationType?: ShareDefinitionDestinationType;
    sharedWithEmail?: string | undefined;
    isPending?: boolean;
    accessType?: AccessType;
    createdAtUtc?: Date;
}

export class GroupDefinitionModel implements IGroupDefinitionModel {
    id?: string;
    displayName?: string;

    constructor(data?: IGroupDefinitionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): GroupDefinitionModel {
        data = typeof data === 'object' ? data : {};
        let result = new GroupDefinitionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IGroupDefinitionModel {
    id?: string;
    displayName?: string;
}

export class OrganizationDefinitionModel implements IOrganizationDefinitionModel {
    id?: number;
    name?: string;

    constructor(data?: IOrganizationDefinitionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): OrganizationDefinitionModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDefinitionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IOrganizationDefinitionModel {
    id?: number;
    name?: string;
}

export class FileSharedObjectsCountResponseModel implements IFileSharedObjectsCountResponseModel {
    count?: number;

    constructor(data?: IFileSharedObjectsCountResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): FileSharedObjectsCountResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileSharedObjectsCountResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        return data;
    }
}

export interface IFileSharedObjectsCountResponseModel {
    count?: number;
}

export class IsFileSharedResponseModel implements IIsFileSharedResponseModel {
    isShared?: boolean;

    constructor(data?: IIsFileSharedResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isShared = _data["isShared"];
        }
    }

    static fromJS(data: any): IsFileSharedResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new IsFileSharedResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isShared"] = this.isShared;
        return data;
    }
}

export interface IIsFileSharedResponseModel {
    isShared?: boolean;
}

export class SharedByMeWithBreadcrumbsResponseModel implements ISharedByMeWithBreadcrumbsResponseModel {
    files?: SharedByMeFileModel[];
    breadcrumbItems?: BreadcrumbItem[] | undefined;

    constructor(data?: ISharedByMeWithBreadcrumbsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(SharedByMeFileModel.fromJS(item));
            }
            if (Array.isArray(_data["breadcrumbItems"])) {
                this.breadcrumbItems = [] as any;
                for (let item of _data["breadcrumbItems"])
                    this.breadcrumbItems!.push(BreadcrumbItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SharedByMeWithBreadcrumbsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SharedByMeWithBreadcrumbsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.breadcrumbItems)) {
            data["breadcrumbItems"] = [];
            for (let item of this.breadcrumbItems)
                data["breadcrumbItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISharedByMeWithBreadcrumbsResponseModel {
    files?: SharedByMeFileModel[];
    breadcrumbItems?: BreadcrumbItem[] | undefined;
}

export class SharedByMeFileModel extends FileModel implements ISharedByMeFileModel {
    directoryPaths?: ParentReferenceModel[];
    accessType?: AccessType;
    sharedAtUtc?: Date;

    constructor(data?: ISharedByMeFileModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["directoryPaths"])) {
                this.directoryPaths = [] as any;
                for (let item of _data["directoryPaths"])
                    this.directoryPaths!.push(ParentReferenceModel.fromJS(item));
            }
            this.accessType = _data["accessType"];
            this.sharedAtUtc = _data["sharedAtUtc"] ? new Date(_data["sharedAtUtc"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): SharedByMeFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new SharedByMeFileModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.directoryPaths)) {
            data["directoryPaths"] = [];
            for (let item of this.directoryPaths)
                data["directoryPaths"].push(item ? item.toJSON() : undefined as any);
        }
        data["accessType"] = this.accessType;
        data["sharedAtUtc"] = this.sharedAtUtc ? this.sharedAtUtc.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISharedByMeFileModel extends IFileModel {
    directoryPaths?: ParentReferenceModel[];
    accessType?: AccessType;
    sharedAtUtc?: Date;
}

export class ShareByMeFilterResponseModel implements IShareByMeFilterResponseModel {
    id?: number;
    name?: string;
    fileId?: number;
    fileUniqueIdentifier?: string | undefined;
    fileVersionNumber?: number;
    sharedAtUtc?: Date;

    constructor(data?: IShareByMeFilterResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fileId = _data["fileId"];
            this.fileUniqueIdentifier = _data["fileUniqueIdentifier"];
            this.fileVersionNumber = _data["fileVersionNumber"];
            this.sharedAtUtc = _data["sharedAtUtc"] ? new Date(_data["sharedAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ShareByMeFilterResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShareByMeFilterResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fileId"] = this.fileId;
        data["fileUniqueIdentifier"] = this.fileUniqueIdentifier;
        data["fileVersionNumber"] = this.fileVersionNumber;
        data["sharedAtUtc"] = this.sharedAtUtc ? this.sharedAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IShareByMeFilterResponseModel {
    id?: number;
    name?: string;
    fileId?: number;
    fileUniqueIdentifier?: string | undefined;
    fileVersionNumber?: number;
    sharedAtUtc?: Date;
}

export class ShareWithMeFilterResponseModel implements IShareWithMeFilterResponseModel {
    id?: number;
    currentVersionId?: number | undefined;
    name?: string;
    fileId?: number;
    fileUniqueIdentifier?: string | undefined;
    fileVersionNumber?: number;
    owner?: UserModel;
    sharedAtUtc?: Date;

    constructor(data?: IShareWithMeFilterResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.currentVersionId = _data["currentVersionId"];
            this.name = _data["name"];
            this.fileId = _data["fileId"];
            this.fileUniqueIdentifier = _data["fileUniqueIdentifier"];
            this.fileVersionNumber = _data["fileVersionNumber"];
            this.owner = _data["owner"] ? UserModel.fromJS(_data["owner"]) : undefined as any;
            this.sharedAtUtc = _data["sharedAtUtc"] ? new Date(_data["sharedAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ShareWithMeFilterResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShareWithMeFilterResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["currentVersionId"] = this.currentVersionId;
        data["name"] = this.name;
        data["fileId"] = this.fileId;
        data["fileUniqueIdentifier"] = this.fileUniqueIdentifier;
        data["fileVersionNumber"] = this.fileVersionNumber;
        data["owner"] = this.owner ? this.owner.toJSON() : undefined as any;
        data["sharedAtUtc"] = this.sharedAtUtc ? this.sharedAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IShareWithMeFilterResponseModel {
    id?: number;
    currentVersionId?: number | undefined;
    name?: string;
    fileId?: number;
    fileUniqueIdentifier?: string | undefined;
    fileVersionNumber?: number;
    owner?: UserModel;
    sharedAtUtc?: Date;
}

export class ShareByMeStudyResponseModel implements IShareByMeStudyResponseModel {
    id?: number;
    name?: string;
    fileId?: number;
    fileUniqueIdentifier?: string | undefined;
    fileVersionNumber?: number;
    sharedAtUtc?: Date;

    constructor(data?: IShareByMeStudyResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fileId = _data["fileId"];
            this.fileUniqueIdentifier = _data["fileUniqueIdentifier"];
            this.fileVersionNumber = _data["fileVersionNumber"];
            this.sharedAtUtc = _data["sharedAtUtc"] ? new Date(_data["sharedAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ShareByMeStudyResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShareByMeStudyResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fileId"] = this.fileId;
        data["fileUniqueIdentifier"] = this.fileUniqueIdentifier;
        data["fileVersionNumber"] = this.fileVersionNumber;
        data["sharedAtUtc"] = this.sharedAtUtc ? this.sharedAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IShareByMeStudyResponseModel {
    id?: number;
    name?: string;
    fileId?: number;
    fileUniqueIdentifier?: string | undefined;
    fileVersionNumber?: number;
    sharedAtUtc?: Date;
}

export class ShareWithMeStudyResponseModel implements IShareWithMeStudyResponseModel {
    id?: number;
    name?: string;
    fileId?: number;
    fileUniqueIdentifier?: string | undefined;
    fileVersionNumber?: number;
    owner?: UserModel;
    sharedAtUtc?: Date;

    constructor(data?: IShareWithMeStudyResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fileId = _data["fileId"];
            this.fileUniqueIdentifier = _data["fileUniqueIdentifier"];
            this.fileVersionNumber = _data["fileVersionNumber"];
            this.owner = _data["owner"] ? UserModel.fromJS(_data["owner"]) : undefined as any;
            this.sharedAtUtc = _data["sharedAtUtc"] ? new Date(_data["sharedAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ShareWithMeStudyResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShareWithMeStudyResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fileId"] = this.fileId;
        data["fileUniqueIdentifier"] = this.fileUniqueIdentifier;
        data["fileVersionNumber"] = this.fileVersionNumber;
        data["owner"] = this.owner ? this.owner.toJSON() : undefined as any;
        data["sharedAtUtc"] = this.sharedAtUtc ? this.sharedAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IShareWithMeStudyResponseModel {
    id?: number;
    name?: string;
    fileId?: number;
    fileUniqueIdentifier?: string | undefined;
    fileVersionNumber?: number;
    owner?: UserModel;
    sharedAtUtc?: Date;
}

export class ShareByMeScenarioResponseModel implements IShareByMeScenarioResponseModel {
    id?: number;
    name?: string;
    fileId?: number;
    fileUniqueIdentifier?: string | undefined;
    fileVersionNumber?: number;
    sharedAtUtc?: Date;

    constructor(data?: IShareByMeScenarioResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fileId = _data["fileId"];
            this.fileUniqueIdentifier = _data["fileUniqueIdentifier"];
            this.fileVersionNumber = _data["fileVersionNumber"];
            this.sharedAtUtc = _data["sharedAtUtc"] ? new Date(_data["sharedAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ShareByMeScenarioResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShareByMeScenarioResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fileId"] = this.fileId;
        data["fileUniqueIdentifier"] = this.fileUniqueIdentifier;
        data["fileVersionNumber"] = this.fileVersionNumber;
        data["sharedAtUtc"] = this.sharedAtUtc ? this.sharedAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IShareByMeScenarioResponseModel {
    id?: number;
    name?: string;
    fileId?: number;
    fileUniqueIdentifier?: string | undefined;
    fileVersionNumber?: number;
    sharedAtUtc?: Date;
}

export class ShareWithMeScenarioResponseModel implements IShareWithMeScenarioResponseModel {
    id?: number;
    name?: string;
    fileId?: number;
    fileUniqueIdentifier?: string | undefined;
    fileVersionNumber?: number;
    owner?: UserModel;
    sharedAtUtc?: Date;

    constructor(data?: IShareWithMeScenarioResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fileId = _data["fileId"];
            this.fileUniqueIdentifier = _data["fileUniqueIdentifier"];
            this.fileVersionNumber = _data["fileVersionNumber"];
            this.owner = _data["owner"] ? UserModel.fromJS(_data["owner"]) : undefined as any;
            this.sharedAtUtc = _data["sharedAtUtc"] ? new Date(_data["sharedAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ShareWithMeScenarioResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShareWithMeScenarioResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fileId"] = this.fileId;
        data["fileUniqueIdentifier"] = this.fileUniqueIdentifier;
        data["fileVersionNumber"] = this.fileVersionNumber;
        data["owner"] = this.owner ? this.owner.toJSON() : undefined as any;
        data["sharedAtUtc"] = this.sharedAtUtc ? this.sharedAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IShareWithMeScenarioResponseModel {
    id?: number;
    name?: string;
    fileId?: number;
    fileUniqueIdentifier?: string | undefined;
    fileVersionNumber?: number;
    owner?: UserModel;
    sharedAtUtc?: Date;
}

export class SharedWithMeWithBreadcrumbsResponseModel implements ISharedWithMeWithBreadcrumbsResponseModel {
    files?: SharedWithMeFileModel[];
    breadcrumbItems?: BreadcrumbItem[] | undefined;

    constructor(data?: ISharedWithMeWithBreadcrumbsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(SharedWithMeFileModel.fromJS(item));
            }
            if (Array.isArray(_data["breadcrumbItems"])) {
                this.breadcrumbItems = [] as any;
                for (let item of _data["breadcrumbItems"])
                    this.breadcrumbItems!.push(BreadcrumbItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SharedWithMeWithBreadcrumbsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SharedWithMeWithBreadcrumbsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.breadcrumbItems)) {
            data["breadcrumbItems"] = [];
            for (let item of this.breadcrumbItems)
                data["breadcrumbItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISharedWithMeWithBreadcrumbsResponseModel {
    files?: SharedWithMeFileModel[];
    breadcrumbItems?: BreadcrumbItem[] | undefined;
}

export class SharedWithMeFileModel extends FileModel implements ISharedWithMeFileModel {
    owner?: UserModel;
    accessType?: AccessType;
    sharedAtUtc?: Date;

    constructor(data?: ISharedWithMeFileModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.owner = _data["owner"] ? UserModel.fromJS(_data["owner"]) : undefined as any;
            this.accessType = _data["accessType"];
            this.sharedAtUtc = _data["sharedAtUtc"] ? new Date(_data["sharedAtUtc"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): SharedWithMeFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new SharedWithMeFileModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["owner"] = this.owner ? this.owner.toJSON() : undefined as any;
        data["accessType"] = this.accessType;
        data["sharedAtUtc"] = this.sharedAtUtc ? this.sharedAtUtc.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ISharedWithMeFileModel extends IFileModel {
    owner?: UserModel;
    accessType?: AccessType;
    sharedAtUtc?: Date;
}

export class ExamplesWithBreadcrumbsResponseModel implements IExamplesWithBreadcrumbsResponseModel {
    files?: ExampleFileModel[];
    breadcrumbItems?: BreadcrumbItem[] | undefined;

    constructor(data?: IExamplesWithBreadcrumbsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(ExampleFileModel.fromJS(item));
            }
            if (Array.isArray(_data["breadcrumbItems"])) {
                this.breadcrumbItems = [] as any;
                for (let item of _data["breadcrumbItems"])
                    this.breadcrumbItems!.push(BreadcrumbItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExamplesWithBreadcrumbsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExamplesWithBreadcrumbsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.breadcrumbItems)) {
            data["breadcrumbItems"] = [];
            for (let item of this.breadcrumbItems)
                data["breadcrumbItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExamplesWithBreadcrumbsResponseModel {
    files?: ExampleFileModel[];
    breadcrumbItems?: BreadcrumbItem[] | undefined;
}

export class ExampleFileModel extends FileModel implements IExampleFileModel {
    owner?: UserModel;
    sharedAtUtc?: Date;

    constructor(data?: IExampleFileModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.owner = _data["owner"] ? UserModel.fromJS(_data["owner"]) : undefined as any;
            this.sharedAtUtc = _data["sharedAtUtc"] ? new Date(_data["sharedAtUtc"].toString()) : undefined as any;
        }
    }

    static override fromJS(data: any): ExampleFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExampleFileModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["owner"] = this.owner ? this.owner.toJSON() : undefined as any;
        data["sharedAtUtc"] = this.sharedAtUtc ? this.sharedAtUtc.toISOString() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IExampleFileModel extends IFileModel {
    owner?: UserModel;
    sharedAtUtc?: Date;
}

export class LastUploadedFileResponseModel implements ILastUploadedFileResponseModel {
    uploadedAt?: Date | undefined;

    constructor(data?: ILastUploadedFileResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uploadedAt = _data["uploadedAt"] ? new Date(_data["uploadedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): LastUploadedFileResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new LastUploadedFileResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadedAt"] = this.uploadedAt ? this.uploadedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface ILastUploadedFileResponseModel {
    uploadedAt?: Date | undefined;
}

export class LastSharedFileResponseModel implements ILastSharedFileResponseModel {
    sharedAt?: Date | undefined;

    constructor(data?: ILastSharedFileResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sharedAt = _data["sharedAt"] ? new Date(_data["sharedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): LastSharedFileResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new LastSharedFileResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sharedAt"] = this.sharedAt ? this.sharedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface ILastSharedFileResponseModel {
    sharedAt?: Date | undefined;
}

export class ActiveSubscriptionUsageResponseModel implements IActiveSubscriptionUsageResponseModel {
    subscriptionId?: number | undefined;
    stripeSubscriptionId?: string;
    stripeProductId?: string;
    stripeProduct?: StripeProductSlimModel | undefined;
    newestBillingInstanceId?: number;
    usageType?: BillingInstanceUsageType;
    allowedTokens?: number | undefined;
    usedTokens?: number | undefined;
    validFromUtc?: Date;
    validToUtc?: Date;
    productType?: string | undefined;
    stripeCustomerId?: string | undefined;
    ownerCantUse?: boolean;
    ownerId?: string | undefined;
    owner?: string | undefined;
    isSubscriptionOwner?: boolean;
    maxUsers?: number | undefined;

    constructor(data?: IActiveSubscriptionUsageResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.stripeSubscriptionId = _data["stripeSubscriptionId"];
            this.stripeProductId = _data["stripeProductId"];
            this.stripeProduct = _data["stripeProduct"] ? StripeProductSlimModel.fromJS(_data["stripeProduct"]) : undefined as any;
            this.newestBillingInstanceId = _data["newestBillingInstanceId"];
            this.usageType = _data["usageType"];
            this.allowedTokens = _data["allowedTokens"];
            this.usedTokens = _data["usedTokens"];
            this.validFromUtc = _data["validFromUtc"] ? new Date(_data["validFromUtc"].toString()) : undefined as any;
            this.validToUtc = _data["validToUtc"] ? new Date(_data["validToUtc"].toString()) : undefined as any;
            this.productType = _data["productType"];
            this.stripeCustomerId = _data["stripeCustomerId"];
            this.ownerCantUse = _data["ownerCantUse"];
            this.ownerId = _data["ownerId"];
            this.owner = _data["owner"];
            this.isSubscriptionOwner = _data["isSubscriptionOwner"];
            this.maxUsers = _data["maxUsers"];
        }
    }

    static fromJS(data: any): ActiveSubscriptionUsageResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveSubscriptionUsageResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["stripeSubscriptionId"] = this.stripeSubscriptionId;
        data["stripeProductId"] = this.stripeProductId;
        data["stripeProduct"] = this.stripeProduct ? this.stripeProduct.toJSON() : undefined as any;
        data["newestBillingInstanceId"] = this.newestBillingInstanceId;
        data["usageType"] = this.usageType;
        data["allowedTokens"] = this.allowedTokens;
        data["usedTokens"] = this.usedTokens;
        data["validFromUtc"] = this.validFromUtc ? this.validFromUtc.toISOString() : undefined as any;
        data["validToUtc"] = this.validToUtc ? this.validToUtc.toISOString() : undefined as any;
        data["productType"] = this.productType;
        data["stripeCustomerId"] = this.stripeCustomerId;
        data["ownerCantUse"] = this.ownerCantUse;
        data["ownerId"] = this.ownerId;
        data["owner"] = this.owner;
        data["isSubscriptionOwner"] = this.isSubscriptionOwner;
        data["maxUsers"] = this.maxUsers;
        return data;
    }
}

export interface IActiveSubscriptionUsageResponseModel {
    subscriptionId?: number | undefined;
    stripeSubscriptionId?: string;
    stripeProductId?: string;
    stripeProduct?: StripeProductSlimModel | undefined;
    newestBillingInstanceId?: number;
    usageType?: BillingInstanceUsageType;
    allowedTokens?: number | undefined;
    usedTokens?: number | undefined;
    validFromUtc?: Date;
    validToUtc?: Date;
    productType?: string | undefined;
    stripeCustomerId?: string | undefined;
    ownerCantUse?: boolean;
    ownerId?: string | undefined;
    owner?: string | undefined;
    isSubscriptionOwner?: boolean;
    maxUsers?: number | undefined;
}

export class StripeProductSlimModel implements IStripeProductSlimModel {
    id?: string;
    name?: string;
    description?: string | undefined;
    priceId?: string;
    price?: StripePriceModel | undefined;
    metadata?: { [key: string]: string; };

    constructor(data?: IStripeProductSlimModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.priceId = _data["priceId"];
            this.price = _data["price"] ? StripePriceModel.fromJS(_data["price"]) : undefined as any;
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (this.metadata as any)![key] = _data["metadata"][key];
                }
            }
        }
    }

    static fromJS(data: any): StripeProductSlimModel {
        data = typeof data === 'object' ? data : {};
        let result = new StripeProductSlimModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["priceId"] = this.priceId;
        data["price"] = this.price ? this.price.toJSON() : undefined as any;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (data["metadata"] as any)[key] = (this.metadata as any)[key];
            }
        }
        return data;
    }
}

export interface IStripeProductSlimModel {
    id?: string;
    name?: string;
    description?: string | undefined;
    priceId?: string;
    price?: StripePriceModel | undefined;
    metadata?: { [key: string]: string; };
}

export class StripePriceModel implements IStripePriceModel {
    id?: string;
    value?: number | undefined;
    quantity?: number | undefined;
    productId?: string;

    constructor(data?: IStripePriceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.quantity = _data["quantity"];
            this.productId = _data["productId"];
        }
    }

    static fromJS(data: any): StripePriceModel {
        data = typeof data === 'object' ? data : {};
        let result = new StripePriceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["quantity"] = this.quantity;
        data["productId"] = this.productId;
        return data;
    }
}

export interface IStripePriceModel {
    id?: string;
    value?: number | undefined;
    quantity?: number | undefined;
    productId?: string;
}

export enum BillingInstanceUsageType {
    Unlimited = 0,
    Hourly = 1,
}

export enum ProductType {
    DwsimPro = 0,
    DwsimCollaboraton = 1,
    FlowsheetCopilot = 2,
}

export class OwnerUsesBillingInstancePostModel implements IOwnerUsesBillingInstancePostModel {
    billingInstanceId?: number | undefined;
    ownerCantUse?: boolean;

    constructor(data?: IOwnerUsesBillingInstancePostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billingInstanceId = _data["billingInstanceId"];
            this.ownerCantUse = _data["ownerCantUse"];
        }
    }

    static fromJS(data: any): OwnerUsesBillingInstancePostModel {
        data = typeof data === 'object' ? data : {};
        let result = new OwnerUsesBillingInstancePostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billingInstanceId"] = this.billingInstanceId;
        data["ownerCantUse"] = this.ownerCantUse;
        return data;
    }
}

export interface IOwnerUsesBillingInstancePostModel {
    billingInstanceId?: number | undefined;
    ownerCantUse?: boolean;
}

export class ContactFormPostModel implements IContactFormPostModel {
    hasFileAttached?: boolean;
    emailSubject!: string;
    fileUniqueId?: string;
    fileVersionNumber?: number;
    message!: string;

    constructor(data?: IContactFormPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasFileAttached = _data["hasFileAttached"];
            this.emailSubject = _data["emailSubject"];
            this.fileUniqueId = _data["fileUniqueId"];
            this.fileVersionNumber = _data["fileVersionNumber"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ContactFormPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactFormPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasFileAttached"] = this.hasFileAttached;
        data["emailSubject"] = this.emailSubject;
        data["fileUniqueId"] = this.fileUniqueId;
        data["fileVersionNumber"] = this.fileVersionNumber;
        data["message"] = this.message;
        return data;
    }
}

export interface IContactFormPostModel {
    hasFileAttached?: boolean;
    emailSubject: string;
    fileUniqueId?: string;
    fileVersionNumber?: number;
    message: string;
}

export class FileTagPostModel implements IFileTagPostModel {
    tagId?: number | undefined;
    tagName?: string;
    fileId?: number;

    constructor(data?: IFileTagPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagId = _data["tagId"];
            this.tagName = _data["tagName"];
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): FileTagPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileTagPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        data["tagName"] = this.tagName;
        data["fileId"] = this.fileId;
        return data;
    }
}

export interface IFileTagPostModel {
    tagId?: number | undefined;
    tagName?: string;
    fileId?: number;
}

export class DirectoryTagPostModel implements IDirectoryTagPostModel {
    tagId?: number | undefined;
    tagName?: string;
    directoryId?: number;

    constructor(data?: IDirectoryTagPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagId = _data["tagId"];
            this.tagName = _data["tagName"];
            this.directoryId = _data["directoryId"];
        }
    }

    static fromJS(data: any): DirectoryTagPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new DirectoryTagPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        data["tagName"] = this.tagName;
        data["directoryId"] = this.directoryId;
        return data;
    }
}

export interface IDirectoryTagPostModel {
    tagId?: number | undefined;
    tagName?: string;
    directoryId?: number;
}

export class TourStatusResponseModel implements ITourStatusResponseModel {
    hasSeenTour?: boolean;

    constructor(data?: ITourStatusResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasSeenTour = _data["hasSeenTour"];
        }
    }

    static fromJS(data: any): TourStatusResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TourStatusResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasSeenTour"] = this.hasSeenTour;
        return data;
    }
}

export interface ITourStatusResponseModel {
    hasSeenTour?: boolean;
}

export class ReadyToOrderResponseModel implements IReadyToOrderResponseModel {
    isReadyToOrder?: boolean;

    constructor(data?: IReadyToOrderResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isReadyToOrder = _data["isReadyToOrder"];
        }
    }

    static fromJS(data: any): ReadyToOrderResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReadyToOrderResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isReadyToOrder"] = this.isReadyToOrder;
        return data;
    }
}

export interface IReadyToOrderResponseModel {
    isReadyToOrder?: boolean;
}

export class UserBusinessResponseModel implements IUserBusinessResponseModel {
    userId?: string;
    email?: string | undefined;
    emailType?: EmailType | undefined;
    isMailConfirmed?: boolean;
    motherTicketId?: number | undefined;
    readyToOrder?: boolean;

    constructor(data?: IUserBusinessResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.emailType = _data["emailType"];
            this.isMailConfirmed = _data["isMailConfirmed"];
            this.motherTicketId = _data["motherTicketId"];
            this.readyToOrder = _data["readyToOrder"];
        }
    }

    static fromJS(data: any): UserBusinessResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserBusinessResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["emailType"] = this.emailType;
        data["isMailConfirmed"] = this.isMailConfirmed;
        data["motherTicketId"] = this.motherTicketId;
        data["readyToOrder"] = this.readyToOrder;
        return data;
    }
}

export interface IUserBusinessResponseModel {
    userId?: string;
    email?: string | undefined;
    emailType?: EmailType | undefined;
    isMailConfirmed?: boolean;
    motherTicketId?: number | undefined;
    readyToOrder?: boolean;
}

export enum EmailType {
    Consumer = 0,
    Business = 1,
}

export class IsUserExamplesAdminResponseModel implements IIsUserExamplesAdminResponseModel {
    isUserExamplesAdmin?: boolean;

    constructor(data?: IIsUserExamplesAdminResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isUserExamplesAdmin = _data["isUserExamplesAdmin"];
        }
    }

    static fromJS(data: any): IsUserExamplesAdminResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new IsUserExamplesAdminResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isUserExamplesAdmin"] = this.isUserExamplesAdmin;
        return data;
    }
}

export interface IIsUserExamplesAdminResponseModel {
    isUserExamplesAdmin?: boolean;
}

export class IsDwsimProUserResponseModel implements IIsDwsimProUserResponseModel {
    isDwsimProUser?: boolean;

    constructor(data?: IIsDwsimProUserResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDwsimProUser = _data["isDwsimProUser"];
        }
    }

    static fromJS(data: any): IsDwsimProUserResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new IsDwsimProUserResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDwsimProUser"] = this.isDwsimProUser;
        return data;
    }
}

export interface IIsDwsimProUserResponseModel {
    isDwsimProUser?: boolean;
}

export class UserEmailCategoryResponseModel implements IUserEmailCategoryResponseModel {
    domainCategory?: GeminiDomainCategory | undefined;

    constructor(data?: IUserEmailCategoryResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domainCategory = _data["domainCategory"];
        }
    }

    static fromJS(data: any): UserEmailCategoryResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserEmailCategoryResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domainCategory"] = this.domainCategory;
        return data;
    }
}

export interface IUserEmailCategoryResponseModel {
    domainCategory?: GeminiDomainCategory | undefined;
}

export enum GeminiDomainCategory {
    Company = 0,
    University = 1,
    Other = 2,
}

export class UserEmailCategoryPostModel implements IUserEmailCategoryPostModel {
    email!: string;

    constructor(data?: IUserEmailCategoryPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UserEmailCategoryPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserEmailCategoryPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IUserEmailCategoryPostModel {
    email: string;
}

export class CreateUserResponseModel implements ICreateUserResponseModel {
    userPrincipalName?: string;

    constructor(data?: ICreateUserResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userPrincipalName = _data["userPrincipalName"];
        }
    }

    static fromJS(data: any): CreateUserResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userPrincipalName"] = this.userPrincipalName;
        return data;
    }
}

export interface ICreateUserResponseModel {
    userPrincipalName?: string;
}

export class CreateUserPostModel implements ICreateUserPostModel {
    firstName!: string;
    lastName!: string;
    email!: string;
    businessPhone?: string | undefined;
    password!: string;
    isDwsimRefferer?: boolean;

    constructor(data?: ICreateUserPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.businessPhone = _data["businessPhone"];
            this.password = _data["password"];
            this.isDwsimRefferer = _data["isDwsimRefferer"];
        }
    }

    static fromJS(data: any): CreateUserPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["businessPhone"] = this.businessPhone;
        data["password"] = this.password;
        data["isDwsimRefferer"] = this.isDwsimRefferer;
        return data;
    }
}

export interface ICreateUserPostModel {
    firstName: string;
    lastName: string;
    email: string;
    businessPhone?: string | undefined;
    password: string;
    isDwsimRefferer?: boolean;
}

export class RegistrationConfirmationPostModel implements IRegistrationConfirmationPostModel {
    email?: string;

    constructor(data?: IRegistrationConfirmationPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): RegistrationConfirmationPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationConfirmationPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IRegistrationConfirmationPostModel {
    email?: string;
}

export class ConfirmUserRegistrationResultModel implements IConfirmUserRegistrationResultModel {
    username?: string;
    userPrincipalName?: string;

    constructor(data?: IConfirmUserRegistrationResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.userPrincipalName = _data["userPrincipalName"];
        }
    }

    static fromJS(data: any): ConfirmUserRegistrationResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmUserRegistrationResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["userPrincipalName"] = this.userPrincipalName;
        return data;
    }
}

export interface IConfirmUserRegistrationResultModel {
    username?: string;
    userPrincipalName?: string;
}

export class UserPrincipalToRealEmailPostModel implements IUserPrincipalToRealEmailPostModel {
    userPrincipalName!: string;

    constructor(data?: IUserPrincipalToRealEmailPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userPrincipalName = _data["userPrincipalName"];
        }
    }

    static fromJS(data: any): UserPrincipalToRealEmailPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserPrincipalToRealEmailPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userPrincipalName"] = this.userPrincipalName;
        return data;
    }
}

export interface IUserPrincipalToRealEmailPostModel {
    userPrincipalName: string;
}

export enum PricingDialogType {
    Hourly = 0,
    Team = 1,
    Unlimited = 2,
    Support = 3,
    FlowsheetCollaboration = 4,
    FlowsheetCopilot = 5,
}

export class GetPriceResponseModel implements IGetPriceResponseModel {
    yourPrice?: number;
    pricePerHour?: number;
    yourDiscount?: number;
    isRateLimited?: boolean;

    constructor(data?: IGetPriceResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.yourPrice = _data["yourPrice"];
            this.pricePerHour = _data["pricePerHour"];
            this.yourDiscount = _data["yourDiscount"];
            this.isRateLimited = _data["isRateLimited"];
        }
    }

    static fromJS(data: any): GetPriceResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPriceResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["yourPrice"] = this.yourPrice;
        data["pricePerHour"] = this.pricePerHour;
        data["yourDiscount"] = this.yourDiscount;
        data["isRateLimited"] = this.isRateLimited;
        return data;
    }
}

export interface IGetPriceResponseModel {
    yourPrice?: number;
    pricePerHour?: number;
    yourDiscount?: number;
    isRateLimited?: boolean;
}

export class BuyNowResponseModel implements IBuyNowResponseModel {
    url?: string;

    constructor(data?: IBuyNowResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): BuyNowResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BuyNowResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IBuyNowResponseModel {
    url?: string;
}

export class BuyNowPostModel implements IBuyNowPostModel {
    hours?: number;
    engineers?: number;
    months?: number;

    constructor(data?: IBuyNowPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hours = _data["hours"];
            this.engineers = _data["engineers"];
            this.months = _data["months"];
        }
    }

    static fromJS(data: any): BuyNowPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new BuyNowPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hours"] = this.hours;
        data["engineers"] = this.engineers;
        data["months"] = this.months;
        return data;
    }
}

export interface IBuyNowPostModel {
    hours?: number;
    engineers?: number;
    months?: number;
}

export class BillingPortalUrlResponseModel implements IBillingPortalUrlResponseModel {
    url?: string;

    constructor(data?: IBillingPortalUrlResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): BillingPortalUrlResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BillingPortalUrlResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IBillingPortalUrlResponseModel {
    url?: string;
}

export class CustomerSessionResponseModel implements ICustomerSessionResponseModel {
    clientSecret?: string;

    constructor(data?: ICustomerSessionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientSecret = _data["clientSecret"];
        }
    }

    static fromJS(data: any): CustomerSessionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSessionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientSecret"] = this.clientSecret;
        return data;
    }
}

export interface ICustomerSessionResponseModel {
    clientSecret?: string;
}

export class ChangePlanResponseModel implements IChangePlanResponseModel {
    url?: string;

    constructor(data?: IChangePlanResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): ChangePlanResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePlanResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IChangePlanResponseModel {
    url?: string;
}

export class ChangePlanPostModel implements IChangePlanPostModel {
    priceId!: string;

    constructor(data?: IChangePlanPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priceId = _data["priceId"];
        }
    }

    static fromJS(data: any): ChangePlanPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePlanPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priceId"] = this.priceId;
        return data;
    }
}

export interface IChangePlanPostModel {
    priceId: string;
}

export class BillingInstanceSummary implements IBillingInstanceSummary {
    validFromUtc?: Date;
    validToUtc?: Date;
    allowedDuration?: string | undefined;
    usedDuration?: string | undefined;
    firstSessionStartedAt?: Date;
    lastSessionEndedAt?: Date | undefined;
    sessions?: SessionResponseModel[];

    constructor(data?: IBillingInstanceSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validFromUtc = _data["validFromUtc"] ? new Date(_data["validFromUtc"].toString()) : undefined as any;
            this.validToUtc = _data["validToUtc"] ? new Date(_data["validToUtc"].toString()) : undefined as any;
            this.allowedDuration = _data["allowedDuration"];
            this.usedDuration = _data["usedDuration"];
            this.firstSessionStartedAt = _data["firstSessionStartedAt"] ? new Date(_data["firstSessionStartedAt"].toString()) : undefined as any;
            this.lastSessionEndedAt = _data["lastSessionEndedAt"] ? new Date(_data["lastSessionEndedAt"].toString()) : undefined as any;
            if (Array.isArray(_data["sessions"])) {
                this.sessions = [] as any;
                for (let item of _data["sessions"])
                    this.sessions!.push(SessionResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BillingInstanceSummary {
        data = typeof data === 'object' ? data : {};
        let result = new BillingInstanceSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validFromUtc"] = this.validFromUtc ? this.validFromUtc.toISOString() : undefined as any;
        data["validToUtc"] = this.validToUtc ? this.validToUtc.toISOString() : undefined as any;
        data["allowedDuration"] = this.allowedDuration;
        data["usedDuration"] = this.usedDuration;
        data["firstSessionStartedAt"] = this.firstSessionStartedAt ? this.firstSessionStartedAt.toISOString() : undefined as any;
        data["lastSessionEndedAt"] = this.lastSessionEndedAt ? this.lastSessionEndedAt.toISOString() : undefined as any;
        if (Array.isArray(this.sessions)) {
            data["sessions"] = [];
            for (let item of this.sessions)
                data["sessions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBillingInstanceSummary {
    validFromUtc?: Date;
    validToUtc?: Date;
    allowedDuration?: string | undefined;
    usedDuration?: string | undefined;
    firstSessionStartedAt?: Date;
    lastSessionEndedAt?: Date | undefined;
    sessions?: SessionResponseModel[];
}

export class SessionResponseModel implements ISessionResponseModel {
    id?: number;
    startedAtUtc?: Date;
    endedAtUtc?: Date | undefined;
    duration?: string;
    userDisplayName?: string;

    constructor(data?: ISessionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startedAtUtc = _data["startedAtUtc"] ? new Date(_data["startedAtUtc"].toString()) : undefined as any;
            this.endedAtUtc = _data["endedAtUtc"] ? new Date(_data["endedAtUtc"].toString()) : undefined as any;
            this.duration = _data["duration"];
            this.userDisplayName = _data["userDisplayName"];
        }
    }

    static fromJS(data: any): SessionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SessionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startedAtUtc"] = this.startedAtUtc ? this.startedAtUtc.toISOString() : undefined as any;
        data["endedAtUtc"] = this.endedAtUtc ? this.endedAtUtc.toISOString() : undefined as any;
        data["duration"] = this.duration;
        data["userDisplayName"] = this.userDisplayName;
        return data;
    }
}

export interface ISessionResponseModel {
    id?: number;
    startedAtUtc?: Date;
    endedAtUtc?: Date | undefined;
    duration?: string;
    userDisplayName?: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}